<template>
  <div class="ad-root">
    <nav class="ad-topbar"><div class="container d-flex align-items-center py-2">
      <a href="javascript:void(0)" @click="$router.push('/farm')" class="ad-back"><i class="mdi mdi-arrow-left"></i></a>
      <img src="/assets/images/flockr_logo.png" alt="Flockr" style="height:32px;" class="me-3" />
      <span v-if="animal.name||animal.tag_number" class="ad-title">{{ animal.name||animal.tag_number }}</span>
    </div></nav>
    <div v-if="loading" class="text-center py-5" style="padding-top:100px!important;"><div class="spinner-border text-warning"></div></div>
    <div v-else-if="!animal.id" class="text-center py-5" style="padding-top:100px!important;">
      <i class="mdi mdi-cow-off" style="font-size:64px;color:var(--fm-s,#3A3530);"></i>
      <h5 class="mt-3" style="color:var(--fm-h,#F5F0E8);">Animal Not Found</h5>
      <button class="btn btn-warning mt-2" @click="$router.push('/farm')">Back to Farm</button>
    </div>
    <div v-else class="container ad-container">
      <!-- HEADER -->
      <div class="ad-header">
        <div class="ad-photo" :style="primaryPhoto?{backgroundImage:'url('+primaryPhoto+')'}:{}" @click="photos.length?previewIndex=0:null">
          <i v-if="!primaryPhoto" class="mdi mdi-cow" style="font-size:48px;color:var(--fm-s,#2A2520);"></i>
          <div v-if="primaryPhoto" class="ad-photo-hover"><i class="mdi mdi-magnify-plus-outline"></i><span>View</span></div>
          <label class="ad-photo-change" @click.stop title="Change photo"><i class="mdi mdi-camera"></i><input type="file" accept="image/*" @change="onProfilePhotoChange" style="display:none;" /></label>
        </div>
        <div class="ad-header-info">
          <h4 style="color:var(--fm-h,#F5F0E8);margin:0;">{{ animal.name||'Unnamed' }}</h4>
          <div style="color:var(--fm-s,#6B6356);font-size:13px;">{{ animal.species_name }} <span v-if="animal.breed_name">&middot; {{ animal.breed_name }}</span> <span v-if="animal.tag_number">&middot; #{{ animal.tag_number }}</span></div>
          <div class="d-flex gap-2 mt-2 flex-wrap">
            <span class="ad-badge" :class="'bg-'+animal.health_status">{{ animal.health_status }}</span>
            <span class="ad-badge" :class="'bg-'+animal.status">{{ (animal.status||'').replace(/_/g,' ') }}</span>
            <span v-if="animal.sex&&animal.sex!=='unknown'" class="ad-badge" :style="{background:animal.sex==='male'?'rgba(79,195,247,.12)':'rgba(244,143,177,.12)',color:animal.sex==='male'?'#4FC3F7':'#F48FB1'}"><i :class="'mdi '+(animal.sex==='male'?'mdi-gender-male':'mdi-gender-female')+' me-1'"></i>{{ animal.sex }}</span>
            <span v-if="animal.reproductive_status&&animal.reproductive_status!=='not_applicable'" class="ad-badge" style="background:rgba(206,147,216,.12);color:#CE93D8;">{{ (animal.reproductive_status||'').replace(/_/g,' ') }}</span>
          </div>
        </div>
      </div>

      <!-- QUICK STATS -->
      <div class="ad-quick-stats">
        <div class="ad-qs"><div class="ad-qs-num">{{ animal.weight_kg||'—' }}</div><div class="ad-qs-lbl">Weight (kg)</div></div>
        <div class="ad-qs"><div class="ad-qs-num">{{ animalAge }}</div><div class="ad-qs-lbl">Age</div></div>
        <div class="ad-qs" v-if="animal.daily_milk_yield_liters>0"><div class="ad-qs-num" style="color:#4FC3F7;">{{ animal.daily_milk_yield_liters }}</div><div class="ad-qs-lbl">Milk (L/day)</div></div>
        <div class="ad-qs"><div class="ad-qs-num" style="color:#BFA164;">{{ animal.acquisition_price?'KES '+fNum(animal.acquisition_price):'—' }}</div><div class="ad-qs-lbl">Acquisition</div></div>
      </div>

      <!-- PERFORMANCE CARD -->
      <div v-if="performance" class="ad-perf-card" :class="'perf-'+performance.badge">
        <div class="ad-perf-head">
          <div>
            <div class="ad-perf-title">Performance</div>
            <div class="ad-perf-sub">{{ perfCohortLabel }}</div>
          </div>
          <span class="ad-perf-badge">{{ perfBadgeLabel }}</span>
        </div>
        <div class="ad-perf-body">
          <div v-if="performance.growth_kg_per_day" class="ad-perf-bar-row">
            <div class="ad-perf-bar"><div class="ad-perf-bar-fill" :style="{width: perfBarWidth+'%'}"></div></div>
            <span class="ad-perf-score">{{ Math.round(performance.composite_score) }}</span>
          </div>
          <div class="ad-perf-reason">{{ performance.reason }}</div>
        </div>
      </div>
      <div v-else-if="!loading && animal.id" class="ad-perf-card perf-no_data">
        <div class="ad-perf-head">
          <div>
            <div class="ad-perf-title">Performance</div>
            <div class="ad-perf-sub">Log 2+ weights across 14+ days to start scoring</div>
          </div>
          <span class="ad-perf-badge">No data yet</span>
        </div>
      </div>

      <!-- QUICK ACTIONS -->
      <div class="ad-actions">
        <button class="ad-act" @click="openAddWeight"><i class="mdi mdi-scale" style="color:#50C878;"></i>Weight</button>
        <button class="ad-act" @click="openAddHealth"><i class="mdi mdi-stethoscope" style="color:#FF6B6B;"></i>Health</button>
        <button class="ad-act" @click="openAddVax"><i class="mdi mdi-needle" style="color:#4FC3F7;"></i>Vaccine</button>
        <button class="ad-act" @click="openAddBreed"><i class="mdi mdi-heart" style="color:#CE93D8;"></i>Breed</button>
        <button class="ad-act" @click="openFeedModal"><i class="mdi mdi-silverware-fork-knife" style="color:#FF9800;"></i>Feed</button>
        <button class="ad-act" @click="openAddMilk"><i class="mdi mdi-cup-water" style="color:#4FC3F7;"></i>Milk</button>
        <button class="ad-act" @click="openEditAnimal"><i class="mdi mdi-pencil" style="color:#BFA164;"></i>Edit</button>
        <button class="ad-act" v-if="animal.status==='active'" @click="$router.push({path:'/sell/create',query:{animalId:animal.id}})"><i class="mdi mdi-tag" style="color:#BFA164;"></i>Publish</button>
        <button class="ad-act" v-if="animal.status==='listed_for_sale'" @click="unlistAnimal" :disabled="processing"><i class="mdi mdi-tag-off" style="color:#FF6B6B;"></i>Unlist</button>
        <button class="ad-act" @click="showReportOptions=true"><i class="mdi mdi-file-pdf-box" style="color:#FF6B6B;"></i>Report</button>
        <button class="ad-act" @click="tab='actions';loadPendingActions()"><i class="mdi mdi-gesture-tap-button" style="color:#4FC3F7;"></i>Actions</button>
        <button class="ad-act" @click="openAiVet()"><i class="mdi mdi-robot" style="color:#CE93D8;"></i>AI Vet</button>
      </div>

      <!-- TABS -->
      <div class="ad-tabs">
        <button class="ad-tab" :class="{active:tab==='info'}" @click="tab='info'">Info</button>
        <button class="ad-tab" :class="{active:tab==='health'}" @click="tab='health'">Health ({{ healthRecords.length }})</button>
        <button class="ad-tab" :class="{active:tab==='vaccinations'}" @click="tab='vaccinations'">Vaccines ({{ vaccinations.length }})</button>
        <button class="ad-tab" :class="{active:tab==='weight'}" @click="tab='weight'">Weight ({{ weightHistory.length }})</button>
        <button class="ad-tab" :class="{active:tab==='breeding'}" @click="tab='breeding'">Breeding ({{ breedingRecords.length }})</button>
        <button class="ad-tab" :class="{active:tab==='feeding'}" @click="tab='feeding';loadFeedingLogs();loadFeedingSchedules()">Feeding ({{ feedingLogs.length }})</button>
        <button class="ad-tab" :class="{active:tab==='milk'}" @click="tab='milk';loadMilkRecords()">Milk ({{ milkRecords.length }})</button>
        <button class="ad-tab" :class="{active:tab==='photos'}" @click="tab='photos'">Photos ({{ photos.length }})</button>
        <button class="ad-tab" :class="{active:tab==='actions'}" @click="tab='actions';loadPendingActions()">Actions<span v-if="pendingActions.length" style="color:#FFAB00;"> ({{ pendingActions.length }})</span></button>
        <button class="ad-tab" :class="{active:tab==='history'}" @click="tab='history';loadAuditTrail()">History</button>
      </div>

      <!-- INFO TAB -->
      <div v-if="tab==='info'" class="ad-card">
        <div class="ad-row"><span>Farm</span><span>{{ animal.farm_name }}</span></div>
        <div class="ad-row"><span>Species</span><span>{{ animal.species_name }}</span></div>
        <div class="ad-row"><span>Breed</span><span>{{ animal.breed_name||'—' }}</span></div>
        <div class="ad-row"><span>Sex</span><span class="text-capitalize">{{ animal.sex }}</span></div>
        <div class="ad-row"><span>Age</span><span>{{ animalAge }}</span></div>
        <div class="ad-row"><span>Color/Markings</span><span>{{ animal.color_markings||'—' }}</span></div>
        <div class="ad-row"><span>Source</span><span class="text-capitalize">{{ (animal.acquisition_type||'').replace(/_/g,' ') }}</span></div>
        <div class="ad-row"><span>Acquired</span><span>{{ animal.acquisition_date?fDate(animal.acquisition_date):'—' }}</span></div>
        <div class="ad-row"><span>Purchase Price</span><span style="color:#BFA164;font-weight:700;">{{ animal.acquisition_price?'KES '+fNum(animal.acquisition_price):'—' }}</span></div>
        <div class="ad-row"><span>Vet/Health Costs</span><span style="color:#FF6B6B;">KES {{ fNum(totalHealthCost) }}</span></div>
        <div class="ad-row"><span>Vaccination Costs</span><span style="color:#4FC3F7;">KES {{ fNum(totalVaxCost) }}</span></div>
        <div class="ad-row"><span>Breeding Costs</span><span style="color:#CE93D8;">KES {{ fNum(totalBreedCost) }}</span></div>
        <div class="ad-row"><span>Feeding Costs</span><span style="color:#FF9800;">KES {{ fNum(totalFeedCost) }}</span></div>
        <div class="ad-row" style="border-top:1px solid var(--fm-br);padding-top:6px;margin-top:4px;"><span style="font-weight:700;">Total Investment</span><span style="color:#BFA164;font-weight:700;">KES {{ fNum(totalInvestment) }}</span></div>
        <div v-if="animal.pedigree_number" class="ad-row"><span>Pedigree #</span><span>{{ animal.pedigree_number }}</span></div>
        <div v-if="animal.microchip_number" class="ad-row"><span>Microchip</span><span>{{ animal.microchip_number }}</span></div>
        <div class="ad-row"><span><i class="mdi mdi-nfc-tap me-1" style="color:#4FC3F7;"></i>NFC Tag</span>
          <span v-if="animal.nfc_tag_serial" class="d-flex align-items-center gap-2">
          <span style="color:#4FC3F7;font-family:monospace;font-size:11px;">{{ animal.nfc_tag_serial.substring(0,20) }}</span>
          <button class="btn btn-sm btn-outline-danger" style="font-size:9px;padding:1px 6px;" @click="removeNfcTag"><i class="mdi mdi-close"></i></button>
        </span>
          <span v-else class="d-flex align-items-center gap-2">
          <button v-if="nfcSupported" class="btn btn-sm btn-outline-info" style="font-size:10px;padding:2px 10px;" @click="startNfcAssign"><i class="mdi mdi-nfc-tap me-1"></i>Scan Tag</button>
          <span v-if="!nfcSupported" style="color:#FF9800;font-size:10px;cursor:help;" title="NFC scanning requires Chrome on Android with NFC hardware"><i class="mdi mdi-nfc-off me-1"></i>NFC not available</span>
          <button class="btn btn-sm btn-outline-secondary" style="font-size:10px;padding:2px 10px;" @click="showManualNfc=!showManualNfc"><i class="mdi mdi-keyboard me-1"></i>Enter Manually</button>
        </span>
        </div>

        <!-- Manual NFC Serial Entry -->
        <div v-if="showManualNfc && !animal.nfc_tag_serial" style="background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:8px;padding:12px;margin-top:6px;">
          <div style="color:var(--fm-s,#6B6356);font-size:11px;margin-bottom:6px;">Enter the NFC tag serial number (printed on tag or from packaging)</div>
          <div class="d-flex gap-2">
            <input v-model="manualNfcSerial" class="ad-input flex-fill" placeholder="e.g. 04:A2:3B:C1:D5:E6:70" style="font-family:monospace;font-size:12px;" />
            <button class="btn btn-sm btn-info" @click="assignNfcTag(manualNfcSerial)" :disabled="!manualNfcSerial||processing"><i class="mdi mdi-check me-1"></i>Assign</button>
          </div>
        </div>

        <!-- NFC Assign Overlay -->
        <div v-if="showNfcAssign" style="background:var(--fm-bg3,#0F200F);border:1px solid #1b5e20;border-radius:10px;padding:16px;margin-top:8px;text-align:center;">
          <div v-if="nfcAssigning">
            <div class="spinner-border spinner-border-sm text-info" style="width:20px;height:20px;"></div>
            <div style="color:#4FC3F7;font-size:14px;font-weight:600;margin-top:8px;">Hold phone near NFC tag...</div>
            <div style="color:var(--fm-s,#6B6356);font-size:11px;">This tag will be linked to {{ animal.name || animal.tag_number || 'this animal' }}</div>
          </div>
          <div v-else-if="nfcAssignStatus">
            <div :style="{color:nfcAssignStatus.includes('success')||nfcAssignStatus.includes('assigned')?'#50C878':'#FF6B6B',fontSize:'13px',fontWeight:600}">{{ nfcAssignStatus }}</div>
          </div>
          <div class="d-flex justify-content-center gap-2 mt-2">
            <button v-if="!nfcAssigning" class="btn btn-sm btn-info" @click="startNfcAssign"><i class="mdi mdi-refresh me-1"></i>Retry</button>
            <button class="btn btn-sm btn-outline-secondary" @click="stopNfcAssign">{{ nfcAssigning ? 'Cancel' : 'Close' }}</button>
          </div>
        </div>
        <div v-if="animal.notes" class="mt-3"><div style="color:var(--fm-s,#6B6356);font-size:11px;font-weight:600;margin-bottom:4px;">NOTES</div><div style="color:var(--fm-m,#A09888);font-size:13px;">{{ animal.notes }}</div></div>
      </div>

      <!-- HEALTH TAB -->
      <div v-if="tab==='health'">
        <div v-for="h in healthRecords" :key="h.id" class="ad-card mb-2">
          <div class="d-flex justify-content-between align-items-start">
            <strong style="color:var(--fm-h,#F5F0E8);font-size:13px;">{{ h.title }}</strong>
            <div class="d-flex align-items-center gap-1">
              <span class="ad-badge" :class="h.severity==='critical'?'bg-sick':h.severity==='moderate'?'bg-quarantine':'bg-healthy'">{{ h.severity||h.record_type }}</span>
              <button class="ad-weight-action" @click="openEditHealth(h)" title="Edit"><i class="mdi mdi-pencil-outline"></i></button>
              <button class="ad-weight-action ad-weight-action-danger" @click="openDeleteHealth(h)" :disabled="processing" title="Delete"><i class="mdi mdi-trash-can-outline"></i></button>
            </div>
          </div>
          <div v-if="h.diagnosis" style="color:var(--fm-m,#A09888);font-size:12px;margin-top:4px;">Diagnosis: {{ h.diagnosis }}</div>
          <div v-if="h.treatment" style="color:var(--fm-m,#A09888);font-size:12px;">Treatment: {{ h.treatment }}</div>
          <div v-if="h.cost" style="color:#FF6B6B;font-size:12px;">Cost: KES {{ fNum(h.cost) }}</div>
          <div style="color:var(--fm-s,#6B6356);font-size:11px;margin-top:4px;">{{ fDate(h.record_date) }}</div>
        </div>
        <div v-if="healthRecords.length===0" class="ad-empty">No health records</div>
      </div>

      <!-- VACCINATIONS TAB -->
      <div v-if="tab==='vaccinations'">
        <div v-for="v in vaccinations" :key="v.id" class="ad-card mb-2">
          <div class="d-flex justify-content-between align-items-start">
            <strong style="color:var(--fm-h,#F5F0E8);font-size:13px;">{{ v.vaccine_name }}</strong>
            <div class="d-flex align-items-center gap-1">
              <span style="color:#4FC3F7;font-size:11px;">{{ v.disease_target }}</span>
              <button class="ad-weight-action" @click="openEditVax(v)" title="Edit"><i class="mdi mdi-pencil-outline"></i></button>
              <button class="ad-weight-action ad-weight-action-danger" @click="openDeleteVax(v)" :disabled="processing" title="Delete"><i class="mdi mdi-trash-can-outline"></i></button>
            </div>
          </div>
          <div style="color:var(--fm-m,#A09888);font-size:12px;">Dosage: {{ v.dosage||'—' }} &middot; Route: {{ v.administration_route }}</div>
          <div v-if="v.cost" style="color:#FF6B6B;font-size:12px;">Cost: KES {{ fNum(v.cost) }}</div>
          <div class="d-flex justify-content-between mt-1"><span style="color:var(--fm-s,#6B6356);font-size:11px;">Given: {{ fDate(v.administered_date) }}</span><span v-if="v.next_due_date" :style="{color:isDueSoon(v.next_due_date)?'#FF6B6B':'#50C878',fontSize:'11px'}">Next: {{ fDate(v.next_due_date) }}</span></div>
        </div>
        <div v-if="vaccinations.length===0" class="ad-empty">No vaccinations recorded</div>
      </div>

      <!-- WEIGHT TAB -->
      <div v-if="tab==='weight'">
        <!-- VERDICT CARD: Hold / Sell now / Past peak -->
        <div v-if="profitVerdict" class="ad-verdict-card" :class="'verdict-'+profitVerdict.action">
          <div class="ad-verdict-icon">
            <i v-if="profitVerdict.action==='hold'" class="mdi mdi-trending-up"></i>
            <i v-else-if="profitVerdict.action==='sell_soon'" class="mdi mdi-clock-alert-outline"></i>
            <i v-else-if="profitVerdict.action==='sell_now'" class="mdi mdi-cash-multiple"></i>
            <i v-else class="mdi mdi-information-outline"></i>
          </div>
          <div class="ad-verdict-body">
            <div class="ad-verdict-headline">{{ profitVerdict.headline }}</div>
            <div class="ad-verdict-detail">{{ profitVerdict.detail }}</div>
          </div>
        </div>

        <div v-if="economics && (econSeries && econSeries.length)" class="ad-card mb-3 ad-econ-chart-card">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <h6 class="ad-card-title m-0">Growth &amp; Profitability</h6>
            <div class="ad-econ-legend">
              <span class="ad-econ-leg"><span class="ad-econ-swatch" style="background:#BFA164;"></span>Weight</span>
              <span class="ad-econ-leg"><span class="ad-econ-swatch" style="background:#FF6B6B;"></span>Invested</span>
              <span class="ad-econ-leg"><span class="ad-econ-swatch" style="background:#4FC3F7;"></span>Asset value</span>
              <span v-if="hasProfit" class="ad-econ-leg"><span class="ad-econ-swatch" style="background:#50C878;"></span>Profit</span>
            </div>
          </div>
          <div class="ad-econ-chart" @mousemove="onChartMove($event)" @mouseleave="hoverIdx=null" @touchmove.prevent="onChartTouch($event)">
            <svg :viewBox="'0 0 '+econChartW+' '+econChartH" style="width:100%;height:280px;display:block;">
              <!-- gridlines -->
              <line v-for="(g,gi) in econGridY" :key="'gy-'+gi" :x1="econPadL" :x2="econChartW-econPadR" :y1="g.y" :y2="g.y" class="ad-econ-grid" stroke-width="1" />
              <!-- zero line for profit -->
              <line v-if="hasProfit" :x1="econPadL" :x2="econChartW-econPadR" :y1="econZeroY" :y2="econZeroY" stroke="rgba(80,200,120,.25)" stroke-dasharray="2,3" stroke-width="1" />
              <!-- today divider -->
              <line :x1="econTodayX" :x2="econTodayX" :y1="econPadT" :y2="econChartH-econPadB" class="ad-econ-divider" stroke-dasharray="3,4" stroke-width="1" />
              <text v-if="econTodayX > econPadL+60 && econTodayX < econChartW-econPadR-60" :x="econTodayX" :y="econPadT-4" text-anchor="middle" class="ad-econ-ax" style="font-size:9px;">Today</text>
              <!-- Weight (past solid, future dashed) -->
              <polyline :points="econPath('w', false)" fill="none" stroke="#BFA164" stroke-width="2" stroke-linejoin="round" />
              <polyline :points="econPath('w', true)" fill="none" stroke="#BFA164" stroke-width="2" stroke-dasharray="4,4" stroke-linejoin="round" />
              <!-- Invested -->
              <polyline :points="econPath('i', false)" fill="none" stroke="#FF6B6B" stroke-width="2" stroke-linejoin="round" />
              <polyline :points="econPath('i', true)" fill="none" stroke="#FF6B6B" stroke-width="2" stroke-dasharray="4,4" stroke-linejoin="round" />
              <!-- Asset value -->
              <polyline :points="econPath('a', false)" fill="none" stroke="#4FC3F7" stroke-width="2" stroke-linejoin="round" />
              <polyline :points="econPath('a', true)" fill="none" stroke="#4FC3F7" stroke-width="2" stroke-dasharray="4,4" stroke-linejoin="round" />
              <!-- Profit -->
              <polyline v-if="hasProfit" :points="econPath('p', false)" fill="none" stroke="#50C878" stroke-width="2.5" stroke-linejoin="round" />
              <polyline v-if="hasProfit" :points="econPath('p', true)" fill="none" stroke="#50C878" stroke-width="2.5" stroke-dasharray="4,4" stroke-linejoin="round" />
              <!-- Peak profit marker -->
              <g v-if="peakIdx !== null && hasProfit">
                <line :x1="econXAt(peakIdx)" :x2="econXAt(peakIdx)" :y1="econPadT" :y2="econChartH-econPadB" stroke="#50C878" stroke-dasharray="2,3" stroke-width="1" opacity="0.55" />
                <circle :cx="econXAt(peakIdx)" :cy="econYProfit(econSeries[peakIdx].profit)" r="6" fill="#50C878" stroke="#0A0A0A" stroke-width="2" />
                <text :x="econXAt(peakIdx)" :y="econYProfit(econSeries[peakIdx].profit)-12" text-anchor="middle" fill="#50C878" style="font-size:10px;font-weight:700;">★ Peak</text>
              </g>
              <!-- Hover crosshair + dots -->
              <g v-if="hoverIdx !== null && econSeries[hoverIdx]">
                <line :x1="econXAt(hoverIdx)" :x2="econXAt(hoverIdx)" :y1="econPadT" :y2="econChartH-econPadB" class="ad-econ-cross" stroke-width="1" />
                <circle :cx="econXAt(hoverIdx)" :cy="econYWeight(econSeries[hoverIdx].weight)" r="3.5" fill="#BFA164" stroke="#0A0A0A" stroke-width="1.5" />
                <circle :cx="econXAt(hoverIdx)" :cy="econYKsh(econSeries[hoverIdx].invested)" r="3.5" fill="#FF6B6B" stroke="#0A0A0A" stroke-width="1.5" />
                <circle :cx="econXAt(hoverIdx)" :cy="econYKsh(econSeries[hoverIdx].asset)" r="3.5" fill="#4FC3F7" stroke="#0A0A0A" stroke-width="1.5" />
                <circle v-if="hasProfit" :cx="econXAt(hoverIdx)" :cy="econYProfit(econSeries[hoverIdx].profit)" r="3.5" fill="#50C878" stroke="#0A0A0A" stroke-width="1.5" />
              </g>
              <!-- Y axis labels (left = weight kg) -->
              <text v-for="(g,gi) in econGridY" :key="'lwl-'+gi" :x="econPadL-4" :y="g.y+3" text-anchor="end" fill="rgba(191,161,100,.7)" style="font-size:9px;">{{ g.weightLabel }}</text>
              <!-- Y axis labels (right = Ksh) -->
              <text v-for="(g,gi) in econGridY" :key="'lwr-'+gi" :x="econChartW-econPadR+4" :y="g.y+3" text-anchor="start" fill="rgba(79,195,247,.7)" style="font-size:9px;">{{ g.kshLabel }}</text>
              <!-- X axis date labels (start, today, end) -->
              <text :x="econPadL" :y="econChartH-econPadB+12" text-anchor="start" class="ad-econ-ax" style="font-size:9px;">{{ econXDateLabel(0) }}</text>
              <text v-if="econTodayX > econPadL+55 && econTodayX < econChartW-econPadR-55" :x="econTodayX" :y="econChartH-econPadB+12" text-anchor="middle" class="ad-econ-ax" style="font-size:9px;">{{ econXDateLabel(econTodayIdx) }}</text>
              <text :x="econChartW-econPadR" :y="econChartH-econPadB+12" text-anchor="end" class="ad-econ-ax" style="font-size:9px;">{{ econXDateLabel(econSeries.length-1) }}</text>
              <!-- Axis titles -->
              <text :x="econPadL-4" :y="econPadT-6" text-anchor="start" fill="rgba(191,161,100,.85)" style="font-size:9px;font-weight:700;">Weight (kg)</text>
              <text :x="econChartW-econPadR+4" :y="econPadT-6" text-anchor="end" fill="rgba(79,195,247,.85)" style="font-size:9px;font-weight:700;">Value (Ksh)</text>
              <text :x="(econPadL+econChartW-econPadR)/2" :y="econChartH-4" text-anchor="middle" class="ad-econ-ax" style="font-size:9px;font-weight:700;">Date</text>
            </svg>
            <!-- Hover tooltip -->
            <div v-if="hoverIdx !== null && econSeries[hoverIdx]" class="ad-econ-tip" :style="econTipStyle">
              <div class="ad-econ-tip-date">{{ econXDateLabel(hoverIdx) }}<span v-if="hoverIdx > econTodayIdx" style="color:#FF9800;margin-left:6px;font-size:10px;">PROJECTED</span></div>
              <div class="ad-econ-tip-row"><span style="color:#BFA164;">Weight</span><strong>{{ Number(econSeries[hoverIdx].weight).toFixed(1) }} kg</strong></div>
              <div class="ad-econ-tip-row"><span style="color:#FF6B6B;">Invested</span><strong>Ksh {{ econFmt(econSeries[hoverIdx].invested) }}</strong></div>
              <div class="ad-econ-tip-row"><span style="color:#4FC3F7;">Asset value</span><strong>Ksh {{ econFmt(econSeries[hoverIdx].asset) }}</strong></div>
              <div v-if="hasProfit" class="ad-econ-tip-row"><span style="color:#50C878;">Profit</span><strong :style="{color: econSeries[hoverIdx].profit >= 0 ? '#50C878' : '#FF6B6B'}">{{ econSeries[hoverIdx].profit >= 0 ? '+' : '' }}Ksh {{ econFmt(econSeries[hoverIdx].profit) }}</strong></div>
            </div>
          </div>
          <div v-if="!hasProfit && economics" class="ad-econ-footnote">
            <i class="mdi mdi-information-outline me-1"></i>Set this animal's acquisition price (Edit → Acquisition) to see the profit line and sell-point recommendation.
          </div>
          <div v-else-if="economics" class="ad-econ-footnote">
            <i class="mdi mdi-information-outline me-1"></i>Asset value = weight × {{ economics.sale_target_kshs_per_kg }} Ksh/kg. Projection uses {{ Number(economics.actual_kg_per_day || economics.target_kg_per_day || 1).toFixed(2) }} kg/day &amp; {{ economics.daily_feed_cost_kshs }} Ksh/day feed ({{ economics.formulation_name || 'default formulation' }}).
          </div>
        </div>
        <div v-for="w in weightHistory" :key="w.id" class="ad-weight-row">
          <strong style="color:var(--fm-h,#F5F0E8);">{{ w.weight_kg }}kg</strong>
          <span style="color:var(--fm-s,#6B6356);font-size:11px;flex:1;text-align:right;margin-right:10px;">{{ fDate(w.recorded_at) }} &middot; {{ weightMethodLabel(w.measurement_method) }}</span>
          <button class="ad-weight-action" @click="openEditWeight(w)" title="Edit weight"><i class="mdi mdi-pencil-outline"></i></button>
          <button class="ad-weight-action ad-weight-action-danger" @click="openDeleteWeight(w)" :disabled="processing" title="Delete weight"><i class="mdi mdi-trash-can-outline"></i></button>
        </div>
        <div v-if="weightHistory.length===0" class="ad-empty">No weight records</div>
      </div>

      <!-- BREEDING TAB -->
      <div v-if="tab==='breeding'">
        <div v-for="b in breedingRecords" :key="b.id" class="ad-card mb-2">
          <div class="d-flex justify-content-between align-items-start">
            <strong style="color:var(--fm-h,#F5F0E8);font-size:13px;">{{ b.breeding_method==='artificial_insemination'?'AI':'Natural' }} Mating</strong>
            <div class="d-flex align-items-center gap-1">
              <span class="ad-badge" :class="b.outcome==='successful_birth'?'bg-healthy':(b.outcome==='pregnant'?'bg-healthy':(b.outcome==='failed'?'bg-sick':'bg-quarantine'))">{{ b.outcome||'pending' }}</span>
              <button class="ad-weight-action" @click="openEditBreed(b)" title="Edit"><i class="mdi mdi-pencil-outline"></i></button>
              <button class="ad-weight-action ad-weight-action-danger" @click="openDeleteBreed(b)" :disabled="processing" title="Delete"><i class="mdi mdi-trash-can-outline"></i></button>
            </div>
          </div>
          <div style="color:var(--fm-m,#A09888);font-size:12px;">Date: {{ fDate(b.breeding_date) }}</div>
          <div v-if="b.expected_due_date" style="color:#CE93D8;font-size:12px;">Expected due: {{ fDate(b.expected_due_date) }}</div>
          <div v-if="b.actual_birth_date" style="color:#50C878;font-size:12px;">Delivered: {{ fDate(b.actual_birth_date) }} · {{ b.offspring_count || 0 }} offspring</div>
          <div v-if="b.cost" style="color:#FF6B6B;font-size:12px;">Cost: KES {{ fNum(b.cost) }}</div>
          <!-- Record offspring — Alex 2026-07-17. Only enabled when the outcome isn't
               already recorded and the breeding isn't marked failed. -->
          <button v-if="b.outcome !== 'successful_birth' && b.outcome !== 'no_conception' && b.outcome !== 'abortion'"
                  class="btn btn-sm btn-outline-warning mt-2"
                  @click="openRecordOffspring(b)">
            <i class="mdi mdi-baby-carriage me-1"></i>Record kids / lambs
          </button>
        </div>
        <div v-if="breedingRecords.length===0" class="ad-empty">No breeding records</div>
      </div>

      <!-- Record-offspring modal — one row per kid/lamb -->
      <div v-if="showRecordOffspring" class="ad-overlay" @click.self="showRecordOffspring=false">
        <div class="ad-modal">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h6 style="color:var(--fm-h,#F5F0E8);margin:0;"><i class="mdi mdi-baby-carriage me-2" style="color:#BFA164;"></i>Record offspring</h6>
            <button class="btn-close btn-close-white" @click="showRecordOffspring=false"></button>
          </div>
          <div class="mb-3">
            <label class="ad-label">Birth date</label>
            <input v-model="offspringBirthDate" type="date" class="ad-input w-100" :max="todayStr" />
          </div>
          <div v-for="(o, oi) in offspringDraft" :key="'o-'+oi" class="ad-card mb-2" style="padding:10px;">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <strong style="color:#BFA164;font-size:12px;">Kid/Lamb #{{ oi+1 }}</strong>
              <button v-if="offspringDraft.length > 1" class="btn btn-sm btn-outline-danger" @click="offspringDraft.splice(oi,1)"><i class="mdi mdi-close"></i></button>
            </div>
            <div class="row g-2">
              <div class="col-6"><label class="ad-label">Tag #</label><input v-model="o.tag" class="ad-input w-100" placeholder="e.g. K-2026-001" /></div>
              <div class="col-6"><label class="ad-label">Sex</label>
                <select v-model="o.sex" class="ad-input w-100">
                  <option value="unknown">Unknown</option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                </select>
              </div>
              <div class="col-6"><label class="ad-label">Birth weight (kg)</label><input v-model="o.birthWeightKg" type="number" step="0.1" class="ad-input w-100" placeholder="e.g. 3.2" /></div>
              <div class="col-6"><label class="ad-label">Name (optional)</label><input v-model="o.name" class="ad-input w-100" /></div>
            </div>
          </div>
          <button class="btn btn-sm btn-outline-secondary w-100 mb-3" @click="offspringDraft.push({tag:'',sex:'unknown',birthWeightKg:'',name:''})">
            <i class="mdi mdi-plus me-1"></i>Add another
          </button>
          <button class="btn btn-warning fw-bold w-100" @click="saveOffspring" :disabled="processing">
            <span v-if="processing"><span class="spinner-border spinner-border-sm me-1"></span>Saving…</span>
            <span v-else><i class="mdi mdi-content-save me-1"></i>Save & link to dam</span>
          </button>
        </div>
      </div>

      <!-- FEEDING TAB -->
      <div v-if="tab==='feeding'">
        <!-- FEEDING SCHEDULES -->
        <div class="ad-card mb-3" style="border-left:3px solid #BFA164;">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <h6 style="color:var(--fm-h,#F5F0E8);margin:0;font-size:13px;"><i class="mdi mdi-calendar-clock me-1" style="color:#BFA164;"></i>Feeding Schedules</h6>
            <button class="btn btn-sm btn-outline-warning" @click="openAddSchedule"><i class="mdi mdi-plus me-1"></i>New</button>
          </div>
          <div v-for="s in feedingSchedules" :key="s.id" class="ad-sched-row" :class="{'ad-sched-inactive':Number(s.is_active)!==1}">
            <div class="flex-fill">
              <div style="color:var(--fm-h,#F5F0E8);font-size:13px;font-weight:600;">{{ s.formulation_name || s.feed_type }}<span v-if="Number(s.is_active)!==1" style="color:var(--fm-s,#6B6356);font-weight:400;font-size:11px;"> · paused</span></div>
              <div style="color:var(--fm-m,#A09888);font-size:11px;">{{ s.quantity_kg }}kg · {{ (s.frequency||'').replace(/_/g,' ') }}<span v-if="s.formulation_daily_cost>0"> · {{ Number(s.formulation_daily_cost).toLocaleString() }} Ksh/day</span></div>
            </div>
            <button class="ad-weight-action" @click="toggleSchedule(s)" :title="Number(s.is_active)===1?'Pause':'Resume'"><i :class="Number(s.is_active)===1?'mdi mdi-pause-circle-outline':'mdi mdi-play-circle-outline'"></i></button>
            <button class="ad-weight-action" @click="openEditSchedule(s)" title="Edit"><i class="mdi mdi-pencil-outline"></i></button>
            <button class="ad-weight-action ad-weight-action-danger" @click="openDeleteSchedule(s)" :disabled="processing" title="Delete"><i class="mdi mdi-trash-can-outline"></i></button>
          </div>
          <div v-if="feedingSchedules.length===0" style="color:var(--fm-s,#6B6356);font-size:12px;text-align:center;padding:8px;">No feeding schedules yet. Add one to plan recurring feeds.</div>
        </div>

        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 style="color:var(--fm-h,#F5F0E8);margin:0;">Feeding Log</h6>
          <button class="btn btn-sm btn-warning" @click="openFeedModal"><i class="mdi mdi-plus me-1"></i>Log Feed</button>
        </div>
        <div v-if="loadingFeed" class="text-center py-3"><div class="spinner-border spinner-border-sm text-warning"></div></div>
        <div v-else>
          <div v-for="f in feedingLogs" :key="f.id" class="ad-card mb-2">
            <div class="d-flex justify-content-between align-items-start">
              <strong style="color:var(--fm-h,#F5F0E8);font-size:13px;">{{ f.feed_type }}</strong>
              <div class="d-flex align-items-center gap-1">
                <span style="color:var(--fm-s,#6B6356);font-size:11px;">{{ fDate(f.fed_at) }}</span>
                <button class="ad-weight-action" @click="openEditFeed(f)" title="Edit"><i class="mdi mdi-pencil-outline"></i></button>
                <button class="ad-weight-action ad-weight-action-danger" @click="openDeleteFeed(f)" :disabled="processing" title="Delete"><i class="mdi mdi-trash-can-outline"></i></button>
              </div>
            </div>
            <div style="color:#FF9800;font-size:13px;font-weight:600;">{{ f.quantity_kg }} kg</div>
            <div v-if="f.cost" style="color:#FF6B6B;font-size:12px;">Cost: KES {{ fNum(f.cost) }}</div>
            <div v-if="f.notes" style="color:var(--fm-s,#6B6356);font-size:11px;margin-top:2px;">{{ f.notes }}</div>
          </div>
          <div v-if="feedingLogs.length===0" class="ad-empty">
            <i class="mdi mdi-silverware-fork-knife" style="font-size:28px;color:var(--fm-s,#2A2520);display:block;margin-bottom:6px;"></i>
            No feeding records yet
          </div>
        </div>
      </div>

      <!-- MILK TAB -->
      <div v-if="tab==='milk'">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 style="color:var(--fm-h,#F5F0E8);margin:0;">Milk Records</h6>
          <button class="btn btn-sm btn-warning" @click="openAddMilk"><i class="mdi mdi-plus me-1"></i>Record Milk</button>
        </div>
        <div v-if="milkRecords.length" class="d-flex gap-2 mb-3">
          <div class="ad-card flex-fill" style="text-align:center;"><div style="color:#4FC3F7;font-size:18px;font-weight:700;">{{ Number(milkLast7).toFixed(1) }}</div><div style="color:var(--fm-s,#6B6356);font-size:10px;text-transform:uppercase;">Last 7 days (L)</div></div>
          <div class="ad-card flex-fill" style="text-align:center;"><div style="color:#50C878;font-size:18px;font-weight:700;">{{ Number(milkTotal).toFixed(1) }}</div><div style="color:var(--fm-s,#6B6356);font-size:10px;text-transform:uppercase;">All-time (L)</div></div>
        </div>
        <div v-if="loadingMilk" class="text-center py-3"><div class="spinner-border spinner-border-sm text-warning"></div></div>
        <div v-else>
          <div v-for="m in milkRecords" :key="m.id" class="ad-card mb-2">
            <div class="d-flex justify-content-between align-items-start">
              <strong style="color:#4FC3F7;font-size:15px;">{{ m.quantity_liters }} L</strong>
              <div class="d-flex align-items-center gap-1">
                <span class="ad-badge bg-healthy" style="text-transform:capitalize;">{{ m.session }}</span>
                <button class="ad-weight-action" @click="openEditMilk(m)" title="Edit"><i class="mdi mdi-pencil-outline"></i></button>
                <button class="ad-weight-action ad-weight-action-danger" @click="openDeleteMilk(m)" :disabled="processing" title="Delete"><i class="mdi mdi-trash-can-outline"></i></button>
              </div>
            </div>
            <div style="color:var(--fm-s,#6B6356);font-size:11px;margin-top:2px;">{{ fDate(m.record_date) }}<span v-if="m.quality_grade"> · Grade {{ m.quality_grade }}</span><span v-if="m.fat_content_pct"> · {{ m.fat_content_pct }}% fat</span></div>
          </div>
          <div v-if="milkRecords.length===0" class="ad-empty">
            <i class="mdi mdi-cup-water" style="font-size:28px;color:var(--fm-s,#2A2520);display:block;margin-bottom:6px;"></i>
            No milk records yet
          </div>
        </div>
      </div>

      <!-- ACTIONS TAB (issue 86) -->
      <div v-if="tab==='actions'">
        <div class="ad-card mb-2">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h6 style="color:var(--fm-h,#F5F0E8);margin:0;"><i class="mdi mdi-gesture-tap-button me-2" style="color:#BFA164;"></i>Animal Actions</h6>
              <div style="color:var(--fm-s,#6B6356);font-size:11px;margin-top:3px;">Status changes are recorded here with full details and land in the audit trail.</div>
            </div>
            <span class="text-capitalize" style="background:var(--fm-bg3,#1E1E1E);border:1px solid var(--fm-br,#2A2520);color:#BFA164;font-size:11px;font-weight:700;padding:4px 10px;border-radius:20px;white-space:nowrap;">{{ (animal.status||'active').replace(/_/g,' ') }}</span>
          </div>
          <div v-if="amOwner===false" style="background:rgba(79,195,247,.06);border:1px solid rgba(79,195,247,.25);border-radius:8px;padding:8px 10px;margin-top:10px;color:#4FC3F7;font-size:11px;">
            <i class="mdi mdi-account-check-outline me-1"></i>You're a farm member — actions you submit are sent to the farm owner for approval before they take effect.
          </div>
        </div>

        <div v-if="loadingPending" class="text-center py-2"><div class="spinner-border spinner-border-sm text-warning"></div></div>
        <div v-for="p in pendingActions" :key="p.id" class="ad-card mb-2" style="border-color:rgba(255,171,0,.4);">
          <div class="d-flex justify-content-between align-items-start">
            <strong style="color:#FFAB00;font-size:13px;"><i class="mdi mdi-clock-alert-outline me-1"></i>{{ p.summary }}</strong>
            <span style="background:rgba(255,171,0,.12);color:#FFAB00;font-size:10px;font-weight:700;padding:2px 8px;border-radius:20px;white-space:nowrap;">PENDING APPROVAL</span>
          </div>
          <div style="color:var(--fm-s,#6B6356);font-size:11px;margin-top:4px;">
            <i class="mdi mdi-account-outline me-1"></i>Requested by {{ p.maker_name||'a farm member' }} · {{ fDateTime(p.created_at) }}
          </div>
          <div v-if="amOwner" style="color:var(--fm-m,#A09888);font-size:11px;margin-top:4px;"><i class="mdi mdi-arrow-right-thin me-1"></i>Approve or reject it from your Farm Dashboard.</div>
        </div>

        <div class="ad-actions-grid">
          <button class="ad-action-card" @click="openAction('sold')"><i class="mdi mdi-cash" style="color:#50C878;"></i><span>Mark as Sold</span><small>Record sale price, buyer and payment — syncs to farm income</small></button>
          <button class="ad-action-card" @click="openAction('deceased')"><i class="mdi mdi-heart-broken" style="color:#FF6B6B;"></i><span>Mark as Deceased</span><small>Record date and cause of death</small></button>
          <button class="ad-action-card" @click="openAction('culled')"><i class="mdi mdi-alert-outline" style="color:#FFAB00;"></i><span>Mark as Culled</span><small>Removed from the herd — record date and reason</small></button>
          <button class="ad-action-card" @click="openAction('slaughtered')"><i class="mdi mdi-knife" style="color:#FFAB00;"></i><span>Mark as Slaughtered</span><small>Slaughtered for meat — record date and reason</small></button>
          <button class="ad-action-card" @click="openAction('lost')"><i class="mdi mdi-map-marker-question-outline" style="color:#FF9800;"></i><span>Report Lost</span><small>Animal is missing — record when and details</small></button>
          <button class="ad-action-card" @click="openAction('stolen')"><i class="mdi mdi-alert-circle" style="color:#FF9800;"></i><span>Report Stolen</span><small>Theft report — record when and details</small></button>
          <button class="ad-action-card" @click="openAction('transfer')"><i class="mdi mdi-swap-horizontal" style="color:#4FC3F7;"></i><span>Transfer</span><small>Move this animal to another of your farms</small></button>
        </div>
      </div>

      <!-- HISTORY TAB -->
      <div v-if="tab==='history'">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h6 style="color:var(--fm-h,#F5F0E8);margin:0;">Audit Trail</h6>
          <span style="color:var(--fm-s,#6B6356);font-size:11px;"><i class="mdi mdi-lock-outline me-1"></i>Immutable log</span>
        </div>
        <div style="color:var(--fm-s,#6B6356);font-size:11px;margin-bottom:12px;">Every change made to this animal's records — who did it, when and what changed. Entries cannot be edited or deleted.</div>
        <div v-if="loadingAudit" class="text-center py-3"><div class="spinner-border spinner-border-sm text-warning"></div></div>
        <div v-else>
          <div v-for="t in auditTrail" :key="t.id" class="ad-card mb-2">
            <div class="d-flex justify-content-between align-items-start">
              <strong style="color:#BFA164;font-size:13px;"><i :class="'mdi me-1 '+auditIcon(t.action)"></i>{{ auditLabel(t.action) }}</strong>
              <span style="color:var(--fm-s,#6B6356);font-size:11px;white-space:nowrap;">{{ fDateTime(t.created_at) }}</span>
            </div>
            <div style="color:var(--fm-t,#C9C2B6);font-size:12px;margin-top:3px;">{{ t.description }}</div>
            <div style="color:var(--fm-s,#6B6356);font-size:11px;margin-top:3px;">
              <i class="mdi mdi-account-outline me-1"></i>{{ t.actor_name || 'Unknown user' }}<span v-if="t.actor_phone"> · {{ t.actor_phone }}</span>
            </div>
          </div>
          <div v-if="auditTrail.length===0" class="ad-empty">
            <i class="mdi mdi-history" style="font-size:28px;color:var(--fm-s,#2A2520);display:block;margin-bottom:6px;"></i>
            No recorded changes yet
          </div>
        </div>
      </div>

      <!-- PHOTOS TAB -->
      <div v-if="tab==='photos'">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 style="color:var(--fm-h,#F5F0E8);margin:0;">Photos ({{ photos.length }})</h6>
          <label class="btn btn-sm btn-warning" style="margin:0;cursor:pointer;">
            <i class="mdi mdi-camera-plus me-1"></i>Add Photos
            <input type="file" accept="image/*" multiple @change="onPhotoSelect" style="display:none;" />
          </label>
        </div>

        <!-- STAGED: new photos waiting to be uploaded -->
        <div v-if="stagedPhotos.length" class="ad-card mb-3" style="border-color:var(--fm-br,#2A2520);">
          <div class="d-flex align-items-center justify-content-between mb-2">
            <span style="color:#BFA164;font-size:13px;font-weight:600;"><i class="mdi mdi-cloud-upload-outline me-1"></i>Ready to upload ({{ stagedPhotos.length }})</span>
            <div class="d-flex gap-2">
              <button class="btn btn-sm btn-outline-danger" @click="stagedPhotos=[]" style="font-size:11px;">Clear All</button>
              <button class="btn btn-sm btn-warning" @click="uploadStagedPhotos" :disabled="uploadingPhotos">
                <span v-if="uploadingPhotos"><span class="spinner-border spinner-border-sm me-1"></span>Uploading...</span>
                <span v-else><i class="mdi mdi-cloud-upload me-1"></i>Upload All</span>
              </button>
            </div>
          </div>
          <div class="ad-staged-grid">
            <div v-for="(sp,si) in stagedPhotos" :key="'sp-'+si" class="ad-staged-item">
              <div class="ad-staged-img" :style="{backgroundImage:'url('+sp.preview+')'}" @click="previewIndex=photos.length+si">
                <button class="ad-staged-rm" @click="stagedPhotos.splice(si,1)">&times;</button>
                <span v-if="si===0 && photos.length===0" class="ad-staged-badge">Primary</span>
              </div>
              <div class="ad-staged-info">{{ formatFileSize(sp.size) }}</div>
            </div>
            <label class="ad-staged-add" v-if="stagedPhotos.length<6">
              <i class="mdi mdi-plus" style="font-size:20px;color:#BFA164;"></i>
              <span style="font-size:9px;color:var(--fm-s,#6B6356);">More</span>
              <input type="file" accept="image/*" multiple @change="onPhotoSelect" style="display:none;" />
            </label>
          </div>
        </div>

        <!-- EXISTING: saved photos -->
        <div v-if="photos.length" class="ad-photo-grid">
          <div v-for="p in photos" :key="p.id" class="ad-photo-item-wrap">
            <div class="ad-photo-item" :style="{backgroundImage:'url('+photoUrl(p.photo_url)+')'}" @click="previewIndex=photos.indexOf(p)">
              <span v-if="p.is_primary==1" class="ad-photo-primary"><i class="mdi mdi-star"></i></span>
            </div>
            <div class="ad-photo-actions">
              <button v-if="p.is_primary!=1" class="ad-pa-btn" @click="setPrimaryPhoto(p)" title="Set as primary"><i class="mdi mdi-star-outline"></i></button>
              <button class="ad-pa-btn ad-pa-del" @click="deletePhoto(p)" title="Delete"><i class="mdi mdi-trash-can-outline"></i></button>
            </div>
          </div>
        </div>

        <!-- EMPTY STATE -->
        <div v-if="photos.length===0 && stagedPhotos.length===0" class="ad-empty">
          <i class="mdi mdi-camera-off" style="font-size:32px;color:var(--fm-s,#2A2520);display:block;margin-bottom:8px;"></i>
          No photos yet. Add photos to help buyers see your animal.
          <label class="btn btn-sm btn-outline-warning mt-2" style="cursor:pointer;">
            <i class="mdi mdi-camera-plus me-1"></i>Upload Photos
            <input type="file" accept="image/*" multiple @change="onPhotoSelect" style="display:none;" />
          </label>
        </div>
      </div>

      <!-- PHOTO PREVIEW -->
      <div v-if="previewIndex!==null" class="ad-lightbox" @click.self="previewIndex=null">
        <button class="ad-lb-close" @click="previewIndex=null"><i class="mdi mdi-close"></i></button>
        <button v-if="previewIndex>0" class="ad-lb-nav ad-lb-prev" @click.stop="previewIndex--"><i class="mdi mdi-chevron-left"></i></button>
        <img :src="allPreviewPhotos[previewIndex]" class="ad-lb-img" />
        <button v-if="previewIndex<allPreviewPhotos.length-1" class="ad-lb-nav ad-lb-next" @click.stop="previewIndex++"><i class="mdi mdi-chevron-right"></i></button>
        <div class="ad-lb-counter">{{ previewIndex+1 }} / {{ allPreviewPhotos.length }}</div>
      </div>

      <!-- WEIGHT MODAL (add + edit) -->
      <div v-if="showWeightModal" class="ad-overlay" @click.self="closeWeightModal"><div class="ad-modal">
        <h6 style="color:var(--fm-h,#F5F0E8);"><i class="mdi mdi-scale me-2" style="color:#50C878;"></i>{{ editingWeightId ? 'Edit Weight' : 'Record Weight' }}</h6>
        <div class="mb-2"><label class="ad-label">Weight (kg) *</label><input v-model="newWeight" class="ad-input w-100" type="number" step="0.1" autofocus /></div>
        <div class="mb-2"><label class="ad-label">Date Recorded *</label><input v-model="weightDate" class="ad-input w-100" type="date" :max="todayStr" /></div>
        <div class="mb-3"><label class="ad-label">Method</label><select v-model="weightMethod" class="ad-input w-100"><option value="scale">Weighing Scale</option><option value="weigh_tape">Weigh Tape (Girth)</option><option value="visual_estimate">Visual Estimate</option></select></div>
        <button class="btn btn-warning w-100" @click="saveWeight" :disabled="!newWeight||!weightDate||processing">{{ editingWeightId ? 'Save Changes' : 'Record' }}</button>
        <button class="btn btn-sm btn-link text-muted w-100 mt-1" @click="closeWeightModal">Cancel</button>
      </div></div>

      <!-- DELETE WEIGHT CONFIRM MODAL -->
      <div v-if="showDeleteWeightModal" class="ad-overlay" @click.self="closeDeleteWeight"><div class="ad-modal ad-modal-danger">
        <div class="ad-del-icon"><i class="mdi mdi-alert-outline"></i></div>
        <h6 class="ad-del-title">Delete weight reading?</h6>
        <div v-if="deleteWeightTarget" class="ad-del-summary">
          <strong>{{ deleteWeightTarget.weight_kg }} kg</strong>
          <span>recorded {{ fDate(deleteWeightTarget.recorded_at) }}<span v-if="deleteWeightTarget.measurement_method"> · {{ weightMethodLabel(deleteWeightTarget.measurement_method) }}</span></span>
        </div>
        <p class="ad-del-warn">This permanently removes the reading and recalculates the growth chart and performance score. This cannot be undone.</p>
        <label class="ad-label">Type <strong style="color:#FF6B6B;">DELETE</strong> to confirm</label>
        <input v-model="deleteConfirmText" class="ad-input w-100" placeholder="DELETE" autocomplete="off" @keyup.enter="confirmDeleteWeight" />
        <button class="btn w-100 mt-3 ad-del-btn" :disabled="deleteConfirmText.trim().toUpperCase() !== 'DELETE' || processing" @click="confirmDeleteWeight">
          <span v-if="processing"><span class="spinner-border spinner-border-sm me-1"></span>Deleting…</span>
          <span v-else><i class="mdi mdi-trash-can-outline me-1"></i>Delete reading</span>
        </button>
        <button class="btn btn-sm btn-link text-muted w-100 mt-1" @click="closeDeleteWeight" :disabled="processing">Cancel</button>
      </div></div>

      <!-- DELETE HEALTH RECORD CONFIRM MODAL -->
      <div v-if="showDeleteHealthModal" class="ad-overlay" @click.self="closeDeleteHealth"><div class="ad-modal ad-modal-danger">
        <div class="ad-del-icon"><i class="mdi mdi-alert-outline"></i></div>
        <h6 class="ad-del-title">Delete health record?</h6>
        <div v-if="deleteHealthTarget" class="ad-del-summary">
          <strong>{{ deleteHealthTarget.title }}</strong>
          <span>{{ fDate(deleteHealthTarget.record_date) }}<span v-if="deleteHealthTarget.record_type"> · {{ deleteHealthTarget.record_type }}</span></span>
        </div>
        <p class="ad-del-warn">This permanently removes the health record. This cannot be undone.</p>
        <label class="ad-label">Type <strong style="color:#FF6B6B;">DELETE</strong> to confirm</label>
        <input v-model="deleteHealthConfirmText" class="ad-input w-100" placeholder="DELETE" autocomplete="off" @keyup.enter="confirmDeleteHealth" />
        <button class="btn w-100 mt-3 ad-del-btn" :disabled="deleteHealthConfirmText.trim().toUpperCase() !== 'DELETE' || processing" @click="confirmDeleteHealth">
          <span v-if="processing"><span class="spinner-border spinner-border-sm me-1"></span>Deleting…</span>
          <span v-else><i class="mdi mdi-trash-can-outline me-1"></i>Delete record</span>
        </button>
        <button class="btn btn-sm btn-link text-muted w-100 mt-1" @click="closeDeleteHealth" :disabled="processing">Cancel</button>
      </div></div>

      <!-- DELETE VACCINATION CONFIRM MODAL -->
      <div v-if="showDeleteVaxModal" class="ad-overlay" @click.self="closeDeleteVax"><div class="ad-modal ad-modal-danger">
        <div class="ad-del-icon"><i class="mdi mdi-alert-outline"></i></div>
        <h6 class="ad-del-title">Delete vaccination record?</h6>
        <div v-if="deleteVaxTarget" class="ad-del-summary">
          <strong>{{ deleteVaxTarget.vaccine_name }}</strong>
          <span>{{ deleteVaxTarget.disease_target }}<span v-if="deleteVaxTarget.administered_date"> · given {{ fDate(deleteVaxTarget.administered_date) }}</span></span>
        </div>
        <p class="ad-del-warn">This permanently removes the vaccination record. This cannot be undone.</p>
        <label class="ad-label">Type <strong style="color:#FF6B6B;">DELETE</strong> to confirm</label>
        <input v-model="deleteVaxConfirmText" class="ad-input w-100" placeholder="DELETE" autocomplete="off" @keyup.enter="confirmDeleteVax" />
        <button class="btn w-100 mt-3 ad-del-btn" :disabled="deleteVaxConfirmText.trim().toUpperCase() !== 'DELETE' || processing" @click="confirmDeleteVax">
          <span v-if="processing"><span class="spinner-border spinner-border-sm me-1"></span>Deleting…</span>
          <span v-else><i class="mdi mdi-trash-can-outline me-1"></i>Delete record</span>
        </button>
        <button class="btn btn-sm btn-link text-muted w-100 mt-1" @click="closeDeleteVax" :disabled="processing">Cancel</button>
      </div></div>

      <!-- DELETE BREEDING CONFIRM MODAL -->
      <div v-if="showDeleteBreedModal" class="ad-overlay" @click.self="closeDeleteBreed"><div class="ad-modal ad-modal-danger">
        <div class="ad-del-icon"><i class="mdi mdi-alert-outline"></i></div>
        <h6 class="ad-del-title">Delete breeding record?</h6>
        <div v-if="deleteBreedTarget" class="ad-del-summary">
          <strong>{{ deleteBreedTarget.breeding_method==='artificial_insemination'?'AI':'Natural' }} Mating</strong>
          <span>{{ fDate(deleteBreedTarget.breeding_date) }}</span>
        </div>
        <p class="ad-del-warn">This permanently removes the breeding record. This cannot be undone.</p>
        <label class="ad-label">Type <strong style="color:#FF6B6B;">DELETE</strong> to confirm</label>
        <input v-model="deleteBreedConfirmText" class="ad-input w-100" placeholder="DELETE" autocomplete="off" @keyup.enter="confirmDeleteBreed" />
        <button class="btn w-100 mt-3 ad-del-btn" :disabled="deleteBreedConfirmText.trim().toUpperCase() !== 'DELETE' || processing" @click="confirmDeleteBreed">
          <span v-if="processing"><span class="spinner-border spinner-border-sm me-1"></span>Deleting…</span>
          <span v-else><i class="mdi mdi-trash-can-outline me-1"></i>Delete record</span>
        </button>
        <button class="btn btn-sm btn-link text-muted w-100 mt-1" @click="closeDeleteBreed" :disabled="processing">Cancel</button>
      </div></div>

      <!-- DELETE FEEDING CONFIRM MODAL -->
      <div v-if="showDeleteFeedModal" class="ad-overlay" @click.self="closeDeleteFeed"><div class="ad-modal ad-modal-danger">
        <div class="ad-del-icon"><i class="mdi mdi-alert-outline"></i></div>
        <h6 class="ad-del-title">Delete feeding record?</h6>
        <div v-if="deleteFeedTarget" class="ad-del-summary">
          <strong>{{ deleteFeedTarget.feed_type }}</strong>
          <span>{{ deleteFeedTarget.quantity_kg }} kg · {{ fDate(deleteFeedTarget.fed_at) }}</span>
        </div>
        <p class="ad-del-warn">This permanently removes the feeding record and adjusts the cost on the profitability chart. This cannot be undone.</p>
        <label class="ad-label">Type <strong style="color:#FF6B6B;">DELETE</strong> to confirm</label>
        <input v-model="deleteFeedConfirmText" class="ad-input w-100" placeholder="DELETE" autocomplete="off" @keyup.enter="confirmDeleteFeed" />
        <button class="btn w-100 mt-3 ad-del-btn" :disabled="deleteFeedConfirmText.trim().toUpperCase() !== 'DELETE' || processing" @click="confirmDeleteFeed">
          <span v-if="processing"><span class="spinner-border spinner-border-sm me-1"></span>Deleting…</span>
          <span v-else><i class="mdi mdi-trash-can-outline me-1"></i>Delete record</span>
        </button>
        <button class="btn btn-sm btn-link text-muted w-100 mt-1" @click="closeDeleteFeed" :disabled="processing">Cancel</button>
      </div></div>

      <!-- DELETE PHOTO CONFIRM MODAL (lightweight — photos are easily re-uploaded) -->
      <div v-if="showDeletePhotoModal" class="ad-overlay" @click.self="closeDeletePhoto"><div class="ad-modal ad-modal-danger">
        <div class="ad-del-icon"><i class="mdi mdi-image-off-outline"></i></div>
        <h6 class="ad-del-title">Delete this photo?</h6>
        <div v-if="deletePhotoTarget" style="margin-bottom:12px;">
          <img :src="photoUrl(deletePhotoTarget.photo_url)" style="width:100%;max-height:160px;object-fit:cover;border-radius:8px;" />
        </div>
        <p class="ad-del-warn" style="text-align:center;">This removes the photo from the animal's gallery. You can upload it again later.</p>
        <button class="btn w-100 ad-del-btn" :disabled="processing" @click="confirmDeletePhoto">
          <span v-if="processing"><span class="spinner-border spinner-border-sm me-1"></span>Deleting…</span>
          <span v-else><i class="mdi mdi-trash-can-outline me-1"></i>Delete photo</span>
        </button>
        <button class="btn btn-sm btn-link text-muted w-100 mt-1" @click="closeDeletePhoto" :disabled="processing">Cancel</button>
      </div></div>

      <!-- HEALTH MODAL -->
      <div v-if="showHealthModal" class="ad-overlay" @click.self="closeHealthModal"><div class="ad-modal">
        <h6 style="color:var(--fm-h,#F5F0E8);"><i class="mdi mdi-stethoscope me-2" style="color:#FF6B6B;"></i>{{ editingHealthId ? 'Edit Health Record' : 'Add Health Record' }}</h6>
        <div class="mb-2" style="position:relative;"><label class="ad-label">Title *</label><input v-model="newHealth.title" class="ad-input w-100" placeholder="Type or select..." @input="filterHealthSuggestions" @focus="showHealthSuggestions=true" @blur="hideHealthSuggestions" autocomplete="off" />
          <div v-if="showHealthSuggestions && filteredHealthTitles.length" class="ad-suggest">
            <div v-for="(s,si) in filteredHealthTitles" :key="si" class="ad-suggest-item" @mousedown.prevent="pickHealthTitle(s)">{{ s }}</div>
          </div>
        </div>
        <div class="mb-2"><label class="ad-label">Type</label><select v-model="newHealth.recordType" class="ad-input w-100"><option value="illness">Illness</option><option value="treatment">Treatment</option><option value="surgery">Surgery</option><option value="checkup">Checkup</option><option value="vaccination">Vaccination</option><option value="deworming">Deworming</option><option value="hoof_trim">Hoof Trim</option><option value="dental">Dental</option><option value="other">Other</option></select></div>
        <div class="mb-2" style="position:relative;"><label class="ad-label">Diagnosis</label><input v-model="newHealth.diagnosis" class="ad-input w-100" placeholder="Type or select..." @input="showDiagSuggest=true" @focus="showDiagSuggest=true" @blur="hideDiagSuggest" autocomplete="off" />
          <div v-if="showDiagSuggest && filteredDiagnoses.length" class="ad-suggest">
            <div v-for="(s,si) in filteredDiagnoses" :key="'d-'+si" class="ad-suggest-item" @mousedown.prevent="newHealth.diagnosis=s;showDiagSuggest=false">{{ s }}</div>
          </div>
        </div>
        <div class="mb-2" style="position:relative;"><label class="ad-label">Treatment</label><input v-model="newHealth.treatment" class="ad-input w-100" placeholder="Type or select..." @input="showTreatSuggest=true" @focus="showTreatSuggest=true" @blur="hideTreatSuggest" autocomplete="off" />
          <div v-if="showTreatSuggest && filteredTreatments.length" class="ad-suggest">
            <div v-for="(s,si) in filteredTreatments" :key="'t-'+si" class="ad-suggest-item" @mousedown.prevent="newHealth.treatment=s;showTreatSuggest=false">{{ s }}</div>
          </div>
        </div>
        <div class="mb-2"><label class="ad-label">Symptoms</label><textarea v-model="newHealth.symptoms" class="ad-input w-100" rows="2" placeholder="What the animal presented with — coughing, lameness, off-feed, etc."></textarea></div>
        <div class="mb-2"><label class="ad-label">Medications / Drugs</label><textarea v-model="newHealth.medications" class="ad-input w-100" rows="2" placeholder="Product name(s), dosage, batch — e.g. Oxytetracycline 20% LA, 15ml IM"></textarea></div>
        <div class="row g-2 mb-2">
          <div class="col-6"><label class="ad-label">Severity</label>
            <select v-model="newHealth.severity" class="ad-input w-100">
              <option value="">—</option>
              <option value="mild">Mild</option>
              <option value="moderate">Moderate</option>
              <option value="severe">Severe</option>
              <option value="critical">Critical</option>
            </select>
          </div>
          <div class="col-6"><label class="ad-label">Outcome</label>
            <select v-model="newHealth.outcome" class="ad-input w-100">
              <option value="">—</option>
              <option value="recovered">Recovered</option>
              <option value="ongoing">Ongoing</option>
              <option value="chronic">Chronic</option>
              <option value="deceased">Deceased</option>
              <option value="referred">Referred to vet</option>
            </select>
          </div>
        </div>
        <div class="row g-2 mb-2">
          <div class="col-4"><label class="ad-label">Date *</label><input v-model="newHealth.recordDate" class="ad-input w-100" type="date" :max="todayStr" /></div>
          <div class="col-4"><label class="ad-label">Follow-up Date</label><input v-model="newHealth.followUpDate" class="ad-input w-100" type="date" :min="todayStr" /></div>
          <div class="col-4"><label class="ad-label">Cost (KES)</label><input v-model="newHealth.cost" class="ad-input w-100" type="number" /></div>
        </div>
        <button class="btn btn-warning w-100" @click="saveHealth" :disabled="!newHealth.title||!newHealth.recordDate||processing">{{ editingHealthId ? 'Save Changes' : 'Record' }}</button>
        <button class="btn btn-sm btn-link text-muted w-100 mt-1" @click="closeHealthModal">Cancel</button>
      </div></div>

      <!-- VACCINATION MODAL -->
      <div v-if="showVaxModal" class="ad-overlay" @click.self="closeVaxModal"><div class="ad-modal">
        <h6 style="color:var(--fm-h,#F5F0E8);"><i class="mdi mdi-needle me-2" style="color:#4FC3F7;"></i>{{ editingVaxId ? 'Edit Vaccination' : 'Record Vaccination' }}</h6>
        <div class="mb-2" style="position:relative;"><label class="ad-label">Vaccine *</label><input v-model="newVax.vaccineName" class="ad-input w-100" placeholder="Type or select..." @input="showVaxNameSuggest=true" @focus="showVaxNameSuggest=true" @blur="hideVaxNameSuggest" autocomplete="off" />
          <div v-if="showVaxNameSuggest && filteredVaxNames.length" class="ad-suggest">
            <div v-for="(v,vi) in filteredVaxNames" :key="'vn-'+vi" class="ad-suggest-item" @mousedown.prevent="pickVaccine(v)">
              <div style="color:var(--fm-h,#F5F0E8);">{{ v.name }}</div>
              <div style="color:var(--fm-s,#6B6356);font-size:11px;">{{ v.disease }}</div>
            </div>
          </div>
        </div>
        <div class="mb-2" style="position:relative;"><label class="ad-label">Disease Target *</label><input v-model="newVax.diseaseTarget" class="ad-input w-100" placeholder="Type or select..." @input="showVaxDiseaseSuggest=true" @focus="showVaxDiseaseSuggest=true" @blur="hideVaxDiseaseSuggest" autocomplete="off" />
          <div v-if="showVaxDiseaseSuggest && filteredVaxDiseases.length" class="ad-suggest">
            <div v-for="(d,di) in filteredVaxDiseases" :key="'vd-'+di" class="ad-suggest-item" @mousedown.prevent="newVax.diseaseTarget=d;showVaxDiseaseSuggest=false">{{ d }}</div>
          </div>
        </div>
        <div class="mb-2" style="position:relative;"><label class="ad-label">Dosage</label><input v-model="newVax.dosage" class="ad-input w-100" placeholder="Type or select..." @input="showVaxDoseSuggest=true" @focus="showVaxDoseSuggest=true" @blur="hideVaxDoseSuggest" autocomplete="off" />
          <div v-if="showVaxDoseSuggest && filteredVaxDosages.length" class="ad-suggest">
            <div v-for="(ds,dsi) in filteredVaxDosages" :key="'vds-'+dsi" class="ad-suggest-item" @mousedown.prevent="newVax.dosage=ds;showVaxDoseSuggest=false">{{ ds }}</div>
          </div>
        </div>
        <div class="row g-2 mb-2">
          <div class="col-6"><label class="ad-label">Vaccine Brand</label><input v-model="newVax.vaccineBrand" class="ad-input w-100" placeholder="e.g. Merial, MSD" /></div>
          <div class="col-6"><label class="ad-label">Batch / Lot #</label><input v-model="newVax.batchNumber" class="ad-input w-100" placeholder="For traceability" /></div>
        </div>
        <div class="row g-2 mb-2"><div class="col-6"><label class="ad-label">Route</label><select v-model="newVax.route" class="ad-input w-100"><option value="injection">Injection (IM/SC)</option><option value="subcutaneous">Subcutaneous (SC)</option><option value="intramuscular">Intramuscular (IM)</option><option value="intradermal">Intradermal</option><option value="oral">Oral</option><option value="intranasal">Intranasal</option><option value="eye_drop">Eye Drop</option><option value="wing_web">Wing Web</option></select></div>
          <div class="col-6"><label class="ad-label">Next Due Date</label><input v-model="newVax.nextDueDate" class="ad-input w-100" type="date" :min="todayStr" /></div></div>
        <div class="row g-2 mb-2"><div class="col-6"><label class="ad-label">Date Administered *</label><input v-model="newVax.administeredDate" class="ad-input w-100" type="date" :max="todayStr" /></div><div class="col-6"><label class="ad-label">Cost (KES)</label><input v-model="newVax.cost" class="ad-input w-100" type="number" /></div></div>
        <div class="mb-2"><label class="ad-label">Vaccination Certificate URL <span style="color:var(--fm-s,#6B6356);font-weight:400;">(optional)</span></label><input v-model="newVax.certificateUrl" class="ad-input w-100" placeholder="https:// or uploads/path" /></div>
        <button class="btn btn-warning w-100" @click="saveVax" :disabled="!newVax.vaccineName||!newVax.diseaseTarget||!newVax.administeredDate||processing">{{ editingVaxId ? 'Save Changes' : 'Record' }}</button>
        <button class="btn btn-sm btn-link text-muted w-100 mt-1" @click="closeVaxModal">Cancel</button>
      </div></div>

      <!-- BREEDING MODAL -->
      <div v-if="showBreedModal" class="ad-overlay" @click.self="closeBreedModal"><div class="ad-modal">
        <h6 style="color:var(--fm-h,#F5F0E8);"><i class="mdi mdi-heart me-2" style="color:#CE93D8;"></i>{{ editingBreedId ? 'Edit Breeding' : 'Record Breeding' }}</h6>
        <div class="mb-2"><label class="ad-label">Method *</label><select v-model="newBreed.method" class="ad-input w-100"><option value="natural">Natural Mating</option><option value="artificial_insemination">Artificial Insemination (AI)</option><option value="embryo_transfer">Embryo Transfer (ET)</option><option value="synchronized">Synchronized Mating</option></select></div>
        <div class="mb-2" v-if="newBreed.method==='artificial_insemination'||newBreed.method==='embryo_transfer'" style="position:relative;"><label class="ad-label">Semen/Embryo Source</label><input v-model="newBreed.semenSource" class="ad-input w-100" placeholder="Type or select..." @input="showSemenSuggest=true" @focus="showSemenSuggest=true" @blur="hideSemenSuggest" autocomplete="off" />
          <div v-if="showSemenSuggest && filteredSemenSources.length" class="ad-suggest">
            <div v-for="(ss,ssi) in filteredSemenSources" :key="'ss-'+ssi" class="ad-suggest-item" @mousedown.prevent="newBreed.semenSource=ss;showSemenSuggest=false">{{ ss }}</div>
          </div>
        </div>
        <div class="mb-2" v-if="newBreed.method==='natural'||newBreed.method==='synchronized'"><label class="ad-label">Male Animal ID/Tag</label><input v-model="newBreed.maleAnimalId" class="ad-input w-100" placeholder="Tag number or name" /></div>
        <div class="row g-2 mb-2"><div class="col-6"><label class="ad-label">Breeding Date *</label><input v-model="newBreed.breedingDate" class="ad-input w-100" type="date" :max="todayStr" /></div>
          <div class="col-6"><label class="ad-label">Expected Due Date</label><input v-model="newBreed.expectedDueDate" class="ad-input w-100" type="date" :min="todayStr" /></div></div>
        <!-- Pregnancy confirmation (2026-07-29 gap-close) — vet PD result -->
        <div class="mb-2" style="background:rgba(206,147,216,.06);border:1px solid rgba(206,147,216,.2);border-radius:8px;padding:10px;">
          <label class="ad-check"><input type="checkbox" v-model="newBreed.pregnancyConfirmed" /> <span>Pregnancy confirmed (post-vet check)</span></label>
          <div v-if="newBreed.pregnancyConfirmed" class="mt-2"><label class="ad-label">Confirmed On</label><input v-model="newBreed.pregnancyConfirmedDate" class="ad-input w-100" type="date" :max="todayStr" /></div>
        </div>
        <div class="mb-2" v-if="editingBreedId"><label class="ad-label">Actual Birth Date</label><input v-model="newBreed.actualBirthDate" class="ad-input w-100" type="date" :max="todayStr" /></div>
        <div class="mb-2" style="position:relative;"><label class="ad-label">Breeding Notes</label><input v-model="newBreed.notes" class="ad-input w-100" placeholder="Type or select..." @input="showBreedNoteSuggest=true" @focus="showBreedNoteSuggest=true" @blur="hideBreedNoteSuggest" autocomplete="off" />
          <div v-if="showBreedNoteSuggest && filteredBreedNotes.length" class="ad-suggest">
            <div v-for="(bn,bni) in filteredBreedNotes" :key="'bn-'+bni" class="ad-suggest-item" @mousedown.prevent="newBreed.notes=bn;showBreedNoteSuggest=false">{{ bn }}</div>
          </div>
        </div>
        <div class="mb-2"><label class="ad-label">Complications</label><textarea v-model="newBreed.complications" class="ad-input w-100" rows="2" placeholder="Dystocia, retained placenta, twin presentation, etc. — leave blank if none"></textarea></div>
        <div class="mb-2"><label class="ad-label">Cost (KES)</label><input v-model="newBreed.cost" class="ad-input w-100" type="number" /></div>
        <div class="mb-2" v-if="editingBreedId"><label class="ad-label">Outcome</label><select v-model="newBreed.outcome" class="ad-input w-100"><option value="pending">Pending</option><option value="successful_birth">Successful Birth</option><option value="stillborn">Stillborn</option><option value="abortion">Abortion</option><option value="no_conception">No Conception</option><option value="unknown">Unknown</option></select></div>
        <button class="btn btn-warning w-100" @click="saveBreed" :disabled="!newBreed.breedingDate||processing">{{ editingBreedId ? 'Save Changes' : 'Record' }}</button>
        <button class="btn btn-sm btn-link text-muted w-100 mt-1" @click="closeBreedModal">Cancel</button>
      </div></div>

      <!-- REPORT OPTIONS MODAL -->
      <div v-if="showReportOptions" class="ad-overlay" @click.self="showReportOptions=false"><div class="ad-modal">
        <h6 style="color:var(--fm-h,#F5F0E8);"><i class="mdi mdi-file-pdf-box me-2" style="color:#FF6B6B;"></i>Generate Report — {{ animal.name||animal.tag_number }}</h6>
        <p style="color:var(--fm-s,#6B6356);font-size:12px;margin-bottom:12px;">Select which sections to include:</p>
        <div class="ad-report-opt"><label><input type="checkbox" v-model="reportSections.info" disabled checked /> <span>Animal Info & Costs</span></label><span class="ad-ro-tag">Always</span></div>
        <div class="ad-report-opt"><label><input type="checkbox" v-model="reportSections.health" /> <span>Health Records ({{ healthRecords.length }})</span></label></div>
        <div class="ad-report-opt"><label><input type="checkbox" v-model="reportSections.vaccinations" /> <span>Vaccinations ({{ vaccinations.length }})</span></label></div>
        <div class="ad-report-opt"><label><input type="checkbox" v-model="reportSections.weight" /> <span>Weight History ({{ weightHistory.length }})</span></label></div>
        <div class="ad-report-opt"><label><input type="checkbox" v-model="reportSections.breeding" /> <span>Breeding Records ({{ breedingRecords.length }})</span></label></div>
        <div class="ad-report-opt"><label><input type="checkbox" v-model="reportSections.feeding" /> <span>Feeding Log ({{ feedingLogs.length }})</span></label><span v-if="feedingLogs.length>20" class="ad-ro-warn"><i class="mdi mdi-alert-outline me-1"></i>{{ feedingLogs.length }} rows</span></div>
        <div class="ad-report-opt"><label><input type="checkbox" v-model="reportSections.photos" /> <span>Photos ({{ photos.length }})</span></label></div>
        <button class="btn btn-warning w-100 mt-3" @click="showReportOptions=false;printReport()"><i class="mdi mdi-printer me-1"></i>Generate & Print</button>
        <button class="btn btn-sm btn-link text-muted w-100 mt-1" @click="showReportOptions=false">Cancel</button>
      </div></div>

      <!-- FEED MODAL -->
      <div v-if="showFeedModal" class="ad-overlay" @click.self="showFeedModal=false"><div class="ad-modal">
        <h6 style="color:var(--fm-h,#F5F0E8);"><i class="mdi mdi-silverware-fork-knife me-2" style="color:#FF9800;"></i>Log Feeding — {{ animal.name||animal.tag_number }}</h6>

        <!-- Mode toggle: Formulation vs Free-form -->
        <div class="ad-feed-mode-toggle mb-2">
          <button class="ad-feed-mode" :class="{active:newFeed.mode==='formulation'}" @click="newFeed.mode='formulation'">
            <i class="mdi mdi-clipboard-text-outline me-1"></i>Formulation
          </button>
          <button class="ad-feed-mode" :class="{active:newFeed.mode==='free'}" @click="newFeed.mode='free'">
            <i class="mdi mdi-pencil-outline me-1"></i>Free-form
          </button>
        </div>

        <!-- Formulation picker mode -->
        <div v-if="newFeed.mode==='formulation'">
          <div class="mb-2">
            <div class="d-flex justify-content-between align-items-end">
              <label class="ad-label m-0">Formulation *</label>
              <a href="javascript:void(0)" @click="$router.push('/farm/feed-formulations')" style="color:#BFA164;font-size:11px;text-decoration:none;">
                <i class="mdi mdi-cog-outline me-1"></i>Manage
              </a>
            </div>
            <select v-model="newFeed.formulationId" class="ad-input w-100" @change="onFormulationPicked">
              <option value="">Select a ration recipe...</option>
              <option v-for="f in formulationsList" :key="f.id" :value="f.id">
                {{ f.name }}{{ f.weight_band_min_kg||f.weight_band_max_kg ? ' ('+(f.weight_band_min_kg||'?')+'-'+(f.weight_band_max_kg||'?')+'kg)' : '' }} — {{ Number(f.daily_cost_kshs).toLocaleString() }} Ksh/day
              </option>
            </select>
          </div>
          <div v-if="selectedFormulation" class="ad-formula-preview mb-2">
            <div class="ad-formula-head">
              <strong style="color:var(--fm-h,#F5F0E8);font-size:13px;">{{ selectedFormulation.name }}</strong>
              <span class="ad-formula-cost">{{ Number(selectedFormulation.daily_cost_kshs).toLocaleString() }} Ksh × {{ newFeed.rationMultiplier }} = <strong>{{ Number(scaledCost).toLocaleString() }} Ksh</strong></span>
            </div>
            <div class="ad-formula-items">
              <div v-for="it in formulationItems" :key="it.id" class="ad-formula-item">
                <span>{{ it.ingredient_name }}</span>
                <span>{{ (Number(it.quantity_kg) * Number(newFeed.rationMultiplier)).toFixed(2) }} {{ it.uom }} · {{ Number(it.total_cost_kshs * newFeed.rationMultiplier).toLocaleString() }} Ksh</span>
              </div>
            </div>
          </div>
          <div class="row g-2 mb-2">
            <div class="col-6">
              <label class="ad-label">Multiplier <span style="color:var(--fm-s,#6B6356);font-size:10px;">(Days 1-3: 3×, Day 4-5: 2×, Day 6+: 1×)</span></label>
              <select v-model.number="newFeed.rationMultiplier" class="ad-input w-100">
                <option :value="1">1× (standard daily)</option>
                <option :value="2">2× (days 4-5)</option>
                <option :value="3">3× (days 1-3 induction)</option>
              </select>
            </div>
            <div class="col-6"><label class="ad-label">Date *</label><input v-model="newFeed.feedDate" class="ad-input w-100" type="date" :max="todayStr" /></div>
          </div>
        </div>

        <!-- Free-form mode (legacy) -->
        <div v-else>
          <div class="mb-2" style="position:relative;"><label class="ad-label">Feed Type *</label><input v-model="newFeed.feedType" class="ad-input w-100" placeholder="Type or select..." @input="showFeedSuggest=true" @focus="showFeedSuggest=true" @blur="hideFeedSuggest" autocomplete="off" />
            <div v-if="showFeedSuggest && filteredFeedTypes.length" class="ad-suggest">
              <div v-for="(ft,fi) in filteredFeedTypes" :key="'ft-'+fi" class="ad-suggest-item" @mousedown.prevent="newFeed.feedType=ft;showFeedSuggest=false">{{ ft }}</div>
            </div>
          </div>
          <div class="row g-2 mb-2">
            <div class="col-4"><label class="ad-label">Quantity (kg) *</label><input v-model="newFeed.quantityKg" class="ad-input w-100" type="number" step="0.5" /></div>
            <div class="col-4"><label class="ad-label">Date *</label><input v-model="newFeed.feedDate" class="ad-input w-100" type="date" :max="todayStr" /></div>
            <div class="col-4"><label class="ad-label">Cost (KES)</label><input v-model="newFeed.cost" class="ad-input w-100" type="number" /></div>
          </div>
        </div>

        <div class="mb-2" style="position:relative;"><label class="ad-label">Notes</label><input v-model="newFeed.notes" class="ad-input w-100" placeholder="Type or select..." @input="showFeedNoteSuggest=true" @focus="showFeedNoteSuggest=true" @blur="hideFeedNoteSuggest" autocomplete="off" />
          <div v-if="showFeedNoteSuggest && filteredFeedNotes.length" class="ad-suggest">
            <div v-for="(n,ni) in filteredFeedNotes" :key="'fn-'+ni" class="ad-suggest-item" @mousedown.prevent="newFeed.notes=n;showFeedNoteSuggest=false">{{ n }}</div>
          </div>
        </div>
        <button class="btn btn-warning w-100" @click="addFeeding" :disabled="!canSubmitFeed||processing">Record Feeding</button>
        <button class="btn btn-sm btn-link text-muted w-100 mt-1" @click="showFeedModal=false">Cancel</button>
      </div></div>

      <!-- EDIT FEEDING MODAL (simple — edits a logged feed regardless of how it was created) -->
      <div v-if="showEditFeedModal" class="ad-overlay" @click.self="showEditFeedModal=false"><div class="ad-modal">
        <h6 style="color:var(--fm-h,#F5F0E8);"><i class="mdi mdi-pencil me-2" style="color:#FF9800;"></i>Edit Feeding Record</h6>
        <div class="mb-2"><label class="ad-label">Feed Type *</label><input v-model="editFeed.feedType" class="ad-input w-100" /></div>
        <div class="row g-2 mb-2">
          <div class="col-4"><label class="ad-label">Quantity (kg) *</label><input v-model="editFeed.quantityKg" class="ad-input w-100" type="number" step="0.1" /></div>
          <div class="col-4"><label class="ad-label">Date *</label><input v-model="editFeed.feedDate" class="ad-input w-100" type="date" :max="todayStr" /></div>
          <div class="col-4"><label class="ad-label">Cost (KES)</label><input v-model="editFeed.cost" class="ad-input w-100" type="number" /></div>
        </div>
        <div class="mb-2"><label class="ad-label">Notes</label><input v-model="editFeed.notes" class="ad-input w-100" /></div>
        <button class="btn btn-warning w-100" @click="saveEditFeed" :disabled="!editFeed.feedType||!editFeed.quantityKg||!editFeed.feedDate||processing">Save Changes</button>
        <button class="btn btn-sm btn-link text-muted w-100 mt-1" @click="showEditFeedModal=false">Cancel</button>
      </div></div>

      <!-- MILK MODAL (add + edit) -->
      <div v-if="showMilkModal" class="ad-overlay" @click.self="closeMilkModal"><div class="ad-modal">
        <h6 style="color:var(--fm-h,#F5F0E8);"><i class="mdi mdi-cup-water me-2" style="color:#4FC3F7;"></i>{{ editingMilkId ? 'Edit Milk Record' : 'Record Milk' }}</h6>
        <div class="row g-2 mb-2">
          <div class="col-6"><label class="ad-label">Session *</label>
            <select v-model="newMilk.session" class="ad-input w-100">
              <option value="morning">Morning</option><option value="afternoon">Afternoon</option><option value="evening">Evening</option>
            </select>
          </div>
          <div class="col-6"><label class="ad-label">Quantity (litres) *</label><input v-model="newMilk.quantityLiters" class="ad-input w-100" type="number" step="0.1" /></div>
        </div>
        <div class="row g-2 mb-2">
          <div class="col-6"><label class="ad-label">Date *</label><input v-model="newMilk.recordDate" class="ad-input w-100" type="date" :max="todayStr" /></div>
          <div class="col-6"><label class="ad-label">Quality Grade</label>
            <select v-model="newMilk.qualityGrade" class="ad-input w-100">
              <option value="">—</option><option value="A">A</option><option value="B">B</option><option value="C">C</option><option value="rejected">Rejected</option>
            </select>
          </div>
        </div>
        <div class="mb-2"><label class="ad-label">Fat Content (%)</label><input v-model="newMilk.fatContentPct" class="ad-input w-100" type="number" step="0.1" placeholder="Optional" /></div>
        <button class="btn btn-warning w-100" @click="saveMilk" :disabled="!newMilk.quantityLiters||!newMilk.recordDate||processing">{{ editingMilkId ? 'Save Changes' : 'Record' }}</button>
        <button class="btn btn-sm btn-link text-muted w-100 mt-1" @click="closeMilkModal">Cancel</button>
      </div></div>

      <!-- FEEDING SCHEDULE MODAL (add + edit) -->
      <div v-if="showScheduleModal" class="ad-overlay" @click.self="closeScheduleModal"><div class="ad-modal">
        <h6 style="color:var(--fm-h,#F5F0E8);"><i class="mdi mdi-calendar-clock me-2" style="color:#BFA164;"></i>{{ editingScheduleId ? 'Edit Schedule' : 'New Feeding Schedule' }}</h6>
        <div class="mb-2">
          <div class="d-flex justify-content-between align-items-end">
            <label class="ad-label m-0">Formulation</label>
            <a href="javascript:void(0)" @click="$router.push('/farm/feed-formulations')" style="color:#BFA164;font-size:11px;text-decoration:none;"><i class="mdi mdi-cog-outline me-1"></i>Manage</a>
          </div>
          <select v-model="newSchedule.formulationId" class="ad-input w-100" @change="onScheduleFormulationPicked">
            <option value="">Free-form (type below)</option>
            <option v-for="f in formulationsList" :key="f.id" :value="f.id">{{ f.name }} — {{ Number(f.daily_cost_kshs).toLocaleString() }} Ksh/day</option>
          </select>
        </div>
        <div class="row g-2 mb-2">
          <div class="col-7"><label class="ad-label">Feed Type *</label><input v-model="newSchedule.feedType" class="ad-input w-100" :readonly="!!newSchedule.formulationId" placeholder="e.g. Dairy meal" /></div>
          <div class="col-5"><label class="ad-label">Qty (kg) *</label><input v-model="newSchedule.quantityKg" class="ad-input w-100" type="number" step="0.1" :readonly="!!newSchedule.formulationId" /></div>
        </div>
        <div class="mb-2"><label class="ad-label">Frequency</label>
          <select v-model="newSchedule.frequency" class="ad-input w-100">
            <option value="once_daily">Once daily</option><option value="twice_daily">Twice daily</option><option value="three_times">Three times</option><option value="four_times">Four times</option><option value="ad_libitum">Ad libitum</option><option value="custom">Custom</option>
          </select>
        </div>
        <div class="row g-2 mb-2">
          <div class="col-6"><label class="ad-label">Start Date *</label><input v-model="newSchedule.startDate" class="ad-input w-100" type="date" /></div>
          <div class="col-6"><label class="ad-label">End Date</label><input v-model="newSchedule.endDate" class="ad-input w-100" type="date" /></div>
        </div>
        <div class="mb-2"><label class="ad-label">Special Instructions</label><input v-model="newSchedule.specialInstructions" class="ad-input w-100" placeholder="Optional" /></div>
        <button class="btn btn-warning w-100" @click="saveSchedule" :disabled="!newSchedule.feedType||!newSchedule.quantityKg||!newSchedule.startDate||processing">{{ editingScheduleId ? 'Save Changes' : 'Create Schedule' }}</button>
        <button class="btn btn-sm btn-link text-muted w-100 mt-1" @click="closeScheduleModal">Cancel</button>
      </div></div>

      <!-- DELETE SCHEDULE CONFIRM MODAL -->
      <div v-if="showDeleteScheduleModal" class="ad-overlay" @click.self="closeDeleteSchedule"><div class="ad-modal ad-modal-danger">
        <div class="ad-del-icon"><i class="mdi mdi-alert-outline"></i></div>
        <h6 class="ad-del-title">Delete feeding schedule?</h6>
        <div v-if="deleteScheduleTarget" class="ad-del-summary">
          <strong>{{ deleteScheduleTarget.formulation_name || deleteScheduleTarget.feed_type }}</strong>
          <span>{{ deleteScheduleTarget.quantity_kg }}kg · {{ (deleteScheduleTarget.frequency||'').replace(/_/g,' ') }}</span>
        </div>
        <p class="ad-del-warn">This permanently removes the recurring feeding plan. Logged feeds are not affected. This cannot be undone.</p>
        <label class="ad-label">Type <strong style="color:#FF6B6B;">DELETE</strong> to confirm</label>
        <input v-model="deleteScheduleConfirmText" class="ad-input w-100" placeholder="DELETE" autocomplete="off" @keyup.enter="confirmDeleteSchedule" />
        <button class="btn w-100 mt-3 ad-del-btn" :disabled="deleteScheduleConfirmText.trim().toUpperCase() !== 'DELETE' || processing" @click="confirmDeleteSchedule">
          <span v-if="processing"><span class="spinner-border spinner-border-sm me-1"></span>Deleting…</span>
          <span v-else><i class="mdi mdi-trash-can-outline me-1"></i>Delete schedule</span>
        </button>
        <button class="btn btn-sm btn-link text-muted w-100 mt-1" @click="closeDeleteSchedule" :disabled="processing">Cancel</button>
      </div></div>

      <!-- DELETE MILK CONFIRM MODAL -->
      <div v-if="showDeleteMilkModal" class="ad-overlay" @click.self="closeDeleteMilk"><div class="ad-modal ad-modal-danger">
        <div class="ad-del-icon"><i class="mdi mdi-alert-outline"></i></div>
        <h6 class="ad-del-title">Delete milk record?</h6>
        <div v-if="deleteMilkTarget" class="ad-del-summary">
          <strong>{{ deleteMilkTarget.quantity_liters }} L</strong>
          <span style="text-transform:capitalize;">{{ deleteMilkTarget.session }} · {{ fDate(deleteMilkTarget.record_date) }}</span>
        </div>
        <p class="ad-del-warn">This permanently removes the milk record and adjusts the daily yield. This cannot be undone.</p>
        <label class="ad-label">Type <strong style="color:#FF6B6B;">DELETE</strong> to confirm</label>
        <input v-model="deleteMilkConfirmText" class="ad-input w-100" placeholder="DELETE" autocomplete="off" @keyup.enter="confirmDeleteMilk" />
        <button class="btn w-100 mt-3 ad-del-btn" :disabled="deleteMilkConfirmText.trim().toUpperCase() !== 'DELETE' || processing" @click="confirmDeleteMilk">
          <span v-if="processing"><span class="spinner-border spinner-border-sm me-1"></span>Deleting…</span>
          <span v-else><i class="mdi mdi-trash-can-outline me-1"></i>Delete record</span>
        </button>
        <button class="btn btn-sm btn-link text-muted w-100 mt-1" @click="closeDeleteMilk" :disabled="processing">Cancel</button>
      </div></div>

      <!-- AI VET ASSISTANT MODAL -->
      <div v-if="showAiVet" class="ad-overlay" @click.self="closeAiVet()"><div class="ad-modal" style="max-width:560px;max-height:80vh;display:flex;flex-direction:column;">
        <div class="d-flex align-items-center justify-content-between mb-2">
          <h6 style="color:var(--fm-h,#F5F0E8);margin:0;"><i class="mdi mdi-robot me-2" style="color:#CE93D8;"></i>AI Vet — {{ animal.name||animal.tag_number||'Animal' }}</h6>
          <button class="btn btn-sm btn-outline-secondary" @click="closeAiVet()"><i class="mdi mdi-close"></i></button>
        </div>
        <div style="background:var(--fm-bg3,#1a1510);border:1px solid #BFA164;border-radius:8px;padding:6px 10px;margin-bottom:8px;font-size:10px;color:#BFA164;">
          <i class="mdi mdi-information me-1"></i>{{ animal.species_name }} &middot; {{ animal.breed_name||'Unknown breed' }} &middot; {{ animal.weight_kg?animal.weight_kg+'kg':'Weight unknown' }} &middot; {{ animal.health_status||'Unknown' }}
        </div>
        <!-- URGENT banner — pops when AI flags emergency -->
        <div v-if="aiVetUrgent" style="background:rgba(255,107,107,.08);border:2px solid #FF6B6B;border-radius:10px;padding:10px 12px;margin-bottom:8px;animation:aiVetUrgentPulse 2s ease-out infinite;">
          <div class="d-flex align-items-start gap-2">
            <i class="mdi mdi-alert-octagon" style="font-size:22px;color:#FF6B6B;flex-shrink:0;"></i>
            <div style="flex:1;">
              <div style="font-weight:700;font-size:12px;color:#FF6B6B;">EMERGENCY — get a vet immediately</div>
              <div style="font-size:10px;color:var(--fm-m,#A09888);margin-top:2px;">
                The AI flagged this as life-threatening. Don't wait — call a vet now.
              </div>
              <div class="d-flex gap-2 mt-2 flex-wrap">
                <button class="btn btn-sm btn-danger" style="font-size:10px;padding:4px 10px;" @click="openVetPicker(true,'find')">
                  <i class="mdi mdi-stethoscope me-1"></i>Find a Vet NOW
                </button>
                <button class="btn btn-sm btn-outline-warning" style="font-size:10px;padding:4px 10px;" @click="openVetPicker(true,'mine')">
                  <i class="mdi mdi-message-text me-1"></i>Message a Vet
                </button>
                <a class="btn btn-sm btn-outline-light" style="font-size:10px;padding:4px 10px;" href="tel:+254800720555">
                  <i class="mdi mdi-phone me-1"></i>KVB Hotline
                </a>
              </div>
            </div>
          </div>
        </div>
        <div ref="aiVetChat" style="flex:1;overflow-y:auto;background:var(--fm-bg2,#0A0A0A);border:1px solid var(--fm-br,#1E1E1E);border-radius:10px;padding:12px;margin-bottom:8px;min-height:180px;max-height:350px;">
          <div v-if="aiVetMessages.length===0" style="text-align:center;padding:30px 16px;color:var(--fm-s,#6B6356);">
            <i class="mdi mdi-robot" style="font-size:36px;display:block;margin-bottom:6px;color:var(--fm-s,#2A2520);"></i>
            <div style="font-size:12px;color:var(--fm-m,#A09888);">Ask about this animal's health, symptoms, treatment options, or prevention advice.</div>
            <div class="d-flex flex-wrap justify-content-center gap-2 mt-3">
              <button class="btn btn-sm btn-outline-secondary" style="font-size:10px;" @click="aiVetInput='What vaccinations does this animal need next?'">Vaccination schedule</button>
              <button class="btn btn-sm btn-outline-secondary" style="font-size:10px;" @click="aiVetInput='Suggest a feeding plan for optimal weight gain'">Feeding plan</button>
              <button class="btn btn-sm btn-outline-secondary" style="font-size:10px;" @click="aiVetInput='Is this animal healthy based on its records?'">Health check</button>
            </div>
          </div>
          <div v-for="(msg,mi) in aiVetMessages" :key="mi" style="margin-bottom:12px;">
            <div v-if="msg.role==='user'" style="display:flex;justify-content:flex-end;">
              <div style="background:#BFA164;color:#0A0A0A;padding:8px 12px;border-radius:12px 12px 2px 12px;max-width:85%;font-size:12px;line-height:1.5;">
                <img v-if="msg.photo" :src="msg.photo" style="max-width:200px;max-height:150px;border-radius:6px;display:block;margin-bottom:6px;" />
                {{ msg.content }}
              </div>
            </div>
            <div v-else style="display:flex;gap:8px;">
              <i class="mdi mdi-robot" style="color:#CE93D8;font-size:16px;flex-shrink:0;margin-top:4px;"></i>
              <div style="background:var(--fm-bg3,#1E1E1E);color:var(--fm-h,#F5F0E8);padding:8px 12px;border-radius:2px 12px 12px 12px;max-width:85%;font-size:12px;line-height:1.6;" v-html="formatMd(msg.content)"></div>
            </div>
          </div>
          <div v-if="aiVetLoading" style="display:flex;gap:8px;">
            <i class="mdi mdi-robot" style="color:#CE93D8;font-size:16px;flex-shrink:0;margin-top:4px;"></i>
            <div style="background:var(--fm-bg3,#1E1E1E);color:var(--fm-s,#6B6356);padding:8px 12px;border-radius:2px 12px 12px 12px;font-size:12px;">
              <span class="spinner-border spinner-border-sm me-1" style="width:12px;height:12px;"></span>Analysing...
            </div>
          </div>
        </div>
        <!-- Photo preview -->
        <div v-if="aiVetPhoto" style="background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#2A2520);border-radius:8px;padding:8px;margin-bottom:8px;display:flex;align-items:center;gap:10px;">
          <img :src="aiVetPhoto.preview" style="width:48px;height:48px;object-fit:cover;border-radius:6px;" />
          <div class="flex-fill"><div style="color:var(--fm-h,#F5F0E8);font-size:11px;">Photo attached</div><div style="color:var(--fm-s,#6B6356);font-size:9px;">{{ aiVetPhoto.name }}</div></div>
          <button class="btn btn-sm btn-outline-danger" style="font-size:10px;padding:2px 6px;" @click="aiVetPhoto=null"><i class="mdi mdi-close"></i></button>
        </div>
        <!-- Voice indicator -->
        <div v-if="aiVetRecording" style="background:var(--fm-bg3,#200F20);border:1px solid #CE93D8;border-radius:8px;padding:8px 12px;margin-bottom:8px;display:flex;align-items:center;gap:8px;">
          <span class="spinner-grow spinner-grow-sm" style="background:#CE93D8;width:10px;height:10px;"></span>
          <span style="color:#CE93D8;font-size:12px;font-weight:600;">Listening...</span>
          <span class="flex-fill"></span>
          <button class="btn btn-sm btn-outline-danger" style="font-size:10px;padding:2px 8px;" @click="stopVoiceInput()">Stop</button>
        </div>
        <div class="d-flex gap-2 align-items-center">
          <input type="file" ref="aiVetFileInput" accept="image/*" capture="environment" style="display:none;" @change="onAiVetPhoto" />
          <button class="btn btn-sm btn-outline-secondary" style="padding:6px 8px;" @click="$refs.aiVetFileInput.click()" :disabled="aiVetLoading" title="Attach photo"><i class="mdi mdi-camera" style="font-size:16px;"></i></button>
          <button class="btn btn-sm btn-outline-secondary" style="padding:6px 8px;" @click="toggleVoiceInput()" :disabled="aiVetLoading" :style="{borderColor:aiVetRecording?'#CE93D8':'',color:aiVetRecording?'#CE93D8':''}" title="Voice input"><i class="mdi mdi-microphone" style="font-size:16px;"></i></button>
          <input v-model="aiVetInput" class="fm-input flex-fill" placeholder="Describe symptoms..." @keyup.enter="sendAiVet" :disabled="aiVetLoading" style="font-size:12px;background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#2A2520);color:var(--fm-h,#F5F0E8);border-radius:8px;padding:8px 12px;" />
          <button class="btn btn-sm" style="background:#CE93D8;color:#0A0A0A;font-weight:600;padding:6px 14px;" @click="sendAiVet" :disabled="(!aiVetInput.trim()&&!aiVetPhoto)||aiVetLoading"><i class="mdi mdi-send"></i></button>
        </div>
        <div style="color:var(--fm-s,#6B6356);font-size:9px;margin-top:4px;text-align:center;">AI advice is not a substitute for a qualified veterinarian.</div>
      </div></div>

      <!-- ANIMAL ACTION MODAL (issue 86) -->
      <div v-if="showActionModal" class="ad-overlay" @click.self="showActionModal=false"><div class="ad-modal" style="max-width:520px;max-height:85vh;overflow-y:auto;">
        <h6 style="color:var(--fm-h,#F5F0E8);margin-bottom:10px;"><i :class="'mdi me-2 '+actionMeta[actionType].icon" :style="{color:actionMeta[actionType].color}"></i>{{ actionMeta[actionType].title }}</h6>
        <div style="background:var(--fm-bg3,#1a1510);border:1px solid #BFA164;border-radius:8px;padding:8px 12px;margin-bottom:10px;">
          <i class="mdi mdi-cow me-1" style="color:#BFA164;"></i><span style="color:#BFA164;font-size:12px;font-weight:600;">{{ animal.name||animal.tag_number||'This animal' }}</span>
        </div>
        <div v-if="amOwner===false" style="background:rgba(255,171,0,.06);border:1px solid rgba(255,171,0,.25);border-radius:8px;padding:8px 10px;margin-bottom:10px;color:#FFAB00;font-size:11px;">
          <i class="mdi mdi-account-clock-outline me-1"></i>This will be sent to the farm owner for approval before it takes effect.
        </div>

        <!-- SOLD -->
        <div v-if="actionType==='sold'">
          <div class="row g-2 mb-2">
            <div class="col-md-4"><label class="ad-label">Sale Date *</label><input v-model="actionForm.sale_date" class="ad-input w-100" type="date" :max="todayStr" /></div>
            <div class="col-md-4"><label class="ad-label">Live Weight at Sale (kg)</label><input v-model="actionForm.sale_weight_kg" class="ad-input w-100" type="number" step="0.1" placeholder="auto from weight" /></div>
            <div class="col-md-4"><label class="ad-label">Price / kg (KES)</label><input v-model="actionForm.sale_price_per_kg_kes" class="ad-input w-100" type="number" step="0.01" @input="recalcActionSaleTotal" /></div>
          </div>
          <div class="row g-2 mb-2">
            <div class="col-md-6"><label class="ad-label">Total Sale Price (KES) *</label><input v-model="actionForm.sale_price_kes" class="ad-input w-100" type="number" /></div>
            <div class="col-md-6"><label class="ad-label">Payment Method</label>
              <select v-model="actionForm.sale_payment_method" class="ad-input w-100">
                <option value="">—</option>
                <option value="cash">Cash</option>
                <option value="mpesa">M-Pesa</option>
                <option value="bank_transfer">Bank transfer</option>
                <option value="rtgs">RTGS</option>
                <option value="cheque">Cheque</option>
                <option value="deferred">Deferred (terms)</option>
                <option value="other">Other</option>
              </select>
            </div>
          </div>
          <div class="row g-2 mb-2">
            <div class="col-md-6"><label class="ad-label">Payment Terms</label><input v-model="actionForm.sale_payment_terms" class="ad-input w-100" placeholder="e.g. cash on delivery, 4-day terms" /></div>
            <div class="col-md-6"><label class="ad-label">Receipt #</label><input v-model="actionForm.sale_receipt_no" class="ad-input w-100" /></div>
          </div>
          <div class="ad-buyer-block mt-2 mb-2">
            <div style="color:#50C878;font-size:10px;text-transform:uppercase;letter-spacing:.5px;font-weight:600;margin-bottom:6px;">Buyer Attribution</div>
            <div v-if="actionForm.buyer_user_id" class="ad-corp-pill mb-2">
              <i class="mdi mdi-domain me-1"></i>
              <strong>{{ actionForm.buyer_name }}</strong>
              <span v-if="actionForm.buyer_corp_kyc" class="ad-corp-kyc" :class="'kyc-'+actionForm.buyer_corp_kyc">{{ actionForm.buyer_corp_kyc.toUpperCase() }}</span>
              <button class="btn btn-sm btn-link" @click="clearCorpBuyer" style="color:#FF6B6B;padding:0 6px;"><i class="mdi mdi-close"></i></button>
            </div>
            <div v-else>
              <label class="ad-label">Look up corporate buyer (e.g. Choice Meats)</label>
              <div class="ad-corp-search">
                <input v-model="corpSearch" class="ad-input w-100" placeholder="Type company name…" @input="searchCorporates" @focus="searchCorporates" />
                <div v-if="corpSearch && (corpResults.length || corpSearching)" class="ad-corp-results">
                  <div v-if="corpSearching" style="padding:8px;color:var(--fm-s,#6B6356);font-size:11px;">Searching…</div>
                  <div v-else-if="!corpResults.length" style="padding:8px;color:var(--fm-s,#6B6356);font-size:11px;">
                    No corporate match. <a href="javascript:void(0)" @click="useManualBuyer" style="color:#BFA164;">Use "{{ corpSearch }}" as a manual buyer</a>.
                  </div>
                  <div v-for="c in corpResults" :key="'corp-'+c.id" class="ad-corp-row" @click="pickCorpBuyer(c)">
                    <div>
                      <div style="color:var(--fm-h,#F5F0E8);font-weight:600;font-size:13px;">{{ c.company_name }}<span v-if="c.short_name" style="color:var(--fm-s,#6B6356);font-weight:400;"> · {{ c.short_name }}</span></div>
                      <div style="color:var(--fm-s,#6B6356);font-size:11px;">{{ (c.business_type||'').replace('_',' ') }}<span v-if="c.contact_phone"> · {{ c.contact_phone }}</span></div>
                    </div>
                    <span v-if="c.kyc_status" class="ad-corp-kyc" :class="'kyc-'+c.kyc_status">{{ c.kyc_status.toUpperCase() }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row g-2 mt-2 mb-2">
              <div class="col-md-6"><label class="ad-label">Buyer Name</label><input v-model="actionForm.buyer_name" class="ad-input w-100" :disabled="!!actionForm.buyer_user_id" placeholder='e.g. Choice Meats Ltd, or "Unknown Buyer"' /></div>
              <div class="col-md-6"><label class="ad-label">Buyer Phone</label><input v-model="actionForm.buyer_phone" class="ad-input w-100" :disabled="!!actionForm.buyer_user_id" placeholder="2547..." /></div>
            </div>
            <div><label class="ad-label">Destination / Location</label><input v-model="actionForm.sale_destination" class="ad-input w-100" placeholder="e.g. Rumuruti Slaughterhouse, Dagoretti market" /></div>
          </div>
          <div class="mb-2"><label class="ad-label">Sale Notes</label><textarea v-model="actionForm.sale_notes" class="ad-input w-100" rows="2" placeholder="Anything else worth recording about this sale..."></textarea></div>
        </div>

        <!-- DECEASED -->
        <div v-if="actionType==='deceased'">
          <div class="mb-2"><label class="ad-label">Date of Death *</label><input v-model="actionForm.death_date" class="ad-input w-100" type="date" :max="todayStr" /></div>
          <div class="mb-2"><label class="ad-label">Cause of Death</label>
            <select v-model="actionForm.cause_of_death" class="ad-input w-100">
              <option value="">Select cause...</option>
              <option value="disease">Disease</option>
              <option value="predator_attack">Predator Attack</option>
              <option value="accident">Accident / Injury</option>
              <option value="poisoning">Poisoning</option>
              <option value="old_age">Old Age</option>
              <option value="birthing_complications">Birthing Complications</option>
              <option value="drought_starvation">Drought / Starvation</option>
              <option value="slaughter">Slaughter</option>
              <option value="unknown">Unknown</option>
            </select>
          </div>
          <div class="mb-2"><label class="ad-label">Details</label><textarea v-model="actionForm.death_notes" class="ad-input w-100" rows="2" placeholder="Additional details..."></textarea></div>
        </div>

        <!-- CULLED / SLAUGHTERED -->
        <div v-if="actionType==='culled'||actionType==='slaughtered'">
          <div class="row g-2 mb-2">
            <div class="col-6"><label class="ad-label">Date *</label><input v-model="actionForm.cull_date" class="ad-input w-100" type="date" :max="todayStr" /></div>
            <div class="col-6"><label class="ad-label">Reason</label>
              <select v-model="actionForm.cull_reason" class="ad-input w-100">
                <option value="">Select reason…</option>
                <option value="health">Health / disease</option>
                <option value="performance">Poor performance</option>
                <option value="age">Age</option>
                <option value="injury">Injury</option>
                <option value="other">Other</option>
              </select>
            </div>
          </div>
        </div>

        <!-- LOST / STOLEN -->
        <div v-if="actionType==='lost'||actionType==='stolen'">
          <div class="mb-2"><label class="ad-label">Date {{ actionType==='stolen'?'Stolen':'Lost' }} *</label><input v-model="actionForm.incident_date" class="ad-input w-100" type="date" :max="todayStr" /></div>
          <div class="mb-2"><label class="ad-label">Details</label><textarea v-model="actionForm.incident_notes" class="ad-input w-100" rows="2" placeholder="Describe what happened..."></textarea></div>
        </div>

        <!-- TRANSFER -->
        <div v-if="actionType==='transfer'">
          <div v-if="myFarms.length<=1" style="color:var(--fm-m,#A09888);font-size:12px;text-align:center;padding:20px;">
            <i class="mdi mdi-information-outline" style="font-size:24px;color:var(--fm-s,#6B6356);display:block;margin-bottom:8px;"></i>
            You only have one farm. Create another farm first to transfer animals between farms.
          </div>
          <div v-else class="mb-2"><label class="ad-label">Destination Farm *</label>
            <select v-model="actionForm.to_farm_id" class="ad-input w-100">
              <option value="">Select farm...</option>
              <option v-for="f in myFarms.filter(function(f){return f.id!==animal.farm_id})" :key="f.id" :value="f.id">{{ f.name }}</option>
            </select>
          </div>
        </div>

        <button v-if="actionType!=='transfer'||myFarms.length>1" class="btn btn-warning w-100 fw-bold mt-1" @click="submitAction" :disabled="processing||(actionType==='transfer'&&!actionForm.to_farm_id)">
          <span v-if="processing"><span class="spinner-border spinner-border-sm me-1"></span></span>
          <i v-else :class="'mdi me-1 '+(amOwner===false?'mdi-send-clock-outline':'mdi-check-bold')"></i>{{ amOwner===false?'Submit for Approval':actionMeta[actionType].cta }}
        </button>
        <button class="btn btn-sm btn-link text-muted w-100 mt-1" @click="showActionModal=false">Cancel</button>
      </div></div>

      <!-- EDIT ANIMAL MODAL -->
      <div v-if="showEditAnimal" class="ad-overlay" @click.self="showEditAnimal=false"><div class="ad-modal" style="max-width:500px;max-height:85vh;overflow-y:auto;">
        <h6 style="color:var(--fm-h,#F5F0E8);margin-bottom:14px;"><i class="mdi mdi-pencil me-2" style="color:#BFA164;"></i>Edit Animal</h6>

        <div class="row g-2 mb-2">
          <div class="col-6"><label class="ad-label">Name</label><input v-model="editForm.name" class="ad-input w-100" placeholder="e.g. Nyota" /></div>
          <div class="col-6"><label class="ad-label">Tag Number</label><input v-model="editForm.tag_number" class="ad-input w-100" placeholder="e.g. KAJ-001" /></div>
        </div>
        <div class="row g-2 mb-2">
          <div class="col-12">
            <label class="ad-label">ANITRAC tag <span style="color:var(--fm-s,#6B6356);font-weight:400;">(Kenya's national livestock ID — optional)</span></label>
            <input v-model="editForm.anitrac_id" class="ad-input w-100" placeholder="e.g. KE-CTL-2026-00041873" />
            <div v-if="editForm.anitrac_id" style="color:#50C878;font-size:11px;margin-top:3px;">
              <i class="mdi mdi-shield-check-outline me-1"></i>This animal will display the ANITRAC verified badge on marketplace listings.
            </div>
          </div>
        </div>
        <div class="row g-2 mb-2">
          <div class="col-4"><label class="ad-label">Sex</label>
            <select v-model="editForm.sex" class="ad-input w-100">
              <option value="male">Male</option><option value="female">Female</option><option value="unknown">Unknown</option>
            </select>
          </div>
          <div class="col-4"><label class="ad-label">Age (months)</label><input v-model="editForm.age_months" class="ad-input w-100" type="number" min="0" placeholder="e.g. 18" @input="onEditAgeChange" /></div>
          <div class="col-4"><label class="ad-label">Weight (kg)</label><input v-model="editForm.weight_kg" class="ad-input w-100" type="number" step="0.1" /></div>
        </div>
        <!-- Birth + weaning milestones (Alex 2026-07-17) — feed growth-rate KPIs -->
        <div class="row g-2 mb-2">
          <div class="col-4"><label class="ad-label">Birth Weight (kg)</label><input v-model="editForm.birth_weight_kg" class="ad-input w-100" type="number" step="0.1" placeholder="e.g. 3.2" /></div>
          <div class="col-4"><label class="ad-label">Weaning Date</label><input v-model="editForm.weaning_date" class="ad-input w-100" type="date" :max="todayStr" /></div>
          <div class="col-4"><label class="ad-label">Weaning Weight (kg)</label><input v-model="editForm.weaning_weight_kg" class="ad-input w-100" type="number" step="0.1" placeholder="e.g. 25" /></div>
        </div>
        <!-- Body condition + height (2026-07-29 gap-close) -->
        <div class="row g-2 mb-2">
          <div class="col-6"><label class="ad-label">Body Condition Score <span style="color:var(--fm-s,#6B6356);font-weight:400;">(1-5)</span></label>
            <select v-model="editForm.body_condition_score" class="ad-input w-100">
              <option value="">—</option>
              <option value="1">1 · Emaciated</option>
              <option value="1.5">1.5</option>
              <option value="2">2 · Thin</option>
              <option value="2.5">2.5</option>
              <option value="3">3 · Ideal</option>
              <option value="3.5">3.5</option>
              <option value="4">4 · Fat</option>
              <option value="4.5">4.5</option>
              <option value="5">5 · Obese</option>
            </select>
          </div>
          <div class="col-6"><label class="ad-label">Height (cm)</label><input v-model="editForm.height_cm" class="ad-input w-100" type="number" step="0.1" placeholder="Withers height" /></div>
        </div>
        <div class="mb-2"><label class="ad-label">Color / Markings</label><input v-model="editForm.color_markings" class="ad-input w-100" placeholder="e.g. Brown with white face" /></div>

        <!-- Pedigree lineage (2026-07-29 gap-close) — real breeding-programme foundation -->
        <div class="mb-3" style="padding:10px;border-radius:8px;border:1px solid var(--fm-br,#1E1E1E);background:var(--fm-bg3,#1E1E1E);">
          <label class="ad-label" style="color:#CE93D8;font-weight:600;"><i class="mdi mdi-family-tree me-1"></i>Pedigree & Lineage</label>
          <div class="row g-2 mb-2">
            <div class="col-6"><label class="ad-label">Sire (Father)</label>
              <select v-model="editForm.sire_id" class="ad-input w-100">
                <option value="">{{ loadingPedigree ? 'Loading…' : 'Not linked' }}</option>
                <option v-for="s in pedigreeSireOptions" :key="'sire-'+s.id" :value="s.id">
                  {{ s.name || s.tag_number || s.id.substr(0,8) }}{{ s.tag_number && s.name ? ' · '+s.tag_number : '' }}{{ s.breed_name ? ' ('+s.breed_name+')' : '' }}
                </option>
              </select>
            </div>
            <div class="col-6"><label class="ad-label">Dam (Mother)</label>
              <select v-model="editForm.dam_id" class="ad-input w-100">
                <option value="">{{ loadingPedigree ? 'Loading…' : 'Not linked' }}</option>
                <option v-for="d in pedigreeDamOptions" :key="'dam-'+d.id" :value="d.id">
                  {{ d.name || d.tag_number || d.id.substr(0,8) }}{{ d.tag_number && d.name ? ' · '+d.tag_number : '' }}{{ d.breed_name ? ' ('+d.breed_name+')' : '' }}
                </option>
              </select>
            </div>
          </div>
          <div class="mb-2">
            <label class="ad-check"><input type="checkbox" v-model="editForm.is_pedigree" /> <span>Registered pedigree animal</span></label>
          </div>
          <div class="row g-2" v-if="editForm.is_pedigree">
            <div class="col-6"><label class="ad-label">Pedigree Number</label><input v-model="editForm.pedigree_number" class="ad-input w-100" placeholder="Registry ID" /></div>
            <div class="col-6"><label class="ad-label">Microchip Number</label><input v-model="editForm.microchip_number" class="ad-input w-100" placeholder="15-digit chip ID" /></div>
          </div>
        </div>

        <div class="row g-2 mb-2">
          <div class="col-6"><label class="ad-label">Breed</label>
            <select v-model="editForm.breed_id" class="ad-input w-100">
              <option value="">{{ loadingEditBreeds ? 'Loading…' : 'Select breed' }}</option>
              <option v-for="b in editBreedsList" :key="b.id" :value="b.id">{{ b.name }}</option>
            </select>
          </div>
          <div class="col-6"><label class="ad-label">Source</label>
            <select v-model="editForm.acquisition_type" class="ad-input w-100">
              <option value="born_on_farm">Born on Farm</option>
              <option value="purchased">Purchased</option>
              <option value="donated">Donated</option>
              <option value="traded">Traded</option>
              <option value="other">Other</option>
            </select>
          </div>
        </div>
        <div class="row g-2 mb-2" v-if="editForm.acquisition_type && editForm.acquisition_type!=='born_on_farm'">
          <div class="col-6"><label class="ad-label">Acquired Date *</label><input v-model="editForm.acquisition_date" class="ad-input w-100" type="date" :max="todayStr" /></div>
          <div class="col-6"><label class="ad-label">Purchase Price (KES)</label><input v-model="editForm.acquisition_price" class="ad-input w-100" type="number" step="1" placeholder="e.g. 300000" /></div>
        </div>

        <div class="mb-2" style="padding:10px;border-radius:8px;border:1px solid var(--fm-br,#1E1E1E);background:var(--fm-bg3,#1E1E1E);display:flex;align-items:center;justify-content:space-between;gap:10px;">
          <div>
            <label class="ad-label" style="color:#BFA164;font-weight:600;">Status</label>
            <div class="text-capitalize" style="color:var(--fm-h,#F5F0E8);font-size:13px;font-weight:600;">{{ (animal.status||'active').replace(/_/g,' ') }}</div>
          </div>
          <button class="btn btn-sm btn-outline-warning" style="font-size:11px;white-space:nowrap;" @click="showEditAnimal=false;tab='actions';loadPendingActions()"><i class="mdi mdi-gesture-tap-button me-1"></i>Change via Actions</button>


        </div>

        <div class="row g-2 mb-2">
          <div class="col-6"><label class="ad-label">Health Status</label>
            <select v-model="editForm.health_status" class="ad-input w-100">
              <option value="healthy">Healthy</option><option value="sick">Sick</option><option value="under_treatment">Under Treatment</option><option value="recovering">Recovering</option><option value="quarantine">Quarantine</option>
            </select>
          </div>
          <div class="col-6"><label class="ad-label">Reproductive Status</label>
            <select v-model="editForm.reproductive_status" class="ad-input w-100">
              <option value="not_applicable">N/A</option><option value="open">Open</option><option value="pregnant">Pregnant</option><option value="lactating">Lactating</option><option value="dry">Dry</option><option value="breeding_ready">Breeding Ready</option>
            </select>
          </div>
        </div>

        <div v-if="editForm.reproductive_status==='pregnant'" class="mb-2">
          <label class="ad-label">Pregnancy Due Date</label><input v-model="editForm.pregnancy_due_date" class="ad-input w-100" type="date" :min="todayStr" />
        </div>
        <div class="mb-2"><label class="ad-label">Daily Milk Yield (litres)</label><input v-model="editForm.daily_milk_yield_liters" class="ad-input w-100" type="number" step="0.1" placeholder="0.0" /></div>
        <div class="mb-3"><label class="ad-label">Notes</label><textarea v-model="editForm.notes" class="ad-input w-100" rows="2" placeholder="Any notes about this animal..."></textarea></div>


        <button class="btn btn-warning w-100 fw-bold" @click="saveEditAnimal" :disabled="processing">
          <span v-if="processing"><span class="spinner-border spinner-border-sm me-1"></span></span>
          <i v-else class="mdi mdi-content-save me-1"></i>Save Changes
        </button>
        <button class="btn btn-sm btn-link text-muted w-100 mt-1" @click="showEditAnimal=false">Cancel</button>
      </div></div>

      <!-- Sent confirmation toast -->
      <div v-if="sentToast.show" class="ad-sent-toast" @click="sentToast.show=false">
        <i class="mdi mdi-check-circle me-1" style="color:#50C878;"></i>
        Notified {{ sentToast.vetName }} — sent by app, email{{ sentToast.smsSent ? ' and SMS' : '' }}.
        <a class="ms-2" style="color:#BFA164;text-decoration:underline;cursor:pointer;" @click.stop="$router.push(sentToast.conversationId ? ('/messages/' + sentToast.conversationId) : '/messages')">Open chat</a>
      </div>

      <vet-picker-modal v-if="showVetPicker"
        :ai-summary="lastAiVetSummary()"
        :urgent="vetPickerUrgent"
        :animal-id="animal.id"
        :default-mode="vetPickerMode"
        @close="showVetPicker=false"
        @sent="onVetSent" />

    </div>
  </div>
</template>
<style>

/* === GLOBAL THEME === */
html[data-theme="light"] body { background:#FFFFFF!important; color:#1A1A1A!important; }
html[data-theme="light"] .fm-card,html[data-theme="light"] .p2c,html[data-theme="light"] .ld-section,html[data-theme="light"] .ld-action-card,html[data-theme="light"] .ld-seller-card,html[data-theme="light"] .ld-info-card,html[data-theme="light"] .ld-related-card { background:#FFFFFF!important; border-color:#E8E2DA!important; }
html[data-theme="light"] .fm-overlay .fm-modal,html[data-theme="light"] .ad-overlay .ad-modal { background:#FFFFFF!important; border-color:#E8E2DA!important; }
html[data-theme="light"] .fm-input,html[data-theme="light"] .fm-select { background:#F7F5F2!important; border-color:#E0D8D0!important; color:#1A1A1A!important; }
html[data-theme="light"] .fm-label { color:#555!important; }
html[data-theme="dark"] body { background:#0A0A0A!important; color:#F5F0E8!important; }
</style>
<style>
@keyframes aiVetUrgentPulse{0%,100%{box-shadow:0 0 0 0 rgba(255,107,107,.45)}50%{box-shadow:0 0 0 8px rgba(255,107,107,0)}}
:root{--fm-h:#F5F0E8;--fm-s:#6B6356;--fm-m:#A09888;--fm-bg1:#141414;--fm-bg2:#0F0F0F;--fm-bg3:#1E1E1E;--fm-br:#1E1E1E}
html[data-theme="light"]{--fm-h:#1A1A1A;--fm-s:#777;--fm-m:#555;--fm-bg1:#FFFFFF;--fm-bg2:#F7F5F2;--fm-bg3:#F0EBE4;--fm-br:#E8E2DA}
html[data-theme="light"] body{background:#F7F5F2!important;color:#1A1A1A!important}
html[data-theme="light"] .card{background:#FFFFFF!important;border-color:#E8E2DA!important}
html[data-theme="light"] .card-body{color:#1A1A1A!important}
html[data-theme="light"] .modal-content{background:#FFFFFF!important;border-color:#E8E2DA!important;color:#1A1A1A!important}
html[data-theme="light"] .form-control,html[data-theme="light"] .form-select{background:#FFFFFF!important;border-color:#E0D8D0!important;color:#1A1A1A!important}
html[data-theme="light"] .table{color:#1A1A1A!important}
html[data-theme="light"] .table th{color:#555!important;border-color:#E8E2DA!important}
html[data-theme="light"] .table td{border-color:#F0EBE4!important}
html[data-theme="light"] [style*="color:#F5F0E8"]{color:#1A1A1A!important}
html[data-theme="light"] [style*="color:#6B6356"]{color:#777!important}
html[data-theme="light"] [style*="color:#A09888"]{color:#555!important}
html[data-theme="light"] [style*="background:#0F0F0F"]{background:#F7F5F2!important}
html[data-theme="light"] [style*="background:#141414"]{background:#FFFFFF!important}
html[data-theme="light"] [style*="background:#1E1E1E"]{background:#F0EBE4!important}
html[data-theme="light"] [style*="background:#0A0A0A"]{background:#F7F5F2!important}
html[data-theme="light"] [style*="background:#1a1510"]{background:#FFF8F0!important}
html[data-theme="light"] [style*="background:#1A1A1A"]{background:#F0EBE4!important}
html[data-theme="light"] [style*="border:1px solid #1E1E1E"]{border-color:#E8E2DA!important}
html[data-theme="light"] [style*="border:1px solid #2A2520"]{border-color:#E0D8D0!important}
html[data-theme="light"] [style*="border-bottom:1px solid #1A1A1A"]{border-bottom-color:#F0EBE4!important}
html[data-theme="light"] [style*="border-bottom:1px solid #1E1E1E"]{border-bottom-color:#F0EBE4!important}
html[data-theme="light"] [style*="border-bottom:1px solid #2A2520"]{border-bottom-color:#E0D8D0!important}
html[data-theme="light"] [style*="border-top:1px solid #2A2520"]{border-top-color:#E0D8D0!important}
html[data-theme="light"] [style*="color:#BFA164"]{color:#BFA164!important}
html[data-theme="light"] [style*="color:#50C878"]{color:#50C878!important}
html[data-theme="light"] [style*="color:#4FC3F7"]{color:#4FC3F7!important}
html[data-theme="light"] [style*="color:#FF6B6B"]{color:#FF6B6B!important}
html[data-theme="light"] [style*="color:#FF9800"]{color:#FF9800!important}
html[data-theme="light"] [style*="color:#CE93D8"]{color:#CE93D8!important}
html[data-theme="light"] [style*="color:#3A3530"]{color:var(--fm-s,#777)!important}
html[data-theme="light"] [style*="background:#200F20"]{background:#F8F0F8!important;border-color:#CE93D8!important}
html[data-theme="light"] [style*="background:#0F200F"]{background:#F0F8F0!important;border-color:#2e7d32!important}
html[data-theme="light"] .ad-root{background:#F7F5F2!important}
html[data-theme="light"] .ad-topbar{background:rgba(255,255,255,.95)!important;border-bottom-color:#E8E2DA!important}
html[data-theme="light"] .ad-card{background:#FFFFFF!important;border-color:#E8E2DA!important}
html[data-theme="light"] .ad-qs{background:#FFFFFF!important;border-color:#E8E2DA!important}
html[data-theme="light"] .ad-act{background:#FFFFFF!important;border-color:#E8E2DA!important}
html[data-theme="light"] .ad-tab.active{background:#F0EBE4!important}
html[data-theme="light"] .ad-photo{background-color:#F0EBE4!important;border-color:#E8E2DA!important}
html[data-theme="light"] .ad-photo:hover{box-shadow:0 8px 24px rgba(191,161,100,.15)!important}
html[data-theme="light"] .ad-photo-item{border-color:#E8E2DA!important}
html[data-theme="light"] .ad-photo-item:hover{box-shadow:0 8px 30px rgba(0,0,0,.2)!important}
html[data-theme="light"] .ad-modal{background:#FFFFFF!important;border-color:#E8E2DA!important}
html[data-theme="light"] .ad-input{background:#FFFFFF!important;border-color:#E0D8D0!important;color:#1A1A1A!important}
html[data-theme="light"] .ad-suggest{background:#FFFFFF!important;border-color:#E8E2DA!important;box-shadow:0 8px 24px rgba(0,0,0,.1)!important}
html[data-theme="light"] .ad-suggest-item:hover{background:#F7F5F2!important}
html[data-theme="light"] .ad-chart{background:#F7F5F2!important}
html[data-theme="light"] .ad-report-opt:hover{background:#F7F5F2!important}
html[data-theme="light"] .ad-pa-btn{background:#FFFFFF!important;border-color:#E8E2DA!important}
html[data-theme="light"] .ad-staged-img{border-color:#E8E2DA!important}
html[data-theme="light"] .ad-staged-add{border-color:#D9D0C5!important}
html[data-theme="light"] .ad-staged-add:hover{border-color:#BFA164!important}
</style>
<style scoped>
.ad-root{background:var(--fm-bg2,#0A0A0A);min-height:100vh}.ad-topbar{position:sticky;top:0;z-index:100;background:rgba(10,10,10,.95);backdrop-filter:blur(10px);border-bottom:1px solid var(--fm-br,#1E1E1E)}.ad-back{color:var(--fm-m,#A09888);font-size:20px;text-decoration:none;margin-right:12px}.ad-title{color:var(--fm-h,#F5F0E8);font-weight:600;font-size:15px}.ad-container{padding-top:20px;padding-bottom:40px;max-width:800px}
.ad-header{display:flex;gap:16px;margin-bottom:16px;align-items:center}
.ad-photo{width:100px;height:100px;border-radius:12px;background-color:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);background-size:cover;background-position:center;display:flex;align-items:center;justify-content:center;flex-shrink:0;position:relative;cursor:pointer;overflow:hidden;transition:transform .3s ease,box-shadow .3s ease,border-color .2s}
.ad-photo:hover{transform:scale(1.15);box-shadow:0 8px 24px rgba(191,161,100,.25);border-color:#BFA164;z-index:5}
.ad-photo-hover{position:absolute;inset:0;background:rgba(0,0,0,.6);display:flex;flex-direction:column;align-items:center;justify-content:center;opacity:0;transition:opacity .2s;color:#BFA164;font-size:11px;font-weight:600;gap:2px}
.ad-photo-hover i{font-size:22px}
.ad-photo:hover .ad-photo-hover{opacity:1}
.ad-photo-change{position:absolute;bottom:4px;right:4px;width:26px;height:26px;border-radius:50%;background:rgba(191,161,100,.9);color:#0A0A0A;display:flex;align-items:center;justify-content:center;cursor:pointer;font-size:13px;opacity:0;transition:opacity .2s;z-index:2}
.ad-photo:hover .ad-photo-change{opacity:1}
.ad-header-info{flex:1}
.ad-badge{font-size:10px;padding:2px 8px;border-radius:6px;text-transform:capitalize;font-weight:600}.bg-healthy,.bg-active{background:rgba(80,200,120,.12);color:#50C878}.bg-sick,.bg-under_treatment{background:rgba(255,107,107,.12);color:#FF6B6B}.bg-quarantine{background:rgba(255,171,0,.12);color:#FFAB00}.bg-listed_for_sale{background:rgba(191,161,100,.12);color:#BFA164}
.ad-quick-stats{display:flex;gap:10px;margin-bottom:16px;flex-wrap:wrap}.ad-qs{flex:1;min-width:80px;background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:10px;padding:10px;text-align:center}.ad-qs-num{font-size:18px;font-weight:700;color:var(--fm-h,#F5F0E8)}.ad-qs-lbl{font-size:10px;color:var(--fm-s,#6B6356);text-transform:uppercase}
.ad-perf-card{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:10px;padding:14px;margin-bottom:16px;border-left:4px solid #BFA164}
.ad-perf-card.perf-star{border-left-color:#50C878;background:linear-gradient(90deg,rgba(80,200,120,.06),transparent 40%)}
.ad-perf-card.perf-on_track{border-left-color:#4FC3F7;background:linear-gradient(90deg,rgba(79,195,247,.06),transparent 40%)}
.ad-perf-card.perf-watch{border-left-color:#FF9800;background:linear-gradient(90deg,rgba(255,152,0,.08),transparent 40%)}
.ad-perf-card.perf-at_risk{border-left-color:#FF6B6B;background:linear-gradient(90deg,rgba(255,107,107,.08),transparent 40%)}
.ad-perf-card.perf-establishing,.ad-perf-card.perf-no_data{border-left-color:#6B6356}
.ad-perf-head{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:10px;gap:10px}
.ad-perf-title{font-size:13px;font-weight:700;color:var(--fm-h,#F5F0E8);text-transform:uppercase;letter-spacing:.5px}
.ad-perf-sub{font-size:11px;color:var(--fm-s,#6B6356);margin-top:2px}
.ad-perf-badge{font-size:11px;font-weight:700;padding:4px 10px;border-radius:999px;white-space:nowrap;background:rgba(191,161,100,.15);color:#BFA164}
.perf-star .ad-perf-badge{background:rgba(80,200,120,.18);color:#50C878}
.perf-on_track .ad-perf-badge{background:rgba(79,195,247,.18);color:#4FC3F7}
.perf-watch .ad-perf-badge{background:rgba(255,152,0,.18);color:#FF9800}
.perf-at_risk .ad-perf-badge{background:rgba(255,107,107,.18);color:#FF6B6B}
.ad-perf-bar-row{display:flex;align-items:center;gap:10px;margin-bottom:6px}
.ad-perf-bar{flex:1;height:8px;background:rgba(255,255,255,.06);border-radius:4px;overflow:hidden}
html[data-theme="light"] .ad-perf-bar{background:rgba(0,0,0,.06)}
.ad-perf-bar-fill{height:100%;background:#BFA164;border-radius:4px;transition:width .4s}
.perf-star .ad-perf-bar-fill{background:#50C878}
.perf-on_track .ad-perf-bar-fill{background:#4FC3F7}
.perf-watch .ad-perf-bar-fill{background:#FF9800}
.perf-at_risk .ad-perf-bar-fill{background:#FF6B6B}
.ad-perf-score{font-size:13px;font-weight:700;color:var(--fm-h,#F5F0E8);min-width:30px;text-align:right}
.ad-perf-reason{font-size:12px;color:var(--fm-m,#A09888);line-height:1.4}
html[data-theme="light"] .ad-perf-card{background:#FFFFFF!important;border-color:#E8E2DA!important}
.ad-feed-mode-toggle{display:flex;gap:0;background:var(--fm-bg2,#0F0F0F);border-radius:8px;padding:3px;margin-bottom:12px}
.ad-feed-mode{flex:1;background:transparent;border:none;color:var(--fm-m,#A09888);padding:8px 10px;font-size:12px;font-weight:600;border-radius:6px;cursor:pointer;transition:all .15s}
.ad-feed-mode.active{background:#BFA164;color:#0A0A0A}
.ad-formula-preview{background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#1E1E1E);border-radius:8px;padding:10px}
html[data-theme="light"] .ad-formula-preview{background:#F7F5F2!important;border-color:#E8E2DA!important}
.ad-formula-head{display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;padding-bottom:8px;border-bottom:1px solid var(--fm-br,#1E1E1E)}
.ad-formula-cost{font-size:11px;color:var(--fm-m,#A09888)}
.ad-formula-cost strong{color:#FF9800;font-size:13px}
.ad-formula-items{display:flex;flex-direction:column;gap:4px}
.ad-formula-item{display:flex;justify-content:space-between;font-size:11px;color:var(--fm-s,#6B6356)}
.ad-formula-item span:first-child{color:var(--fm-h,#F5F0E8)}
.ad-verdict-card{display:flex;gap:12px;align-items:flex-start;background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:10px;padding:14px;margin-bottom:12px;border-left:4px solid #6B6356}
html[data-theme="light"] .ad-verdict-card{background:#FFFFFF!important;border-color:#E8E2DA!important}
.ad-verdict-card.verdict-hold{border-left-color:#4FC3F7;background:linear-gradient(90deg,rgba(79,195,247,.06),transparent 40%)}
.ad-verdict-card.verdict-sell_soon{border-left-color:#FF9800;background:linear-gradient(90deg,rgba(255,152,0,.08),transparent 40%)}
.ad-verdict-card.verdict-sell_now{border-left-color:#50C878;background:linear-gradient(90deg,rgba(80,200,120,.08),transparent 40%)}
.ad-verdict-card.verdict-unknown{border-left-color:#6B6356}
.ad-verdict-icon{font-size:28px;line-height:1;flex-shrink:0;color:#6B6356}
.verdict-hold .ad-verdict-icon{color:#4FC3F7}
.verdict-sell_soon .ad-verdict-icon{color:#FF9800}
.verdict-sell_now .ad-verdict-icon{color:#50C878}
.ad-verdict-headline{font-size:14px;font-weight:700;color:var(--fm-h,#F5F0E8);margin-bottom:2px}
.ad-verdict-detail{font-size:12px;color:var(--fm-m,#A09888);line-height:1.4}
.ad-econ-chart-card{position:relative}
.ad-econ-legend{display:flex;gap:10px;flex-wrap:wrap;font-size:10px;color:var(--fm-m,#A09888)}
.ad-econ-leg{display:flex;align-items:center;gap:4px}
.ad-econ-swatch{display:inline-block;width:10px;height:10px;border-radius:2px}
.ad-econ-chart{position:relative;cursor:crosshair;user-select:none}
.ad-econ-grid{stroke:rgba(255,255,255,.06)}
.ad-econ-divider{stroke:rgba(255,255,255,.15)}
.ad-econ-cross{stroke:rgba(255,255,255,.3)}
.ad-econ-ax{fill:rgba(255,255,255,.55)}
html[data-theme="light"] .ad-econ-grid{stroke:rgba(0,0,0,.08)}
html[data-theme="light"] .ad-econ-divider{stroke:rgba(0,0,0,.28)}
html[data-theme="light"] .ad-econ-cross{stroke:rgba(0,0,0,.35)}
html[data-theme="light"] .ad-econ-ax{fill:rgba(0,0,0,.6)}
.ad-econ-tip{position:absolute;background:rgba(10,10,10,.95);border:1px solid #BFA164;border-radius:8px;padding:8px 10px;font-size:11px;color:var(--fm-h,#F5F0E8);min-width:170px;pointer-events:none;z-index:10;box-shadow:0 6px 24px rgba(0,0,0,.5)}
html[data-theme="light"] .ad-econ-tip{background:rgba(255,255,255,.98);color:#1A1A1A;border-color:#BFA164}
.ad-econ-tip-date{font-weight:700;font-size:11px;margin-bottom:6px;padding-bottom:5px;border-bottom:1px solid var(--fm-br,#2A2520);color:#BFA164}
.ad-econ-tip-row{display:flex;justify-content:space-between;gap:14px;margin-bottom:2px}
.ad-econ-tip-row strong{color:var(--fm-h,#F5F0E8)}
html[data-theme="light"] .ad-econ-tip-row strong{color:#1A1A1A}
.ad-econ-footnote{font-size:11px;color:var(--fm-s,#6B6356);margin-top:8px;line-height:1.5}
.ad-actions{display:flex;gap:8px;margin-bottom:16px;overflow-x:auto;padding-bottom:4px}.ad-act{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:10px;padding:10px 16px;display:flex;align-items:center;gap:6px;font-size:12px;font-weight:600;color:var(--fm-m,#A09888);cursor:pointer;white-space:nowrap;transition:border-color .2s}.ad-act:hover{border-color:#BFA164;color:var(--fm-h,#F5F0E8)}.ad-act i{font-size:18px}
.ad-tabs{display:flex;gap:4px;margin-bottom:16px;overflow-x:auto}.ad-tab{background:none;border:none;color:var(--fm-s,#6B6356);font-size:12px;font-weight:600;padding:8px 12px;border-radius:8px;cursor:pointer;white-space:nowrap}.ad-tab.active{background:var(--fm-bg3,#1E1E1E);color:#BFA164}
.ad-card{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:10px;padding:14px}.ad-card-title{color:var(--fm-h,#F5F0E8);font-size:14px;font-weight:600;margin-bottom:8px}
.ad-row{display:flex;justify-content:space-between;padding:6px 0;border-bottom:1px solid var(--fm-br,#1A1A1A);font-size:12px;color:var(--fm-m,#A09888)}.ad-row:last-child{border-bottom:none}.ad-row span:first-child{color:var(--fm-s,#6B6356)}
.ad-weight-row{display:flex;justify-content:space-between;align-items:center;padding:8px 0;border-bottom:1px solid var(--fm-br,#1A1A1A)}
.ad-weight-action{background:transparent;border:none;color:var(--fm-s,#6B6356);cursor:pointer;padding:4px 6px;border-radius:6px;font-size:16px;line-height:1;transition:all .15s}
.ad-weight-action:hover{background:rgba(191,161,100,.12);color:#BFA164}
.ad-weight-action-danger:hover{background:rgba(255,107,107,.12);color:#FF6B6B}
.ad-weight-action:disabled{opacity:.4;cursor:not-allowed}
.ad-sched-row{display:flex;align-items:center;gap:4px;padding:8px 0;border-bottom:1px solid var(--fm-br,#1A1A1A)}
.ad-sched-row:last-child{border-bottom:none}
.ad-sched-inactive{opacity:.55}
.ad-modal-danger{text-align:center;max-width:360px}
.ad-del-icon{width:56px;height:56px;border-radius:50%;background:rgba(255,107,107,.12);display:flex;align-items:center;justify-content:center;margin:0 auto 12px}
.ad-del-icon i{font-size:30px;color:#FF6B6B}
.ad-del-title{color:var(--fm-h,#F5F0E8);font-weight:700;font-size:16px;margin-bottom:10px}
.ad-del-summary{background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#2A2520);border-radius:8px;padding:10px;margin-bottom:12px;display:flex;flex-direction:column;gap:2px}
html[data-theme="light"] .ad-del-summary{background:#F7F5F2!important;border-color:#E8E2DA!important}
.ad-del-summary strong{color:var(--fm-h,#F5F0E8);font-size:18px}
.ad-del-summary span{color:var(--fm-s,#6B6356);font-size:12px}
.ad-del-warn{color:var(--fm-m,#A09888);font-size:12px;line-height:1.5;margin-bottom:14px;text-align:left}
.ad-modal-danger .ad-label{text-align:left;display:block;margin-bottom:6px}
.ad-del-btn{background:#FF6B6B;border:none;color:#fff;font-weight:600}
.ad-del-btn:hover:not(:disabled){background:#e85555;color:#fff}
.ad-del-btn:disabled{background:rgba(255,107,107,.3);color:rgba(255,255,255,.6);cursor:not-allowed}
.ad-photo-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(120px,1fr));gap:8px;overflow:visible}
.ad-photo-item-wrap{position:relative;overflow:visible}
.ad-photo-item{height:120px;border-radius:8px;background-size:cover;background-position:center;cursor:pointer;border:1px solid var(--fm-br,#1E1E1E);position:relative;transition:transform .25s ease,box-shadow .25s ease,z-index 0s}
.ad-photo-item:hover{transform:scale(1.8);z-index:50;box-shadow:0 8px 30px rgba(0,0,0,.7);border-color:#BFA164;border-radius:6px}
.ad-photo-primary{position:absolute;top:4px;left:4px;background:rgba(191,161,100,.9);color:#0A0A0A;font-size:10px;width:20px;height:20px;border-radius:50%;display:flex;align-items:center;justify-content:center}
.ad-photo-actions{display:flex;gap:4px;margin-top:4px;justify-content:center}
.ad-pa-btn{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);color:var(--fm-m,#A09888);width:28px;height:28px;border-radius:6px;cursor:pointer;display:flex;align-items:center;justify-content:center;font-size:13px;transition:all .2s}
.ad-pa-btn:hover{border-color:#BFA164;color:#BFA164}
.ad-pa-del:hover{border-color:#FF6B6B;color:#FF6B6B}
.ad-staged-section{margin-bottom:16px}
.ad-staged-grid{display:flex;flex-wrap:wrap;gap:10px;overflow:visible}
.ad-staged-item{position:relative;overflow:visible}
.ad-staged-img{width:90px;height:90px;border-radius:8px;background-size:cover;background-position:center;border:2px solid var(--fm-br,#2A2520);position:relative;cursor:pointer}
.ad-staged-img:hover{border-color:#BFA164}
.ad-staged-rm{position:absolute;top:-6px;right:-6px;width:20px;height:20px;border-radius:50%;background:#FF6B6B;color:#fff;border:none;font-size:14px;line-height:1;display:flex;align-items:center;justify-content:center;cursor:pointer}
.ad-staged-badge{position:absolute;bottom:3px;left:3px;background:rgba(191,161,100,.9);color:#0A0A0A;font-size:8px;font-weight:700;padding:1px 5px;border-radius:3px}
.ad-staged-info{text-align:center;font-size:10px;color:var(--fm-s,#6B6356);margin-top:3px}
.ad-staged-add{width:90px;height:90px;border-radius:8px;border:2px dashed var(--fm-br,#2A2520);display:flex;flex-direction:column;align-items:center;justify-content:center;cursor:pointer;transition:border-color .2s;gap:2px}
.ad-staged-add:hover{border-color:#BFA164}
.ad-empty{color:var(--fm-s,#6B6356);font-size:13px;text-align:center;padding:20px 0}
.ad-chart{background:var(--fm-bg2,#0F0F0F);border-radius:8px;padding:12px}
.ad-overlay{position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.8);z-index:2000;display:flex;align-items:center;justify-content:center;padding:16px}
.ad-lightbox{position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.92);z-index:2500;display:flex;align-items:center;justify-content:center}
.ad-lb-img{max-width:85%;max-height:85vh;border-radius:8px;object-fit:contain;user-select:none}
.ad-lb-close{position:absolute;top:16px;right:16px;width:40px;height:40px;border-radius:50%;background:rgba(255,255,255,.1);border:none;color:#fff;font-size:22px;cursor:pointer;display:flex;align-items:center;justify-content:center;z-index:10;transition:background .2s}
.ad-lb-close:hover{background:rgba(255,255,255,.2)}
.ad-lb-nav{position:absolute;top:50%;transform:translateY(-50%);width:44px;height:44px;border-radius:50%;background:rgba(255,255,255,.1);border:none;color:#fff;font-size:26px;cursor:pointer;display:flex;align-items:center;justify-content:center;z-index:10;transition:background .2s}
.ad-lb-nav:hover{background:rgba(191,161,100,.3)}
.ad-lb-prev{left:16px}
.ad-lb-next{right:16px}
.ad-lb-counter{position:absolute;bottom:20px;left:50%;transform:translateX(-50%);background:rgba(0,0,0,.6);color:var(--fm-h,#F5F0E8);font-size:13px;font-weight:600;padding:4px 14px;border-radius:20px}.ad-modal{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:12px;padding:20px;width:100%;max-width:400px}
.ad-input{background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#2A2520);color:var(--fm-h,#F5F0E8);border-radius:8px;padding:6px 10px;font-size:13px;width:100%}.ad-input:focus{border-color:#BFA164;box-shadow:0 0 0 2px rgba(191,161,100,.15);outline:none}.ad-label{font-size:11px;font-weight:600;color:var(--fm-m,#A09888);margin-bottom:3px;display:block}
.ad-check{display:flex;align-items:center;gap:6px;color:var(--fm-h,#F5F0E8);font-size:13px;cursor:pointer;user-select:none}.ad-check input[type="checkbox"]{accent-color:#BFA164;width:16px;height:16px;cursor:pointer}
.ad-corp-pill{display:inline-flex;align-items:center;gap:6px;background:rgba(80,200,120,.12);border:1px solid rgba(80,200,120,.3);padding:4px 10px;border-radius:20px;color:#50C878;font-size:12px}
.ad-corp-search{position:relative}
.ad-corp-results{position:absolute;top:calc(100% + 4px);left:0;right:0;background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#2A2520);border-radius:8px;max-height:240px;overflow-y:auto;z-index:50;box-shadow:0 6px 24px rgba(0,0,0,.2)}
.ad-corp-row{display:flex;align-items:center;justify-content:space-between;gap:8px;padding:8px 12px;cursor:pointer}
.ad-corp-row:hover{background:rgba(191,161,100,.08)}
.ad-corp-kyc{font-size:9px;font-weight:700;padding:1px 6px;border-radius:6px;letter-spacing:.4px}
.ad-corp-kyc.kyc-verified{background:rgba(80,200,120,.16);color:#50C878}
.ad-corp-kyc.kyc-pending{background:rgba(241,180,76,.16);color:#f1b44c}
.ad-corp-kyc.kyc-rejected{background:rgba(255,107,107,.16);color:#FF6B6B}
.ad-suggest{position:absolute;left:0;right:0;top:100%;background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#2A2520);border-radius:8px;max-height:200px;overflow-y:auto;z-index:20;margin-top:2px;box-shadow:0 8px 24px rgba(0,0,0,.5)}
.ad-suggest-item{padding:8px 12px;color:var(--fm-m,#A09888);font-size:13px;cursor:pointer;border-bottom:1px solid var(--fm-br,#1A1A1A)}
.ad-suggest-item:last-child{border-bottom:none}
.ad-suggest-item:hover{background:var(--fm-bg3,#1E1E1E);color:var(--fm-h,#F5F0E8)}
.ad-report-opt{display:flex;align-items:center;justify-content:space-between;padding:8px 10px;border-bottom:1px solid var(--fm-br,#1A1A1A);border-radius:6px}
.ad-report-opt:hover{background:var(--fm-bg3,#1A1A1A)}
.ad-report-opt label{display:flex;align-items:center;gap:8px;cursor:pointer;color:var(--fm-h,#F5F0E8);font-size:13px;margin:0}
.ad-report-opt input[type="checkbox"]{accent-color:#BFA164;width:16px;height:16px;cursor:pointer}
.ad-ro-tag{font-size:9px;color:#50C878;background:rgba(80,200,120,.12);padding:2px 6px;border-radius:4px;font-weight:600}
.ad-ro-warn{font-size:9px;color:#FF9800;background:rgba(255,152,0,.12);padding:2px 6px;border-radius:4px;font-weight:600}
.ad-actions-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(210px,1fr));gap:10px;margin-top:4px}
.ad-action-card{display:flex;flex-direction:column;align-items:flex-start;gap:4px;text-align:left;background:var(--fm-bg2,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:12px;padding:14px;cursor:pointer;transition:border-color .15s}
.ad-action-card:hover{border-color:#BFA164}
.ad-action-card i{font-size:22px}
.ad-action-card span{color:var(--fm-h,#F5F0E8);font-size:13px;font-weight:700}
.ad-action-card small{color:var(--fm-s,#6B6356);font-size:11px;line-height:1.35}
.ad-sent-toast{position:fixed;left:50%;bottom:calc(24px + env(safe-area-inset-bottom, 0px));transform:translateX(-50%);background:#1E1E1E;border:1px solid #50C878;color:#F5F0E8;padding:10px 16px;border-radius:10px;font-size:12px;z-index:9998;max-width:90vw;cursor:pointer;box-shadow:0 6px 24px rgba(0,0,0,.4);}
html[data-theme="light"] .ad-sent-toast{background:#FFFFFF;color:#1A1A1A;}

/* ===== MOBILE — feels-like-an-app ===== */
@media (max-width: 768px) {
  .ad-container { padding-top: 14px; padding-bottom: calc(80px + env(safe-area-inset-bottom, 0px)); padding-left: 12px; padding-right: 12px; }
  .ad-header { gap: 10px; flex-wrap: wrap; }
  .ad-photo { width: 72px; height: 72px; border-radius: 10px; }
  .ad-quick-stats { gap: 6px; }
  .ad-qs { padding: 8px; min-width: 70px; }
  .ad-qs-num { font-size: 16px; }
  .ad-qs-lbl { font-size: 9px; line-height: 1.2; }
  .ad-perf-card { padding: 12px; }
  .ad-perf-title { font-size: 12px; }
  .ad-perf-badge { font-size: 10px; padding: 2px 8px; }
  .ad-overlay { padding: 10px; align-items: flex-end; }
  .ad-overlay > div { max-height: 90vh; overflow-y: auto; border-radius: 14px 14px 0 0; }
  .ad-sent-toast { bottom: calc(90px + env(safe-area-inset-bottom, 0px)); }
}
</style>
<script>
/* eslint-disable */
import { execute, executeJson, flocker, uploads } from "@/api";
import VetPickerModal from "@/components/flockr-vet/VetPickerModal.vue";
export default {
  name:"AnimalDetail",
  components: { VetPickerModal },
  data(){return{
    darkMode:(document.documentElement.getAttribute('data-theme')||localStorage.getItem('flockr_theme')||'dark')!=='light',
    loading:true,processing:false,uploadingPhotos:false,stagedPhotos:[],animal:{},photos:[],healthRecords:[],vaccinations:[],weightHistory:[],breedingRecords:[],tab:'info',previewIndex:null,performance:null,
    economics:null,hoverIdx:null,econChartW:720,econChartH:280,econPadL:42,econPadR:42,econPadT:18,econPadB:30,
    nfcSupported:false,showNfcAssign:false,nfcAssigning:false,nfcAssignStatus:'',nfcAssignReader:null,nfcAssignAbort:null,showManualNfc:false,manualNfcSerial:'',
    showAiVet:false,aiVetInput:'',aiVetLoading:false,aiVetMessages:[],aiVetPhoto:null,aiVetRecording:false,aiVetRecognition:null,aiVetUrgent:false,showVetPicker:false,vetPickerUrgent:false,vetPickerMode:'mine',sentToast:{show:false,vetName:'',smsSent:false},myFarms:[],
    // Actions module (issue 86) — status changes + transfer live here, maker-checker for non-owners
    showActionModal:false,actionType:'sold',actionForm:{},pendingActions:[],loadingPending:false,amOwner:null,
    actionMeta:{
      sold:{title:'Mark as Sold',icon:'mdi-cash',color:'#50C878',cta:'Record Sale'},
      deceased:{title:'Mark as Deceased',icon:'mdi-heart-broken',color:'#FF6B6B',cta:'Mark Deceased'},
      culled:{title:'Mark as Culled',icon:'mdi-alert-outline',color:'#FFAB00',cta:'Mark Culled'},
      slaughtered:{title:'Mark as Slaughtered',icon:'mdi-knife',color:'#FFAB00',cta:'Mark Slaughtered'},
      lost:{title:'Report Lost',icon:'mdi-map-marker-question-outline',color:'#FF9800',cta:'Report Lost'},
      stolen:{title:'Report Stolen',icon:'mdi-alert-circle',color:'#FF9800',cta:'Report Stolen'},
      transfer:{title:'Transfer Animal',icon:'mdi-swap-horizontal',color:'#4FC3F7',cta:'Transfer Now'}
    },
    corpSearch:'',corpResults:[],corpSearching:false,
    showEditAnimal:false,editBreedsList:[],loadingEditBreeds:false,
    // Sire/dam picker source — populated on modal open. Filtered client-side per species+sex.
    farmAnimalsForPedigree:[],loadingPedigree:false,
    editForm:{name:'',tag_number:'',anitrac_id:'',sex:'',date_of_birth:'',weight_kg:'',birth_weight_kg:'',weaning_date:'',weaning_weight_kg:'',body_condition_score:'',height_cm:'',color_markings:'',breed_id:'',sire_id:'',dam_id:'',is_pedigree:false,pedigree_number:'',microchip_number:'',acquisition_type:'',acquisition_date:'',acquisition_price:'',acquisition_source:'',health_status:'',reproductive_status:'',pregnancy_due_date:'',daily_milk_yield_liters:'',notes:''},
    // Record-offspring modal state
    showRecordOffspring:false, offspringBreedingId:'', offspringBirthDate:new Date().toISOString().split('T')[0], offspringDraft:[{tag:'',sex:'unknown',birthWeightKg:'',name:''}],
    showWeightModal:false,newWeight:'',weightDate:new Date().toISOString().split('T')[0],weightMethod:'scale',editingWeightId:null,
    showDeleteWeightModal:false,deleteWeightTarget:null,deleteConfirmText:'',
    showHealthModal:false,editingHealthId:null,newHealth:{title:'',recordType:'illness',diagnosis:'',treatment:'',symptoms:'',medications:'',severity:'',outcome:'',followUpDate:'',cost:'',recordDate:new Date().toISOString().split('T')[0]},showHealthSuggestions:false,showDiagSuggest:false,showTreatSuggest:false,
    showDeleteHealthModal:false,deleteHealthTarget:null,deleteHealthConfirmText:'',
    healthTitleOptions:[
      'Bloat treatment','East Coast Fever (ECF)','Foot & Mouth Disease (FMD)','Lumpy Skin Disease (LSD)','Anaplasmosis','Babesiosis (Redwater)',
      'Trypanosomosis (Nagana)','Mastitis treatment','Milk fever (Hypocalcaemia)','Pneumonia','Diarrhoea/Scours','Eye infection (Pink eye)',
      'Retained placenta','Dystocia (Difficult birth)','Tick infestation','Mange/Skin condition','Hoof trimming','Wound treatment',
      'Abscess drainage','Dehorning','Castration','Routine checkup','Pregnancy check','Body condition scoring',
      'Deworming','Dipping/Spraying','Mineral deficiency','Ketosis','Acidosis (Grain overload)','Blackleg','Anthrax treatment',
      'Brucellosis test','TB test','Calf scours','Navel ill (Omphalitis)','Coccidiosis','Heartwater','Rift Valley Fever',
      'Ringworm','Warts removal','Fracture/Lameness','Poisoning treatment','Snakebite treatment','Heat stress','Fly strike (Myiasis)',
      'Contagious Bovine Pleuropneumonia (CBPP)','Contagious Caprine Pleuropneumonia (CCPP)','Bovine Viral Diarrhoea (BVD)',
      'Infectious Bovine Rhinotracheitis (IBR)','Malignant Catarrhal Fever (MCF)','Ephemeral Fever (3-day sickness)',
      'Newcastle Disease','Fowl pox','Gumboro (IBD)','Goat pox','Sheep pox','Orf (Sore mouth)',
      'Footrot','Wooden tongue','Lumpy jaw','Tetanus','Johne\'s Disease','Enterotoxaemia','Leptospirosis',
      'Salmonellosis','E. coli infection','Pasteurellosis','Botulism','Rabies exposure',
      'Liver fluke (Fascioliasis)','Lungworm','Roundworm','Tapeworm','Theileriosis','Lice infestation',
      'Metritis','Prolapsed uterus','Vaginal prolapse','Abortion','Infertility workup','Ovarian cyst',
      'Pregnancy toxaemia','Agalactia (No milk)','Twinning complications','Stillbirth',
      'Displaced abomasum','Foreign body (Hardware disease)','Constipation','Impaction','Plant poisoning','Aflatoxin exposure',
      'Bronchitis','Nasal discharge','Coughing/Respiratory distress','Shipping fever',
      'Joint swelling','Hip dislocation','Hoof crack','Hoof abscess','Back injury','Muscle tear','Arthritis',
      'Ear infection','Skin allergy','Photosensitization','Sunburn','Horn injury','Tail injury',
      'Vitamin deficiency','Anaemia','Dehydration','White muscle disease','Grass tetany','Copper deficiency',
      'Zinc deficiency','Phosphorus deficiency','Selenium deficiency',
      'Tail docking','Ear tagging','Microchipping','Rumen trocar (Emergency bloat)','Caesarean section',
      'Teat surgery','Hernia repair','Tumour removal','Hoof resection','Beak trimming',
      'Fertility assessment','Pre-breeding exam','Post-calving check','Calf health check','Annual health screening',
      'Pre-sale examination','Pour-on treatment','Acaricide application','Fly control',
      'Egg drop syndrome','Chronic Respiratory Disease (CRD)','Egg binding','Crop impaction','Bumblefoot',
      'Urinary calculi','Scald (Interdigital dermatitis)','Dog bite wound','Predator attack injury',
      'Transport stress','Post-vaccination reaction','Unknown illness'
    ],
    diagnosisOptions:[
      'Theileria parva infection','Anaplasma marginale','Babesia bigemina','Babesia bovis','Ehrlichia ruminantium',
      'FMD virus confirmed','Lumpy skin disease virus','Rift Valley Fever virus','BVD virus','IBR virus (BoHV-1)',
      'MCF virus','Ephemeral fever virus','Newcastle Disease virus',
      'Bacillus anthracis (Anthrax)','Clostridium chauvoei (Blackleg)','Brucella abortus','Mycobacterium bovis (TB)',
      'Mycoplasma mycoides (CBPP)','Pasteurella multocida','Salmonella spp.','E. coli (pathogenic)',
      'Fusobacterium necrophorum (Footrot)','Actinobacillus lignieresii','Clostridium tetani',
      'Clostridium perfringens (Enterotoxaemia)','Staphylococcus aureus (Mastitis)','Streptococcus agalactiae (Mastitis)',
      'Trypanosoma congolense','Trypanosoma vivax','Eimeria spp. (Coccidiosis)',
      'Fasciola hepatica (Liver fluke)','Fasciola gigantica','Haemonchus contortus (Barber pole worm)',
      'Dictyocaulus viviparus (Lungworm)','Moniezia spp. (Tapeworm)','Sarcoptes scabiei (Mange)',
      'Trichophyton verrucosum (Ringworm)','Dermatophilus congolensis',
      'Hypocalcaemia (Milk fever)','Ketosis/Acetonaemia','Hypomagnesaemia (Grass tetany)','Ruminal acidosis',
      'Copper deficiency','Selenium deficiency','Phosphorus deficiency','Vitamin A deficiency','Vitamin E deficiency',
      'Iron deficiency anaemia','Dehydration','Electrolyte imbalance',
      'Acute mastitis','Chronic mastitis','Subclinical mastitis','Acute metritis','Chronic endometritis',
      'Retained fetal membranes','Uterine prolapse','Ovarian cyst (follicular)','Pyometra','Fetal malpresentation',
      'Ruminal tympany (Bloat)','Grain overload','Traumatic reticuloperitonitis (Hardware)','Abomasal displacement',
      'Intestinal obstruction','Liver abscess','Aflatoxicosis','Plant toxicosis',
      'Bacterial pneumonia','Viral pneumonia','Aspiration pneumonia',
      'Fracture','Septic arthritis','Sole ulcer','White line disease','Digital dermatitis','Laminitis',
      'Laceration','Puncture wound','Abscess','Haematoma','Papillomatosis (Warts)',
      'Infectious keratoconjunctivitis (Pink eye)','Corneal ulcer','Conjunctivitis',
      'Snakebite envenomation','Stress syndrome','No definitive diagnosis','Pending lab results',
      'Normal — no abnormalities found','Pregnant confirmed','Not pregnant','Body condition score: Poor',
      'Body condition score: Moderate','Body condition score: Good','Body condition score: Obese'
    ],
    treatmentOptions:[
      'Oxytetracycline (LA) 20mg/kg IM','Oxytetracycline 10% IV/IM','Penicillin-Streptomycin IM','Amoxicillin 15mg/kg IM',
      'Trimethoprim-Sulfa oral/IM','Gentamicin IM','Tylosin 10mg/kg IM','Enrofloxacin 5mg/kg IM/SC',
      'Florfenicol 20mg/kg IM','Ceftiofur 1mg/kg IM','Tulathromycin 2.5mg/kg SC','Sulphadimidine 33% IV',
      'Metronidazole oral','Doxycycline oral',
      'Ivermectin 1% SC (0.2mg/kg)','Ivermectin pour-on','Albendazole 10% oral','Fenbendazole oral',
      'Levamisole oral/SC','Praziquantel oral','Triclabendazole (Fluke)','Closantel oral',
      'Diminazene aceturate (Berenil) 3.5mg/kg IM','Isometamidium chloride (Samorin) 0.5mg/kg IM',
      'Buparvaquone (Butalex) 2.5mg/kg IM','Imidocarb dipropionate SC',
      'Flunixin meglumine (Banamine) 1.1mg/kg IV','Meloxicam 0.5mg/kg SC','Ketoprofen 3mg/kg IV/IM',
      'Dexamethasone IV/IM','Prednisolone IM','Phenylbutazone oral',
      'Amitraz dip/spray','Cypermethrin pour-on/spray','Deltamethrin pour-on','Fipronil spray','Coumaphos dip',
      'Calcium borogluconate IV (Milk fever)','Magnesium sulphate IV/SC','Dextrose 50% IV','Vitamin B complex IM',
      'Vitamin AD3E IM','Iron dextran IM','Copper glycinate SC','Multivitamin injection',
      'Electrolyte solution oral','Oral rehydration salts (ORS)','Sodium bicarbonate oral',
      'Oxytocin 10-20 IU IM/IV','Prostaglandin F2a (Lutalyse) IM','GnRH (Cystorelin) IM',
      'Intrauterine antibiotic pessary','Teat sealant (dry cow)','Intramammary antibiotic (lactating)',
      'Intramammary antibiotic (dry cow)','Manual removal of placenta','Uterine lavage',
      'Wound cleaning + suturing','Wound debridement + antiseptic','Abscess lancing + drainage + flushing',
      'Trocar and cannula (Emergency bloat)','Rumenotomy','Caesarean section',
      'Hoof trimming + copper sulphate foot bath','Hoof block application',
      'Castration (Burdizzo)','Castration (surgical)','Dehorning (caustic paste)','Dehorning (hot iron)',
      'Ear tagging','Splint/bandage application',
      'Wound spray (Oxytetracycline/Gentian violet)','Tincture of iodine application','Hydrogen peroxide wash',
      'Potassium permanganate wash','Copper sulphate foot bath','Eye ointment (Terramycin)',
      'Antifungal ointment (Ringworm)','Silver sulfadiazine cream','Stockholm tar application',
      'IV fluid therapy (Ringers lactate)','IV fluid therapy (Normal saline)','Blood transfusion',
      'Rumen transfaunation','Stomach tubing (Oral drench)','Activated charcoal oral (Poisoning)',
      'Rest and isolation','Shade and cool water (Heat stress)','Nutritional support/High energy feed',
      'Deworming - Albendazole 10ml/50kg oral','Deworming - Ivermectin 1ml/50kg SC','Deworming - Levamisole 1ml/10kg oral',
      'Observation and monitoring','Referred to veterinarian','Culling recommended',
      'Antihistamine IM (Allergic reaction)','Adrenaline SC/IM (Anaphylaxis)','Antivenom IV (Snakebite)',
      'FMD vaccine administered','LSD vaccine administered','Blackleg vaccine (Blanthax)',
      'Anthrax vaccine (Sterne)','CBPP vaccine','ECF immunization (Muguga cocktail)',
      'No treatment required','Palliative care only'
    ],
    showVaxModal:false,editingVaxId:null,newVax:{vaccineName:'',vaccineBrand:'',batchNumber:'',diseaseTarget:'',dosage:'',route:'injection',nextDueDate:'',cost:'',certificateUrl:'',administeredDate:new Date().toISOString().split('T')[0]},showVaxNameSuggest:false,showVaxDiseaseSuggest:false,showVaxDoseSuggest:false,
    showDeleteVaxModal:false,deleteVaxTarget:null,deleteVaxConfirmText:'',
    showDeletePhotoModal:false,deletePhotoTarget:null,
    vaccineOptions:[
      {name:'FMD Vaccine',disease:'Foot & Mouth Disease',dose:'2ml SC',interval:'6 months'},
      {name:'LSD Vaccine (Neethling)',disease:'Lumpy Skin Disease',dose:'1ml SC',interval:'Annual'},
      {name:'Blanthax (Blackleg)',disease:'Blackleg/Clostridial',dose:'2ml SC',interval:'Annual'},
      {name:'Sterne Vaccine',disease:'Anthrax',dose:'1ml SC',interval:'Annual'},
      {name:'CBPP Vaccine (T1/44)',disease:'Contagious Bovine Pleuropneumonia',dose:'1ml SC',interval:'Annual'},
      {name:'CCPP Vaccine',disease:'Contagious Caprine Pleuropneumonia',dose:'1ml SC',interval:'Annual'},
      {name:'ECF Muguga Cocktail',disease:'East Coast Fever',dose:'1ml SC + Oxytet cover',interval:'Once (lifetime)'},
      {name:'Brucella S19 Vaccine',disease:'Brucellosis',dose:'2ml SC (heifers only)',interval:'Once (4-8 months age)'},
      {name:'Rabies Vaccine',disease:'Rabies',dose:'1ml IM',interval:'Annual'},
      {name:'Rift Valley Fever Vaccine',disease:'Rift Valley Fever',dose:'1ml SC',interval:'Annual'},
      {name:'BVD Vaccine',disease:'Bovine Viral Diarrhoea',dose:'2ml IM',interval:'Annual'},
      {name:'IBR Vaccine',disease:'Infectious Bovine Rhinotracheitis',dose:'2ml IM',interval:'Annual'},
      {name:'Bovine Ephemeral Fever Vaccine',disease:'3-Day Sickness',dose:'2ml SC',interval:'Annual'},
      {name:'Clostridial Multivalent (Covexin 8/10)',disease:'Blackleg/Enterotoxaemia/Tetanus',dose:'2ml SC',interval:'Annual + booster'},
      {name:'Tetanus Toxoid',disease:'Tetanus',dose:'1ml IM',interval:'Annual'},
      {name:'Pasteurella Vaccine',disease:'Pasteurellosis/Pneumonia',dose:'2ml SC',interval:'6 months'},
      {name:'Contagious Ecthyma (Orf) Vaccine',disease:'Orf/Sore Mouth',dose:'Scarification',interval:'Annual'},
      {name:'PPR Vaccine',disease:'Peste des Petits Ruminants',dose:'1ml SC',interval:'Every 3 years'},
      {name:'Sheep Pox Vaccine',disease:'Sheep Pox',dose:'1ml SC',interval:'Annual'},
      {name:'Goat Pox Vaccine',disease:'Goat Pox',dose:'1ml SC',interval:'Annual'},
      {name:'Newcastle Disease Vaccine (I-2/La Sota)',disease:'Newcastle Disease',dose:'Eye drop/Drinking water',interval:'3-4 months'},
      {name:'Gumboro Vaccine (IBD)',disease:'Infectious Bursal Disease',dose:'Eye drop/Drinking water',interval:'Per schedule'},
      {name:'Fowl Pox Vaccine',disease:'Fowl Pox',dose:'Wing web',interval:'Once (6-8 weeks)'},
      {name:'Marek\'s Disease Vaccine',disease:'Marek\'s Disease',dose:'0.2ml SC (day-old)',interval:'Once (day-old)'},
      {name:'Infectious Coryza Vaccine',disease:'Infectious Coryza',dose:'0.5ml IM',interval:'Per schedule'},
      {name:'Fowl Typhoid Vaccine',disease:'Fowl Typhoid/Salmonella',dose:'0.5ml SC',interval:'Per schedule'},
      {name:'Egg Drop Syndrome Vaccine',disease:'Egg Drop Syndrome',dose:'0.5ml IM',interval:'Pre-lay'},
      {name:'Infectious Bronchitis Vaccine',disease:'Infectious Bronchitis',dose:'Eye drop/Spray',interval:'Per schedule'},
      {name:'Avian Influenza Vaccine',disease:'Avian Influenza',dose:'0.5ml IM',interval:'Per schedule'},
      {name:'Canine Distemper Vaccine',disease:'Canine Distemper',dose:'1ml SC',interval:'Annual'},
      {name:'Canine Parvo Vaccine',disease:'Canine Parvovirus',dose:'1ml SC',interval:'Annual'},
      {name:'Rabies Vaccine (Canine)',disease:'Rabies',dose:'1ml IM',interval:'Annual/3-year'},
      {name:'DHLPP Multivalent (Dogs)',disease:'Distemper/Hepatitis/Lepto/Parvo/Parainfluenza',dose:'1ml SC',interval:'Annual'},
      {name:'Kennel Cough Vaccine',disease:'Bordetella/Parainfluenza',dose:'Intranasal',interval:'Annual'}
    ],
    vaxDiseaseOptions:[
      'Foot & Mouth Disease','Lumpy Skin Disease','Blackleg','Anthrax','CBPP','CCPP','East Coast Fever','Brucellosis',
      'Rabies','Rift Valley Fever','BVD','IBR','3-Day Sickness','Tetanus','Pasteurellosis','Enterotoxaemia',
      'Orf/Sore Mouth','PPR','Sheep Pox','Goat Pox','Newcastle Disease','Gumboro (IBD)','Fowl Pox',
      'Marek\'s Disease','Infectious Coryza','Fowl Typhoid','Egg Drop Syndrome','Infectious Bronchitis',
      'Avian Influenza','Canine Distemper','Canine Parvovirus','Leptospirosis','Bovine TB','Johne\'s Disease',
      'Clostridial diseases','Pneumonia','Salmonellosis','E. coli','Theileriosis','Anaplasmosis','Babesiosis',
      'Trypanosomosis','Heartwater','Dermatophilosis','Contagious Abortion'
    ],
    vaxDosageOptions:[
      '0.2ml SC','0.5ml SC','0.5ml IM','1ml SC','1ml IM','2ml SC','2ml IM','3ml SC','5ml SC','5ml IM',
      '1ml SC + Oxytetracycline cover','Eye drop','Drinking water','Wing web stab','Intranasal spray',
      'Scarification','0.5ml/bird IM','1ml/bird SC','Per manufacturer label','As directed by vet'
    ],
    showBreedModal:false,editingBreedId:null,newBreed:{method:'natural',maleAnimalId:'',semenSource:'',breedingDate:new Date().toISOString().split('T')[0],expectedDueDate:'',actualBirthDate:'',pregnancyConfirmed:false,pregnancyConfirmedDate:'',complications:'',cost:'',notes:'',outcome:'pending'},showSemenSuggest:false,showBreedNoteSuggest:false,
    showDeleteBreedModal:false,deleteBreedTarget:null,deleteBreedConfirmText:'',
    showEditFeedModal:false,editFeed:{id:'',feedType:'',quantityKg:'',cost:'',feedDate:'',notes:''},showDeleteFeedModal:false,deleteFeedTarget:null,deleteFeedConfirmText:'',
    auditTrail:[],loadingAudit:false,
    milkRecords:[],loadingMilk:false,milkTotal:0,milkLast7:0,showMilkModal:false,editingMilkId:null,newMilk:{session:'morning',quantityLiters:'',qualityGrade:'',fatContentPct:'',recordDate:new Date().toISOString().split('T')[0]},showDeleteMilkModal:false,deleteMilkTarget:null,deleteMilkConfirmText:'',
    feedingSchedules:[],showScheduleModal:false,editingScheduleId:null,newSchedule:{formulationId:'',feedType:'',quantityKg:'',frequency:'twice_daily',startDate:new Date().toISOString().split('T')[0],endDate:'',specialInstructions:''},showDeleteScheduleModal:false,deleteScheduleTarget:null,deleteScheduleConfirmText:'',
    showFeedModal:false,newFeed:{mode:'formulation',formulationId:'',rationMultiplier:1,feedType:'',quantityKg:'',cost:'',notes:'',feedDate:new Date().toISOString().split('T')[0]},showFeedSuggest:false,showFeedNoteSuggest:false,feedingLogs:[],loadingFeed:false,formulationsList:[],formulationItems:[],loadingFormulations:false,
    feedNoteOptions:[
      'Morning feed','Afternoon feed','Evening feed','Night feed',
      'Supplementary feed — low body condition','Supplementary feed — pregnant cow','Supplementary feed — lactating cow',
      'Post-calving recovery feed','Calf weaning feed','High protein supplement','Energy boost — molasses + grain',
      'Pre-market fattening','Flushing feed (pre-breeding)','Dry season supplementation','Drought emergency feed',
      'Fresh pasture — rotational grazing','Zero grazing — cut & carry','Hay ration — dry season',
      'Silage ration — morning','Silage ration — evening','Mineral lick provided','Salt block placed',
      'Vitamin/mineral drench given','Electrolytes added to water','Probiotics added to feed',
      'Special diet — recovering from illness','Special diet — post-surgery','Special diet — underweight animal',
      'Medicated feed — antibiotics mixed','Medicated feed — dewormer mixed','Reduced ration — overweight',
      'Increased ration — weight gain target','Free-range foraging','Crop residue — maize stover',
      'First feed after purchase','Quarantine isolation feed','Transport recovery feed','Market preparation feed',
      'Individual special ration'
    ],
    showReportOptions:false,reportSections:{info:true,health:true,vaccinations:true,weight:true,breeding:true,feeding:false,photos:false},
    feedTypeOptions:['Dairy meal','Dairy cubes','Maize germ','Maize bran','Wheat bran','Pollard','Cotton seed cake','Sunflower cake','Soya bean meal','Fishmeal','Molasses','Hay (Rhodes grass)','Hay (Lucerne/Alfalfa)','Hay (Oat)','Silage (Maize)','Silage (Napier)','Napier grass (Fresh)','Boma Rhodes (Fresh)','Kikuyu grass','Star grass','Desmodium','Sweet potato vines','Calliandra','Leucaena','Mineral salt block','Mineral premix','DCP (Di-Calcium Phosphate)','Salt (Plain)','Boma lick','Urea-molasses block','Calf starter','Calf pellets','Grower pellets','Finisher pellets','Layer mash','Layer pellets','Chick mash','Broiler starter','Broiler finisher','Kienyeji mash','Goat pellets','Sheep pellets','Pig grower','Pig finisher','Water (clean)','Electrolytes in water','Vitamin/mineral drench','Probiotics','Apple cider vinegar'],
    semenSourceOptions:[
      'KAGRC (Kenya Animal Genetic Resources Centre)','CAIS (Central AI Station)','ABS Global','Semex','CRV','Genus/ABS',
      'WWS (World Wide Sires)','Select Sires','Genex/CRI','Viking Genetics','LIC (NZ)','Cogent','NAGRK',
      'Local AI technician','Private bull owner','Own bull on farm','Neighbour\'s bull','Borrowed bull',
      'Bull from livestock market','Sahiwal bull (KAGRC)','Friesian bull (KAGRC)','Ayrshire bull (KAGRC)',
      'Jersey semen (ABS)','Holstein semen (Semex)','Boran bull','Gyr semen (imported)','Fleckvieh semen',
      'Simmental semen','Brown Swiss semen','Hereford semen','Angus semen','Brahman semen',
      'Dorper ram','Red Maasai ram','Suffolk ram','Hampshire ram','Boer goat buck','Galla goat buck',
      'Toggenburg buck','Alpine buck','Saanen buck'
    ],
    breedNoteOptions:[
      'Standing heat confirmed','Heat detected by bull','Heat detected by observation','Mucus discharge observed',
      'Repeat service (2nd attempt)','Repeat service (3rd attempt)','Synchronized heat (CIDR + PGF2α)',
      'Synchronized heat (OvSynch protocol)','Natural service — bull confirmed mounting','Natural service — observed tie',
      'AI performed by technician','AI performed by farm owner','AI with sexed semen (female)','AI with sexed semen (male)',
      'Embryo transfer — fresh embryo','Embryo transfer — frozen embryo','Pregnancy confirmed by palpation',
      'Pregnancy confirmed by ultrasound','Pregnancy confirmed by blood test','Not confirmed yet — check in 21 days',
      'Failed — cow returned to heat','Failed — no conception','Successful — pregnant confirmed',
      'Twin pregnancy detected','Difficult service — required restraint','First breeding — heifer',
      'First breeding — maiden doe/ewe','Post-calving first service','60 days post-calving service',
      'Short estrus — early insemination','Late insemination','Multiple sires exposed (group mating)',
      'Bull soundness exam done','Cervical mucus clear','Cervical mucus cloudy — possible infection',
      'Vulva swollen — strong heat signs','Quiet heat — no strong signs','Split dose AI attempted',
      'Laparoscopic AI (sheep/goat)','Pen mating — group exposure','Hand mating — controlled'
    ],
    chartW:400,chartH:180}},
  computed:{
    todayStr(){var d=new Date();d.setMinutes(d.getMinutes()-d.getTimezoneOffset());return d.toISOString().split("T")[0]},
    // Sire/dam picker filters — same species as this animal, exclude self, sex-appropriate.
    // Includes all statuses (sold/deceased parents remain valid lineage entries).
    pedigreeSireOptions(){
      var self = this; var sp = this.animal && this.animal.species_id;
      return (this.farmAnimalsForPedigree||[]).filter(function(x){
        return x && x.id !== (self.animal && self.animal.id)
          && String(x.species_id) === String(sp)
          && x.sex === 'male';
      });
    },
    pedigreeDamOptions(){
      var self = this; var sp = this.animal && this.animal.species_id;
      return (this.farmAnimalsForPedigree||[]).filter(function(x){
        return x && x.id !== (self.animal && self.animal.id)
          && String(x.species_id) === String(sp)
          && x.sex === 'female';
      });
    },
    perfBadgeLabel(){if(!this.performance)return '';var m={star:'Star Performer',on_track:'On Track',watch:'Watch',at_risk:'At Risk',establishing:'Establishing baseline',no_data:'No data yet'};return m[this.performance.badge]||this.performance.badge},
    perfCohortLabel(){if(!this.performance||!this.performance.cohort_key)return 'Compared with similar animals on your farm';var parts=String(this.performance.cohort_key).split(':');var spMap={'1':'Cattle','2':'Goats','3':'Sheep','4':'Pigs','5':'Camels','6':'Donkeys','7':'Chickens'};var sp=spMap[parts[0]]||'Animals';var band=parts[1]==='unknown'?'age unknown':parts[1];var sex=parts[2]&&parts[2]!=='unknown'?parts[2]:'';return sp+' • '+band+(sex?' • '+sex:'')},
    perfBarWidth(){if(!this.performance||this.performance.composite_score===null||this.performance.composite_score===undefined)return 0;return Math.max(2,Math.min(100,Number(this.performance.composite_score)))},
    selectedFormulation(){if(!this.newFeed.formulationId)return null;var self=this;return this.formulationsList.find(function(f){return String(f.id)===String(self.newFeed.formulationId)})||null},
    scaledCost(){if(!this.selectedFormulation)return 0;return(Number(this.selectedFormulation.daily_cost_kshs)*Number(this.newFeed.rationMultiplier||1)).toFixed(2)},
    canSubmitFeed(){if(this.newFeed.mode==='formulation')return!!this.newFeed.formulationId&&!!this.newFeed.feedDate;return!!this.newFeed.feedType&&!!this.newFeed.quantityKg&&!!this.newFeed.feedDate},
    hasProfit(){return !!(this.economics && this.economics.acquisition_price_kshs && this.economics.acquisition_price_kshs > 0)},
    econSeries(){
      // Build a daily-sampled time series from first-known event to projected end.
      var e = this.economics; if (!e) return [];
      var wPoints = (e.weight_points || []).map(function(p){return{date:new Date(p.recorded_at),v:Number(p.weight_kg)}});
      var cPoints = (e.cost_points  || []).map(function(p){return{date:new Date(p.date),v:Number(p.cumulative_feed_cost_kshs)}});
      if (wPoints.length === 0) return [];
      wPoints.sort(function(a,b){return a.date - b.date});
      cPoints.sort(function(a,b){return a.date - b.date});
      var firstDate = wPoints[0].date;
      var today = new Date(); today.setHours(0,0,0,0);
      var lastKnown = wPoints[wPoints.length-1].date > today ? wPoints[wPoints.length-1].date : today;
      var kpd = Number(e.actual_kg_per_day || e.target_kg_per_day || 1.0);
      var currentW = wPoints[wPoints.length-1].v;
      var targetW = Number(e.target_weight_kg || (currentW + 100));
      var daysToTarget = kpd > 0 ? Math.max(0, Math.ceil((targetW - currentW) / kpd)) : 0;
      var projEnd = new Date(lastKnown.getTime() + daysToTarget * 86400000);
      // Cap horizon to 365 days from today to keep chart sane
      var maxHorizon = new Date(today.getTime() + 365 * 86400000);
      if (projEnd > maxHorizon) projEnd = maxHorizon;
      // Daily series
      var sale = Number(e.sale_target_kshs_per_kg || 300);
      var dailyFeed = Number(e.daily_feed_cost_kshs || 0);
      var acq = Number(e.acquisition_price_kshs || 0);
      var alreadyInvested = Number(e.total_feed_cost_kshs || 0);
      var series = [];
      var msDay = 86400000;
      var totalDays = Math.ceil((projEnd - firstDate) / msDay);
      if (totalDays <= 0) totalDays = 1;
      // Pre-build day-to-weight interpolator from known weight points
      function interpW(d){
        if (d <= wPoints[0].date) return wPoints[0].v;
        if (d >= wPoints[wPoints.length-1].date) return wPoints[wPoints.length-1].v;
        for (var i=1;i<wPoints.length;i++){
          if (d <= wPoints[i].date){
            var a = wPoints[i-1], b = wPoints[i];
            var t = (d - a.date) / (b.date - a.date);
            return a.v + (b.v - a.v) * t;
          }
        }
        return wPoints[wPoints.length-1].v;
      }
      function cumCostAt(d){
        if (cPoints.length === 0) return 0;
        if (d <= cPoints[0].date) return 0;
        if (d >= cPoints[cPoints.length-1].date) return cPoints[cPoints.length-1].v;
        for (var i=1;i<cPoints.length;i++){
          if (d <= cPoints[i].date){
            var a = cPoints[i-1], b = cPoints[i];
            var t = (d - a.date) / (b.date - a.date);
            return a.v + (b.v - a.v) * t;
          }
        }
        return cPoints[cPoints.length-1].v;
      }
      var lastWeightDate = wPoints[wPoints.length-1].date;
      for (var i=0;i<=totalDays;i++){
        var d = new Date(firstDate.getTime() + i * msDay);
        var isFuture = d > today;
        var w; var inv;
        if (d <= lastWeightDate){
          w = interpW(d);
          inv = acq + cumCostAt(d);
        } else {
          var daysSinceLastWeight = (d - lastWeightDate) / msDay;
          w = Math.min(targetW, currentW + daysSinceLastWeight * kpd);
          var daysSinceToday = Math.max(0, (d - today) / msDay);
          inv = acq + alreadyInvested + daysSinceToday * dailyFeed;
        }
        var asset = w * sale;
        var profit = asset - inv;
        series.push({date:d, weight:w, invested:inv, asset:asset, profit:profit, future:isFuture});
      }
      return series;
    },
    econTodayIdx(){
      if (!this.econSeries.length) return 0;
      var today = new Date(); today.setHours(0,0,0,0);
      var idx = 0;
      for (var i=0;i<this.econSeries.length;i++){
        if (this.econSeries[i].date <= today) idx = i;
      }
      return idx;
    },
    econTodayX(){return this.econXAt(this.econTodayIdx)},
    peakIdx(){
      if (!this.hasProfit || !this.econSeries.length) return null;
      var best = 0;
      for (var i=1;i<this.econSeries.length;i++){
        if (this.econSeries[i].profit > this.econSeries[best].profit) best = i;
      }
      return best;
    },
    econDomain(){
      if (!this.econSeries.length) return {wMin:0,wMax:1,kMin:0,kMax:1};
      var ws = this.econSeries.map(function(s){return s.weight});
      var ks = [];
      var self = this;
      this.econSeries.forEach(function(s){ks.push(s.invested);ks.push(s.asset);if(self.hasProfit)ks.push(s.profit)});
      var wMin = Math.min.apply(null, ws), wMax = Math.max.apply(null, ws);
      var kMin = Math.min.apply(null, ks), kMax = Math.max.apply(null, ks);
      var wPad = (wMax-wMin) * 0.08 || 5;
      var kPad = (kMax-kMin) * 0.08 || 100;
      return {wMin:wMin-wPad, wMax:wMax+wPad, kMin:Math.min(0,kMin-kPad), kMax:kMax+kPad};
    },
    econZeroY(){
      var d = this.econDomain;
      var plotH = this.econChartH - this.econPadT - this.econPadB;
      return this.econPadT + plotH * (1 - (0 - d.kMin) / (d.kMax - d.kMin));
    },
    econGridY(){
      var d = this.econDomain;
      var lines = 5;
      var out = [];
      var plotH = this.econChartH - this.econPadT - this.econPadB;
      for (var i=0;i<=lines;i++){
        var frac = i / lines;
        var y = this.econPadT + plotH * frac;
        var weight = d.wMax - frac * (d.wMax - d.wMin);
        var ksh = d.kMax - frac * (d.kMax - d.kMin);
        out.push({y: y, weightLabel: weight.toFixed(0) + 'kg', kshLabel: Math.abs(ksh) >= 1000 ? (ksh/1000).toFixed(0)+'K' : ksh.toFixed(0)});
      }
      return out;
    },
    econTipStyle(){
      if (this.hoverIdx === null) return {};
      var totalW = this.econChartW;
      var x = this.econXAt(this.hoverIdx);
      var leftSide = (x / totalW) > 0.6;
      var pctX = (x / totalW) * 100;
      return {
        left: leftSide ? 'auto' : (pctX + 2) + '%',
        right: leftSide ? (100 - pctX + 2) + '%' : 'auto',
        top: '10px'
      };
    },
    profitVerdict(){
      if (!this.economics) return null;
      var s = this.econSeries;
      if (!s || !s.length) return null;
      if (!this.hasProfit) {
        return { action: 'unknown', headline: 'Set acquisition price to enable verdict', detail: 'We need what you paid for this animal to calculate true profit.' };
      }
      var todayIdx = this.econTodayIdx;
      var peak = this.peakIdx;
      var todayProfit = s[todayIdx].profit;
      var peakProfit = s[peak].profit;
      var msDay = 86400000;
      var fmt = function(n){return 'Ksh ' + Math.round(n).toLocaleString()};
      if (peak < todayIdx) {
        var daysPast = Math.round((s[todayIdx].date - s[peak].date) / msDay);
        return {
          action: 'sell_now',
          headline: 'Past peak — sell now',
          detail: 'This animal hit peak profit ' + daysPast + ' days ago (' + fmt(peakProfit) + '). Every additional day is now a loss.'
        };
      }
      if (peak === todayIdx) {
        return {
          action: 'sell_now',
          headline: 'Peak profit reached — sell',
          detail: 'Current profit is ' + fmt(todayProfit) + '. From here, additional feeding costs outpace weight gain.'
        };
      }
      var daysToPeak = Math.round((s[peak].date - s[todayIdx].date) / msDay);
      if (daysToPeak <= 21) {
        return {
          action: 'sell_soon',
          headline: 'Sell in ~' + daysToPeak + ' days',
          detail: 'Projected peak profit: ' + fmt(peakProfit) + ' (today: ' + fmt(todayProfit) + '). Plan the offload window now.'
        };
      }
      return {
        action: 'hold',
        headline: 'Hold — peak ' + daysToPeak + ' days out',
        detail: 'Profit today: ' + fmt(todayProfit) + '. Projected peak: ' + fmt(peakProfit) + ' on ' + s[peak].date.toLocaleDateString('en-KE',{day:'numeric',month:'short'}) + '.'
      };
    },
    themePageStyle(){return this.darkMode?'background:#0A0A0A;min-height:100vh;color:#F5F0E8;':'background:#F7F5F2;min-height:100vh;color:#1A1A1A;'},
    themeCardStyle(){return this.darkMode?'background:#141414!important;border:1px solid #1E1E1E!important;':'background:#FFFFFF!important;border:1px solid #E8E2DA!important;'},
    themeInputStyle(){return this.darkMode?'background:#0F0F0F;border:1px solid #2A2520;color:#F5F0E8;':'background:#FFFFFF;border:1px solid #E0D8D0;color:#1A1A1A;'},

    primaryPhoto(){if(!this.photos.length)return null;var url=this.photos[0].photo_url;if(!url)return null;if(url.startsWith&&url.startsWith('http'))return url;return uploads+String(url).replace('uploads/','')},
    allPreviewPhotos(){var self=this;var list=this.photos.map(function(p){return self.photoUrl(p.photo_url)});this.stagedPhotos.forEach(function(sp){list.push(sp.preview)});return list},
    animalAge(){if(!this.animal.date_of_birth&&!this.animal.estimated_age_months)return'—';if(this.animal.estimated_age_months)return this.animal.estimated_age_months+'mo';var d=new Date(this.animal.date_of_birth);var now=new Date();var m=Math.floor((now-d)/(30.44*86400000));return m<12?m+'mo':Math.floor(m/12)+'yr '+(m%12)+'mo'},
    adg(){if(this.weightHistory.length<2)return null;var first=this.weightHistory[this.weightHistory.length-1];var last=this.weightHistory[0];var days=(new Date(last.recorded_at)-new Date(first.recorded_at))/86400000;if(days<1)return null;return((Number(last.weight_kg)-Number(first.weight_kg))/days).toFixed(2)},
    chartPoints(){if(this.weightHistory.length<2)return'';var sorted=this.weightHistory.slice().reverse();var min=Math.min.apply(null,sorted.map(function(w){return Number(w.weight_kg)}));var max=Math.max.apply(null,sorted.map(function(w){return Number(w.weight_kg)}));var range=max-min||1;var self=this;return sorted.map(function(w,i){var x=20+(i/(sorted.length-1))*(self.chartW-40);var y=self.chartH-20-((Number(w.weight_kg)-min)/range)*(self.chartH-40);return x+','+y}).join(' ')},
    chartDots(){if(this.weightHistory.length<2)return[];var sorted=this.weightHistory.slice().reverse();var min=Math.min.apply(null,sorted.map(function(w){return Number(w.weight_kg)}));var max=Math.max.apply(null,sorted.map(function(w){return Number(w.weight_kg)}));var range=max-min||1;var self=this;return sorted.map(function(w,i){return{x:20+(i/(sorted.length-1))*(self.chartW-40),y:self.chartH-20-((Number(w.weight_kg)-min)/range)*(self.chartH-40)}})},
    filteredHealthTitles(){var q=(this.newHealth.title||'').toLowerCase();if(!q)return this.healthTitleOptions.slice(0,12);return this.healthTitleOptions.filter(function(t){return t.toLowerCase().indexOf(q)!==-1}).slice(0,8)},
    filteredDiagnoses(){var q=(this.newHealth.diagnosis||'').toLowerCase();if(!q)return this.diagnosisOptions.slice(0,12);return this.diagnosisOptions.filter(function(t){return t.toLowerCase().indexOf(q)!==-1}).slice(0,8)},
    filteredTreatments(){var q=(this.newHealth.treatment||'').toLowerCase();if(!q)return this.treatmentOptions.slice(0,12);return this.treatmentOptions.filter(function(t){return t.toLowerCase().indexOf(q)!==-1}).slice(0,8)},
    filteredVaxNames(){var q=(this.newVax.vaccineName||'').toLowerCase();var list=this.vaccineOptions;if(q)list=list.filter(function(v){return v.name.toLowerCase().indexOf(q)!==-1||v.disease.toLowerCase().indexOf(q)!==-1});return list.slice(0,10)},
    filteredVaxDiseases(){var q=(this.newVax.diseaseTarget||'').toLowerCase();if(!q)return this.vaxDiseaseOptions.slice(0,12);return this.vaxDiseaseOptions.filter(function(d){return d.toLowerCase().indexOf(q)!==-1}).slice(0,8)},
    filteredVaxDosages(){var q=(this.newVax.dosage||'').toLowerCase();if(!q)return this.vaxDosageOptions;return this.vaxDosageOptions.filter(function(d){return d.toLowerCase().indexOf(q)!==-1}).slice(0,8)},
    filteredSemenSources(){var q=(this.newBreed.semenSource||'').toLowerCase();if(!q)return this.semenSourceOptions.slice(0,12);return this.semenSourceOptions.filter(function(s){return s.toLowerCase().indexOf(q)!==-1}).slice(0,8)},
    filteredBreedNotes(){var q=(this.newBreed.notes||'').toLowerCase();if(!q)return this.breedNoteOptions.slice(0,12);return this.breedNoteOptions.filter(function(n){return n.toLowerCase().indexOf(q)!==-1}).slice(0,8)},
    totalHealthCost(){var t=0;this.healthRecords.forEach(function(h){if(h.cost)t+=Number(h.cost)});return t},
    totalVaxCost(){var t=0;this.vaccinations.forEach(function(v){if(v.cost)t+=Number(v.cost)});return t},
    totalBreedCost(){var t=0;this.breedingRecords.forEach(function(b){if(b.cost)t+=Number(b.cost)});return t},
    totalFeedCost(){var t=0;this.feedingLogs.forEach(function(f){if(f.cost)t+=Number(f.cost)});return t},
    totalInvestment(){return Number(this.animal.acquisition_price||0)+this.totalHealthCost+this.totalVaxCost+this.totalBreedCost+this.totalFeedCost},
    filteredFeedTypes(){var q=(this.newFeed.feedType||'').toLowerCase();if(!q)return this.feedTypeOptions.slice(0,12);return this.feedTypeOptions.filter(function(t){return t.toLowerCase().indexOf(q)!==-1}).slice(0,8)},
    filteredFeedNotes(){var q=(this.newFeed.notes||'').toLowerCase();if(!q)return this.feedNoteOptions.slice(0,12);return this.feedNoteOptions.filter(function(n){return n.toLowerCase().indexOf(q)!==-1}).slice(0,8)}
  },
  async mounted(){
    // Apply global theme
    var t=localStorage.getItem('flockr_theme')||'dark';window.__flockrSetTheme(t);

    this.nfcSupported = ('NDEFReader' in window);
    var id=this.$route.params.id;if(id)await this.load(id);
    if(this.$route.query.action==='weight')this.showWeightModal=true;
    var self=this;
    this._onKey=function(e){
      if(self.previewIndex===null)return;
      if(e.key==='ArrowRight'&&self.previewIndex<self.allPreviewPhotos.length-1)self.previewIndex++;
      else if(e.key==='ArrowLeft'&&self.previewIndex>0)self.previewIndex--;
      else if(e.key==='Escape')self.previewIndex=null;
    };
    document.addEventListener('keydown',this._onKey);
  },
  beforeUnmount(){if(this._onKey)document.removeEventListener('keydown',this._onKey);this.stopNfcAssign()},
  methods:{
    async load(id){this.loading=true;try{
      var f=new FormData();f.append('function','getAnimalDetail');f.append('animalId',id);
      var r=await execute(f,flocker);
      if(r.data&&r.data.success&&r.data.data){var d=r.data.data;this.animal=d.animal||{};this.photos=d.animal.photos||[];this.healthRecords=d.animal.health_records||[];this.vaccinations=d.animal.vaccinations||[];this.weightHistory=d.animal.weight_history||[];this.breedingRecords=d.animal.breeding_records||[]}
    }catch(e){}this.loading=false;this.loadFeedingLogs();this.loadPerformance(id);this.loadEconomics(id);this.loadPendingActions()},
    async loadPerformance(id){try{
      var r=await executeJson({function:'getAnimalPerformanceScore',animalId:id},flocker);
      if(r.data&&r.data.success)this.performance=r.data.data&&r.data.data.score?r.data.data.score:null;
    }catch(e){this.performance=null}},
    async loadEconomics(id){try{
      var r=await executeJson({function:'getAnimalEconomics',animalId:id},flocker);
      if(r.data&&r.data.success)this.economics=r.data.data;
    }catch(e){this.economics=null}},
    econXAt(i){
      var n = this.econSeries.length;
      if (n <= 1) return this.econPadL;
      var plotW = this.econChartW - this.econPadL - this.econPadR;
      return this.econPadL + (i / (n - 1)) * plotW;
    },
    econYWeight(w){
      var d = this.econDomain;
      var plotH = this.econChartH - this.econPadT - this.econPadB;
      return this.econPadT + plotH * (1 - (w - d.wMin) / (d.wMax - d.wMin));
    },
    econYKsh(k){
      var d = this.econDomain;
      var plotH = this.econChartH - this.econPadT - this.econPadB;
      return this.econPadT + plotH * (1 - (k - d.kMin) / (d.kMax - d.kMin));
    },
    econYProfit(p){return this.econYKsh(p)},
    econPath(which, future){
      var self = this;
      var s = this.econSeries;
      if (!s.length) return '';
      var pts = [];
      var todayIdx = this.econTodayIdx;
      for (var i=0;i<s.length;i++){
        var isFut = i > todayIdx;
        if (future !== isFut) {
          // continuity: include the boundary point on both segments
          if (!(future && i === todayIdx) && !(!future && i === todayIdx+1)) continue;
        }
        var x = this.econXAt(i);
        var y;
        if (which === 'w') y = this.econYWeight(s[i].weight);
        else if (which === 'i') y = this.econYKsh(s[i].invested);
        else if (which === 'a') y = this.econYKsh(s[i].asset);
        else if (which === 'p') y = this.econYProfit(s[i].profit);
        pts.push(x + ',' + y);
      }
      return pts.join(' ');
    },
    econXDateLabel(i){
      var s = this.econSeries[i]; if (!s) return '';
      return s.date.toLocaleDateString('en-KE',{day:'numeric',month:'short',year:'2-digit'});
    },
    econFmt(n){return Math.round(n).toLocaleString('en-KE')},
    onChartMove(ev){
      var rect = ev.currentTarget.getBoundingClientRect();
      var xPx = ev.clientX - rect.left;
      var ratio = xPx / rect.width * this.econChartW;
      this.hoverIdx = this.econNearestIdx(ratio);
    },
    onChartTouch(ev){
      if (!ev.touches || !ev.touches.length) return;
      var rect = ev.currentTarget.getBoundingClientRect();
      var xPx = ev.touches[0].clientX - rect.left;
      var ratio = xPx / rect.width * this.econChartW;
      this.hoverIdx = this.econNearestIdx(ratio);
    },
    econNearestIdx(svgX){
      var n = this.econSeries.length;
      if (n === 0) return null;
      var plotW = this.econChartW - this.econPadL - this.econPadR;
      var t = (svgX - this.econPadL) / plotW;
      var idx = Math.round(t * (n - 1));
      return Math.max(0, Math.min(n - 1, idx));
    },
    weightMethodLabel(m){var d={scale:'Scale',weigh_tape:'Weigh Tape',visual_estimate:'Visual Estimate',estimate:'Estimate',ai_estimate:'AI Estimate'};return d[m]||m||'—'},
    openAddWeight(){this.editingWeightId=null;this.newWeight='';this.weightDate=new Date().toISOString().split('T')[0];this.weightMethod='scale';this.showWeightModal=true},
    openEditWeight(w){
      this.editingWeightId=w.id;
      this.newWeight=w.weight_kg;
      // recorded_at may be 'YYYY-MM-DD HH:MM:SS' — strip to date for the date input
      this.weightDate=(w.recorded_at||'').split(' ')[0].split('T')[0] || new Date().toISOString().split('T')[0];
      this.weightMethod=w.measurement_method||'scale';
      this.showWeightModal=true;
    },
    closeWeightModal(){this.showWeightModal=false;this.editingWeightId=null;this.newWeight='';this.weightDate=new Date().toISOString().split('T')[0];this.weightMethod='scale'},
    async saveWeight(){
      this.processing=true;
      try{
        var r;
        if(this.editingWeightId){
          r=await executeJson({function:'updateWeightLog',userId:sessionStorage.getItem('userId'),logId:this.editingWeightId,weightKg:this.newWeight,method:this.weightMethod,recordedAt:this.weightDate||new Date().toISOString().split('T')[0]},flocker);
        } else {
          r=await executeJson({function:'recordWeight',animalId:this.animal.id,weightKg:this.newWeight,method:this.weightMethod,recordedAt:this.weightDate||new Date().toISOString().split('T')[0],recordedBy:sessionStorage.getItem('userId')},flocker);
        }
        if(r.data.success){this.closeWeightModal();await this.load(this.animal.id)}else alert(r.data.message||'Failed');
      }catch(e){alert('Error')}
      this.processing=false;
    },
    openDeleteWeight(w){this.deleteWeightTarget=w;this.deleteConfirmText='';this.showDeleteWeightModal=true},
    closeDeleteWeight(){if(this.processing)return;this.showDeleteWeightModal=false;this.deleteWeightTarget=null;this.deleteConfirmText=''},
    async confirmDeleteWeight(){
      if(!this.deleteWeightTarget)return;
      if(this.deleteConfirmText.trim().toUpperCase()!=='DELETE')return;
      this.processing=true;
      try{
        var r=await executeJson({function:'deleteWeightLog',userId:sessionStorage.getItem('userId'),logId:this.deleteWeightTarget.id},flocker);
        if(r.data.success){this.showDeleteWeightModal=false;this.deleteWeightTarget=null;this.deleteConfirmText='';await this.load(this.animal.id)}else alert(r.data.message||'Failed');
      }catch(e){alert('Error')}
      this.processing=false;
    },
    filterHealthSuggestions(){this.showHealthSuggestions=true},
    hideHealthSuggestions(){var self=this;setTimeout(function(){self.showHealthSuggestions=false},200)},
    hideDiagSuggest(){var self=this;setTimeout(function(){self.showDiagSuggest=false},200)},
    hideTreatSuggest(){var self=this;setTimeout(function(){self.showTreatSuggest=false},200)},
    hideVaxNameSuggest(){var self=this;setTimeout(function(){self.showVaxNameSuggest=false},200)},
    hideVaxDiseaseSuggest(){var self=this;setTimeout(function(){self.showVaxDiseaseSuggest=false},200)},
    hideVaxDoseSuggest(){var self=this;setTimeout(function(){self.showVaxDoseSuggest=false},200)},
    hideSemenSuggest(){var self=this;setTimeout(function(){self.showSemenSuggest=false},200)},
    hideBreedNoteSuggest(){var self=this;setTimeout(function(){self.showBreedNoteSuggest=false},200)},
    pickVaccine(v){this.newVax.vaccineName=v.name;this.newVax.diseaseTarget=v.disease;if(v.dose)this.newVax.dosage=v.dose;this.showVaxNameSuggest=false;
      // Auto-set next due date based on interval
      if(v.interval){var now=new Date();
        if(v.interval.indexOf('6 month')!==-1){now.setMonth(now.getMonth()+6);this.newVax.nextDueDate=now.toISOString().split('T')[0]}
        else if(v.interval.indexOf('Annual')!==-1||v.interval.indexOf('year')!==-1){now.setFullYear(now.getFullYear()+1);this.newVax.nextDueDate=now.toISOString().split('T')[0]}
        else if(v.interval.indexOf('3-4 month')!==-1){now.setMonth(now.getMonth()+3);this.newVax.nextDueDate=now.toISOString().split('T')[0]}
        else if(v.interval.indexOf('3 year')!==-1){now.setFullYear(now.getFullYear()+3);this.newVax.nextDueDate=now.toISOString().split('T')[0]}
      }
    },
    pickHealthTitle(t){this.newHealth.title=t;this.showHealthSuggestions=false;
      // Auto-set type based on title — must match DB ENUM: illness,treatment,surgery,checkup,vaccination,deworming,hoof_trim,dental,other
      var lower=t.toLowerCase();
      if(lower.indexOf('checkup')!==-1||lower.indexOf('check')!==-1||lower.indexOf('scoring')!==-1||lower.indexOf('screening')!==-1||lower.indexOf('assessment')!==-1||lower.indexOf('exam')!==-1)this.newHealth.recordType='checkup';
      else if(lower.indexOf('deworming')!==-1)this.newHealth.recordType='deworming';
      else if(lower.indexOf('hoof')!==-1||lower.indexOf('trimming')!==-1)this.newHealth.recordType='hoof_trim';
      else if(lower.indexOf('dipping')!==-1||lower.indexOf('spraying')!==-1||lower.indexOf('pour-on')!==-1||lower.indexOf('acaricide')!==-1||lower.indexOf('fly control')!==-1)this.newHealth.recordType='other';
      else if(lower.indexOf('castration')!==-1||lower.indexOf('dehorning')!==-1||lower.indexOf('removal')!==-1||lower.indexOf('drainage')!==-1||lower.indexOf('caesarean')!==-1||lower.indexOf('rumenotomy')!==-1||lower.indexOf('trocar')!==-1||lower.indexOf('hernia')!==-1||lower.indexOf('resection')!==-1||lower.indexOf('docking')!==-1)this.newHealth.recordType='surgery';
      else if(lower.indexOf('vaccine')!==-1||lower.indexOf('vaccination')!==-1)this.newHealth.recordType='vaccination';
      else if(lower.indexOf('treatment')!==-1||lower.indexOf('fracture')!==-1||lower.indexOf('wound')!==-1||lower.indexOf('snakebite')!==-1||lower.indexOf('lameness')!==-1||lower.indexOf('poisoning')!==-1||lower.indexOf('bite')!==-1)this.newHealth.recordType='treatment';
      else this.newHealth.recordType='illness';
    },
    openAddHealth(){this.editingHealthId=null;this.newHealth={title:'',recordType:'illness',diagnosis:'',treatment:'',symptoms:'',medications:'',severity:'',outcome:'',followUpDate:'',cost:'',recordDate:new Date().toISOString().split('T')[0]};this.showHealthModal=true},
    openEditHealth(h){
      this.editingHealthId=h.id;
      this.newHealth={
        title:h.title||'',recordType:h.record_type||'illness',diagnosis:h.diagnosis||'',treatment:h.treatment||'',
        symptoms:h.symptoms||'',medications:h.medications||'',
        severity:h.severity||'',outcome:h.outcome||'',
        followUpDate:(h.follow_up_date||'').split(' ')[0].split('T')[0]||'',
        cost:h.cost||'',recordDate:(h.record_date||'').split(' ')[0].split('T')[0]||new Date().toISOString().split('T')[0]
      };
      this.showHealthModal=true;
    },
    closeHealthModal(){this.showHealthModal=false;this.editingHealthId=null;this.newHealth={title:'',recordType:'illness',diagnosis:'',treatment:'',symptoms:'',medications:'',severity:'',outcome:'',followUpDate:'',cost:'',recordDate:new Date().toISOString().split('T')[0]}},
    async saveHealth(){
      this.processing=true;
      try{
        var h=this.newHealth;
        var r;
        if(this.editingHealthId){
          r=await executeJson({function:'updateHealthRecord',userId:sessionStorage.getItem('userId'),recordId:this.editingHealthId,title:h.title,recordType:h.recordType,diagnosis:h.diagnosis,treatment:h.treatment,symptoms:h.symptoms,medications:h.medications,severity:h.severity,outcome:h.outcome,followUpDate:h.followUpDate,cost:h.cost,recordDate:h.recordDate||new Date().toISOString().split('T')[0]},flocker);
        } else {
          r=await executeJson({function:'addHealthRecord',farmId:this.animal.farm_id,animalId:this.animal.id,title:h.title,recordType:h.recordType,diagnosis:h.diagnosis,treatment:h.treatment,symptoms:h.symptoms,medications:h.medications,severity:h.severity,outcome:h.outcome,followUpDate:h.followUpDate,cost:h.cost,recordDate:h.recordDate||new Date().toISOString().split('T')[0],recordedBy:sessionStorage.getItem('userId')},flocker);
        }
        if(r.data.success){this.closeHealthModal();await this.load(this.animal.id)}else alert(r.data.message||'Failed');
      }catch(e){alert('Error')}
      this.processing=false;
    },
    openDeleteHealth(h){this.deleteHealthTarget=h;this.deleteHealthConfirmText='';this.showDeleteHealthModal=true},
    closeDeleteHealth(){if(this.processing)return;this.showDeleteHealthModal=false;this.deleteHealthTarget=null;this.deleteHealthConfirmText=''},
    async confirmDeleteHealth(){
      if(!this.deleteHealthTarget||this.deleteHealthConfirmText.trim().toUpperCase()!=='DELETE')return;
      this.processing=true;
      try{
        var r=await executeJson({function:'deleteHealthRecord',userId:sessionStorage.getItem('userId'),recordId:this.deleteHealthTarget.id},flocker);
        if(r.data.success){this.showDeleteHealthModal=false;this.deleteHealthTarget=null;this.deleteHealthConfirmText='';await this.load(this.animal.id)}else alert(r.data.message||'Failed');
      }catch(e){alert('Error')}
      this.processing=false;
    },
    openAddVax(){this.editingVaxId=null;this.newVax={vaccineName:'',vaccineBrand:'',batchNumber:'',diseaseTarget:'',dosage:'',route:'injection',nextDueDate:'',cost:'',certificateUrl:'',administeredDate:new Date().toISOString().split('T')[0]};this.showVaxModal=true},
    openEditVax(v){
      this.editingVaxId=v.id;
      this.newVax={
        vaccineName:v.vaccine_name||'',vaccineBrand:v.vaccine_brand||'',batchNumber:v.batch_number||'',
        diseaseTarget:v.disease_target||'',dosage:v.dosage||'',
        route:v.administration_route||'injection',
        nextDueDate:(v.next_due_date||'').split(' ')[0].split('T')[0]||'',
        cost:v.cost||'',certificateUrl:v.certificate_url||'',
        administeredDate:(v.administered_date||'').split(' ')[0].split('T')[0]||new Date().toISOString().split('T')[0]
      };
      this.showVaxModal=true;
    },
    closeVaxModal(){this.showVaxModal=false;this.editingVaxId=null;this.newVax={vaccineName:'',vaccineBrand:'',batchNumber:'',diseaseTarget:'',dosage:'',route:'injection',nextDueDate:'',cost:'',certificateUrl:'',administeredDate:new Date().toISOString().split('T')[0]}},
    async saveVax(){
      this.processing=true;
      try{
        var v=this.newVax;
        var r;
        if(this.editingVaxId){
          r=await executeJson({function:'updateVaccination',userId:sessionStorage.getItem('userId'),recordId:this.editingVaxId,vaccineName:v.vaccineName,vaccineBrand:v.vaccineBrand,batchNumber:v.batchNumber,diseaseTarget:v.diseaseTarget,dosage:v.dosage,administrationRoute:v.route,administeredDate:v.administeredDate||new Date().toISOString().split('T')[0],nextDueDate:v.nextDueDate,cost:v.cost,certificateUrl:v.certificateUrl},flocker);
        } else {
          r=await executeJson({function:'recordVaccination',farmId:this.animal.farm_id,animalId:this.animal.id,vaccineName:v.vaccineName,vaccineBrand:v.vaccineBrand,batchNumber:v.batchNumber,diseaseTarget:v.diseaseTarget,dosage:v.dosage,administrationRoute:v.route,administeredDate:v.administeredDate||new Date().toISOString().split('T')[0],nextDueDate:v.nextDueDate,cost:v.cost,certificateUrl:v.certificateUrl,administeredBy:sessionStorage.getItem('userId')},flocker);
        }
        if(r.data.success){this.closeVaxModal();await this.load(this.animal.id)}else alert(r.data.message||'Failed');
      }catch(e){alert('Error')}
      this.processing=false;
    },
    openDeleteVax(v){this.deleteVaxTarget=v;this.deleteVaxConfirmText='';this.showDeleteVaxModal=true},
    closeDeleteVax(){if(this.processing)return;this.showDeleteVaxModal=false;this.deleteVaxTarget=null;this.deleteVaxConfirmText=''},
    async confirmDeleteVax(){
      if(!this.deleteVaxTarget||this.deleteVaxConfirmText.trim().toUpperCase()!=='DELETE')return;
      this.processing=true;
      try{
        var r=await executeJson({function:'deleteVaccination',userId:sessionStorage.getItem('userId'),recordId:this.deleteVaxTarget.id},flocker);
        if(r.data.success){this.showDeleteVaxModal=false;this.deleteVaxTarget=null;this.deleteVaxConfirmText='';await this.load(this.animal.id)}else alert(r.data.message||'Failed');
      }catch(e){alert('Error')}
      this.processing=false;
    },
    openAddBreed(){this.editingBreedId=null;this.newBreed={method:'natural',maleAnimalId:'',semenSource:'',breedingDate:new Date().toISOString().split('T')[0],expectedDueDate:'',actualBirthDate:'',pregnancyConfirmed:false,pregnancyConfirmedDate:'',complications:'',cost:'',notes:'',outcome:'pending'};this.showBreedModal=true},
    // Record-offspring (Alex 2026-07-17). Each row creates an animals row
    // linked to this dam via dam_id (sire from breeding_records if known).
    openRecordOffspring(b){
      this.offspringBreedingId = b.id;
      this.offspringBirthDate = new Date().toISOString().split('T')[0];
      this.offspringDraft = [{tag:'',sex:'unknown',birthWeightKg:'',name:''}];
      this.showRecordOffspring = true;
    },
    async saveOffspring(){
      var draft = this.offspringDraft.filter(o => o.tag || o.name || o.birthWeightKg);
      if (!draft.length) { alert('Add at least one offspring row.'); return; }
      this.processing = true;
      try {
        var r = await executeJson({
          function: 'recordBreedingOffspring',
          recordId: this.offspringBreedingId,
          birthDate: this.offspringBirthDate,
          offspring: JSON.stringify(draft)
        }, flocker);
        if (r.data && r.data.success) {
          this.showRecordOffspring = false;
          await this.load(this.animal.id);
          alert((r.data.data && r.data.data.count) + ' offspring linked to this dam.');
        } else {
          alert((r.data && r.data.message) || 'Could not save offspring');
        }
      } catch(e) { console.error(e); alert('Error saving offspring'); }
      this.processing = false;
    },

    openEditBreed(b){
      this.editingBreedId=b.id;
      this.newBreed={
        method:b.breeding_method||'natural',maleAnimalId:b.male_animal_id||'',semenSource:b.semen_source||'',
        breedingDate:(b.breeding_date||'').split(' ')[0].split('T')[0]||new Date().toISOString().split('T')[0],
        expectedDueDate:(b.expected_due_date||'').split(' ')[0].split('T')[0]||'',
        actualBirthDate:(b.actual_birth_date||'').split(' ')[0].split('T')[0]||'',
        pregnancyConfirmed: (b.pregnancy_confirmed === 1 || b.pregnancy_confirmed === '1' || b.pregnancy_confirmed === true),
        pregnancyConfirmedDate:(b.pregnancy_confirmed_date||'').split(' ')[0].split('T')[0]||'',
        complications:b.complications||'',
        cost:b.cost||'',notes:b.notes||'',outcome:b.outcome||'pending'
      };
      this.showBreedModal=true;
    },
    closeBreedModal(){this.showBreedModal=false;this.editingBreedId=null;this.newBreed={method:'natural',maleAnimalId:'',semenSource:'',breedingDate:new Date().toISOString().split('T')[0],expectedDueDate:'',actualBirthDate:'',pregnancyConfirmed:false,pregnancyConfirmedDate:'',complications:'',cost:'',notes:'',outcome:'pending'}},
    async saveBreed(){
      this.processing=true;
      try{
        var nb=this.newBreed;
        var r;
        if(this.editingBreedId){
          r=await executeJson({function:'updateBreedingRecord',userId:sessionStorage.getItem('userId'),recordId:this.editingBreedId,breedingMethod:nb.method,maleAnimalId:nb.maleAnimalId,semenSource:nb.semenSource,breedingDate:nb.breedingDate,expectedDueDate:nb.expectedDueDate,actualBirthDate:nb.actualBirthDate,pregnancyConfirmed:nb.pregnancyConfirmed?1:0,pregnancyConfirmedDate:nb.pregnancyConfirmedDate,complications:nb.complications,cost:nb.cost,notes:nb.notes,outcome:nb.outcome},flocker);
        } else {
          var p={function:'recordBreeding',farmId:this.animal.farm_id,femaleAnimalId:this.animal.id,breedingMethod:nb.method,breedingDate:nb.breedingDate,recordedBy:sessionStorage.getItem('userId')};
          if(nb.maleAnimalId)p.maleAnimalId=nb.maleAnimalId;
          if(nb.semenSource)p.semenSource=nb.semenSource;
          if(nb.expectedDueDate)p.expectedDueDate=nb.expectedDueDate;
          if(nb.complications)p.complications=nb.complications;
          if(nb.pregnancyConfirmed)p.pregnancyConfirmed=1;
          if(nb.pregnancyConfirmedDate)p.pregnancyConfirmedDate=nb.pregnancyConfirmedDate;
          if(nb.cost)p.cost=nb.cost;
          if(nb.notes)p.notes=nb.notes;
          r=await executeJson(p,flocker);
        }
        if(r.data.success){this.closeBreedModal();await this.load(this.animal.id)}else alert(r.data.message||'Failed');
      }catch(e){alert('Error')}
      this.processing=false;
    },
    openDeleteBreed(b){this.deleteBreedTarget=b;this.deleteBreedConfirmText='';this.showDeleteBreedModal=true},
    closeDeleteBreed(){if(this.processing)return;this.showDeleteBreedModal=false;this.deleteBreedTarget=null;this.deleteBreedConfirmText=''},
    async confirmDeleteBreed(){
      if(!this.deleteBreedTarget||this.deleteBreedConfirmText.trim().toUpperCase()!=='DELETE')return;
      this.processing=true;
      try{var r=await executeJson({function:'deleteBreedingRecord',userId:sessionStorage.getItem('userId'),recordId:this.deleteBreedTarget.id},flocker);
        if(r.data.success){this.showDeleteBreedModal=false;this.deleteBreedTarget=null;this.deleteBreedConfirmText='';await this.load(this.animal.id)}else alert(r.data.message||'Failed')}catch(e){alert('Error')}this.processing=false;
    },
    openEditFeed(f){this.editFeed={id:f.id,feedType:f.feed_type||'',quantityKg:f.quantity_kg||'',cost:f.cost||'',feedDate:(f.fed_at||'').split(' ')[0].split('T')[0]||new Date().toISOString().split('T')[0],notes:f.notes||''};this.showEditFeedModal=true},
    async saveEditFeed(){
      this.processing=true;
      try{var r=await executeJson({function:'updateFeedingLog',userId:sessionStorage.getItem('userId'),logId:this.editFeed.id,feedType:this.editFeed.feedType,quantityKg:this.editFeed.quantityKg,cost:this.editFeed.cost,feedDate:this.editFeed.feedDate,notes:this.editFeed.notes},flocker);
        if(r.data.success){this.showEditFeedModal=false;await this.loadFeedingLogs();await this.load(this.animal.id)}else alert(r.data.message||'Failed')}catch(e){alert('Error')}this.processing=false;
    },
    openDeleteFeed(f){this.deleteFeedTarget=f;this.deleteFeedConfirmText='';this.showDeleteFeedModal=true},
    closeDeleteFeed(){if(this.processing)return;this.showDeleteFeedModal=false;this.deleteFeedTarget=null;this.deleteFeedConfirmText=''},
    async confirmDeleteFeed(){
      if(!this.deleteFeedTarget||this.deleteFeedConfirmText.trim().toUpperCase()!=='DELETE')return;
      this.processing=true;
      try{var r=await executeJson({function:'deleteFeedingLog',userId:sessionStorage.getItem('userId'),logId:this.deleteFeedTarget.id},flocker);
        if(r.data.success){this.showDeleteFeedModal=false;this.deleteFeedTarget=null;this.deleteFeedConfirmText='';await this.loadFeedingLogs();await this.load(this.animal.id)}else alert(r.data.message||'Failed')}catch(e){alert('Error')}this.processing=false;
    },
    async loadMilkRecords(){
      this.loadingMilk=true;
      try{var r=await executeJson({function:'getAnimalMilkRecords',animalId:this.animal.id},flocker);
        if(r.data&&r.data.success){this.milkRecords=r.data.data.records||[];this.milkTotal=r.data.data.totalLiters||0;this.milkLast7=r.data.data.last7Liters||0}
      }catch(e){console.error(e)}
      this.loadingMilk=false;
    },
    async loadAuditTrail(){
      this.loadingAudit=true;
      try{var r=await executeJson({function:'getAnimalAuditTrail',animalId:this.animal.id,userId:sessionStorage.getItem('userId')},flocker);
        if(r.data&&r.data.success){this.auditTrail=r.data.data.trail||[]}else{this.auditTrail=[];if(r.data&&r.data.message)console.warn(r.data.message)}
      }catch(e){console.error(e)}
      this.loadingAudit=false;
    },
    auditLabel(a){
      var map={'animal.add':'Animal added','animal.update':'Animal updated','animal.weight.add':'Weight recorded','animal.weight.update':'Weight edited','animal.weight.delete':'Weight deleted','animal.vaccination.add':'Vaccination recorded','animal.vaccination.add (bulk)':'Vaccination recorded (bulk)','animal.vaccination.update':'Vaccination edited','animal.vaccination.delete':'Vaccination deleted','animal.health.add':'Health record added','animal.health.update':'Health record edited','animal.health.delete':'Health record deleted','animal.breeding.add':'Breeding recorded','animal.breeding.update':'Breeding edited','animal.breeding.delete':'Breeding deleted','animal.breeding.offspring':'Offspring recorded','animal.milk.add':'Milk recorded','animal.milk.update':'Milk record edited','animal.milk.delete':'Milk record deleted','animal.eggs.add':'Eggs recorded','animal.eggs.update':'Egg record edited','animal.eggs.delete':'Egg record deleted','animal.feeding.add':'Feeding logged','animal.feeding.update':'Feeding edited','animal.feeding.delete':'Feeding deleted'};
      return map[a]||a;
    },
    auditIcon(a){
      if(a.indexOf('.delete')>-1)return 'mdi-trash-can-outline';
      if(a.indexOf('.update')>-1)return 'mdi-pencil-outline';
      if(a.indexOf('weight')>-1)return 'mdi-scale';
      if(a.indexOf('vaccination')>-1)return 'mdi-needle';
      if(a.indexOf('health')>-1)return 'mdi-medical-bag';
      if(a.indexOf('breeding')>-1)return 'mdi-gender-male-female';
      if(a.indexOf('milk')>-1)return 'mdi-cup-water';
      if(a.indexOf('eggs')>-1)return 'mdi-egg-outline';
      if(a.indexOf('feeding')>-1)return 'mdi-food-apple-outline';
      return 'mdi-plus-circle-outline';
    },
    fDateTime(d){
      if(!d)return '—';
      var dt=new Date(String(d).replace(' ','T'));
      if(isNaN(dt))return d;
      return dt.toLocaleDateString('en-KE',{day:'numeric',month:'short',year:'numeric'})+' '+dt.toLocaleTimeString('en-KE',{hour:'2-digit',minute:'2-digit'});
    },
    openAddMilk(){this.editingMilkId=null;this.newMilk={session:'morning',quantityLiters:'',qualityGrade:'',fatContentPct:'',recordDate:new Date().toISOString().split('T')[0]};this.showMilkModal=true},
    openEditMilk(m){
      this.editingMilkId=m.id;
      this.newMilk={session:m.session||'morning',quantityLiters:m.quantity_liters||'',qualityGrade:m.quality_grade||'',fatContentPct:m.fat_content_pct||'',recordDate:(m.record_date||'').split(' ')[0].split('T')[0]||new Date().toISOString().split('T')[0]};
      this.showMilkModal=true;
    },
    closeMilkModal(){this.showMilkModal=false;this.editingMilkId=null;this.newMilk={session:'morning',quantityLiters:'',qualityGrade:'',fatContentPct:'',recordDate:new Date().toISOString().split('T')[0]}},
    async saveMilk(){
      this.processing=true;
      try{
        var r;
        if(this.editingMilkId){
          r=await executeJson({function:'updateMilkRecord',userId:sessionStorage.getItem('userId'),recordId:this.editingMilkId,session:this.newMilk.session,quantityLiters:this.newMilk.quantityLiters,qualityGrade:this.newMilk.qualityGrade,fatContentPct:this.newMilk.fatContentPct,recordDate:this.newMilk.recordDate},flocker);
        } else {
          r=await executeJson({function:'recordMilk',farmId:this.animal.farm_id,animalId:this.animal.id,session:this.newMilk.session,quantityLiters:this.newMilk.quantityLiters,recordDate:this.newMilk.recordDate,recordedBy:sessionStorage.getItem('userId')},flocker);
        }
        if(r.data.success){this.closeMilkModal();await this.loadMilkRecords();await this.load(this.animal.id)}else alert(r.data.message||'Failed');
      }catch(e){alert('Error')}
      this.processing=false;
    },
    async loadFeedingSchedules(){
      try{var r=await executeJson({function:'getFeedingSchedules',animalId:this.animal.id},flocker);
        if(r.data&&r.data.success)this.feedingSchedules=r.data.data.schedules||[]}catch(e){console.error(e)}
      if(!this.formulationsList.length)await this.loadFormulations();
    },
    onScheduleFormulationPicked(){
      if(!this.newSchedule.formulationId){return}
      var self=this;var f=(this.formulationsList||[]).find(function(x){return String(x.id)===String(self.newSchedule.formulationId)});
      if(f){this.newSchedule.feedType=f.name;
        // sum item quantities for the schedule qty
        executeJson({function:'getFeedFormulation',formulationId:f.id},flocker).then(function(r){
          if(r.data&&r.data.success){var items=r.data.data.items||[];var q=0;items.forEach(function(it){q+=Number(it.quantity_kg||0)});self.newSchedule.quantityKg=q.toFixed(2)}
        });
      }
    },
    openAddSchedule(){this.editingScheduleId=null;this.newSchedule={formulationId:'',feedType:'',quantityKg:'',frequency:'twice_daily',startDate:new Date().toISOString().split('T')[0],endDate:'',specialInstructions:''};this.showScheduleModal=true;if(!this.formulationsList.length)this.loadFormulations()},
    openEditSchedule(s){
      this.editingScheduleId=s.id;
      this.newSchedule={formulationId:s.formulation_id||'',feedType:s.feed_type||'',quantityKg:s.quantity_kg||'',frequency:s.frequency||'twice_daily',startDate:(s.start_date||'').split(' ')[0].split('T')[0]||new Date().toISOString().split('T')[0],endDate:(s.end_date||'').split(' ')[0].split('T')[0]||'',specialInstructions:s.special_instructions||''};
      this.showScheduleModal=true;if(!this.formulationsList.length)this.loadFormulations();
    },
    closeScheduleModal(){this.showScheduleModal=false;this.editingScheduleId=null},
    async saveSchedule(){
      this.processing=true;
      try{
        var r;
        if(this.editingScheduleId){
          r=await executeJson({function:'updateFeedingSchedule',scheduleId:this.editingScheduleId,formulationId:this.newSchedule.formulationId,feedType:this.newSchedule.feedType,quantityKg:this.newSchedule.quantityKg,frequency:this.newSchedule.frequency,startDate:this.newSchedule.startDate,endDate:this.newSchedule.endDate,specialInstructions:this.newSchedule.specialInstructions},flocker);
        } else {
          r=await executeJson({function:'addFeedingSchedule',farmId:this.animal.farm_id,animalId:this.animal.id,formulationId:this.newSchedule.formulationId,feedType:this.newSchedule.feedType,quantityKg:this.newSchedule.quantityKg,frequency:this.newSchedule.frequency,startDate:this.newSchedule.startDate,endDate:this.newSchedule.endDate,specialInstructions:this.newSchedule.specialInstructions,createdBy:sessionStorage.getItem('userId')},flocker);
        }
        if(r.data.success){this.closeScheduleModal();await this.loadFeedingSchedules()}else alert(r.data.message||'Failed');
      }catch(e){alert('Error')}
      this.processing=false;
    },
    async toggleSchedule(s){
      this.processing=true;
      try{var r=await executeJson({function:'updateFeedingSchedule',scheduleId:s.id,isActive:Number(s.is_active)===1?0:1},flocker);
        if(r.data.success)await this.loadFeedingSchedules();else alert(r.data.message||'Failed')}catch(e){alert('Error')}this.processing=false;
    },
    openDeleteSchedule(s){this.deleteScheduleTarget=s;this.deleteScheduleConfirmText='';this.showDeleteScheduleModal=true},
    closeDeleteSchedule(){if(this.processing)return;this.showDeleteScheduleModal=false;this.deleteScheduleTarget=null;this.deleteScheduleConfirmText=''},
    async confirmDeleteSchedule(){
      if(!this.deleteScheduleTarget||this.deleteScheduleConfirmText.trim().toUpperCase()!=='DELETE')return;
      this.processing=true;
      try{var r=await executeJson({function:'deleteFeedingSchedule',scheduleId:this.deleteScheduleTarget.id},flocker);
        if(r.data.success){this.showDeleteScheduleModal=false;this.deleteScheduleTarget=null;this.deleteScheduleConfirmText='';await this.loadFeedingSchedules()}else alert(r.data.message||'Failed')}catch(e){alert('Error')}this.processing=false;
    },
    openDeleteMilk(m){this.deleteMilkTarget=m;this.deleteMilkConfirmText='';this.showDeleteMilkModal=true},
    closeDeleteMilk(){if(this.processing)return;this.showDeleteMilkModal=false;this.deleteMilkTarget=null;this.deleteMilkConfirmText=''},
    async confirmDeleteMilk(){
      if(!this.deleteMilkTarget||this.deleteMilkConfirmText.trim().toUpperCase()!=='DELETE')return;
      this.processing=true;
      try{var r=await executeJson({function:'deleteMilkRecord',userId:sessionStorage.getItem('userId'),recordId:this.deleteMilkTarget.id},flocker);
        if(r.data.success){this.showDeleteMilkModal=false;this.deleteMilkTarget=null;this.deleteMilkConfirmText='';await this.loadMilkRecords();await this.load(this.animal.id)}else alert(r.data.message||'Failed')}catch(e){alert('Error')}this.processing=false;
    },
    // Feeding
    hideFeedSuggest(){var self=this;setTimeout(function(){self.showFeedSuggest=false},200)},
    hideFeedNoteSuggest(){var self=this;setTimeout(function(){self.showFeedNoteSuggest=false},200)},
    async loadFeedingLogs(){
      this.loadingFeed=true;
      try{var r=await executeJson({function:'getAnimalFeedingLogs',animalId:this.animal.id},flocker);
        if(r.data&&r.data.success)this.feedingLogs=r.data.data.logs||[];
      }catch(e){console.error(e)}
      this.loadingFeed=false;
    },
    async addFeeding(){
      this.processing=true;
      try{
        var payload={function:'logFeeding',farmId:this.animal.farm_id,animalId:this.animal.id,notes:this.newFeed.notes||'',feedDate:this.newFeed.feedDate||new Date().toISOString().split('T')[0],fedBy:sessionStorage.getItem('userId')};
        if(this.newFeed.mode==='formulation' && this.newFeed.formulationId){
          payload.formulationId=this.newFeed.formulationId;
          payload.rationMultiplier=this.newFeed.rationMultiplier||1;
        } else {
          payload.feedType=this.newFeed.feedType;
          payload.quantityKg=this.newFeed.quantityKg;
          payload.cost=this.newFeed.cost||'';
        }
        var r=await executeJson(payload,flocker);
        if(r.data&&r.data.success){
          this.showFeedModal=false;
          this.newFeed={mode:'formulation',formulationId:'',rationMultiplier:1,feedType:'',quantityKg:'',cost:'',notes:'',feedDate:new Date().toISOString().split('T')[0]};
          this.formulationItems=[];
          if(this.tab==='feeding')await this.loadFeedingLogs();
          await this.load(this.animal.id);
        }else alert(r.data.message||'Failed');
      }catch(e){alert('Error')}
      this.processing=false;
    },
    async openFeedModal(){
      this.showFeedModal=true;
      if(!this.formulationsList.length) await this.loadFormulations();
    },
    async loadFormulations(){
      this.loadingFormulations=true;
      try{
        var r=await executeJson({function:'getFeedFormulations',ownerId:sessionStorage.getItem('userId')||''},flocker);
        if(r.data&&r.data.success)this.formulationsList=r.data.data.formulations||[];
      }catch(e){console.error(e)}
      this.loadingFormulations=false;
    },
    async onFormulationPicked(){
      this.formulationItems=[];
      if(!this.newFeed.formulationId)return;
      try{
        var r=await executeJson({function:'getFeedFormulation',formulationId:this.newFeed.formulationId},flocker);
        if(r.data&&r.data.success)this.formulationItems=r.data.data.items||[];
      }catch(e){console.error(e)}
    },
    photoUrl(p){if(!p)return'';if(p.startsWith&&p.startsWith('http'))return p;return uploads+String(p).replace('uploads/','')},
    formatFileSize(b){if(!b)return'';if(b<1024)return b+'B';if(b<1048576)return(b/1024).toFixed(0)+'KB';return(b/1048576).toFixed(1)+'MB'},
    // NFC Tag Assign/Remove
    async startNfcAssign(){
      if(!this.nfcSupported){alert('NFC not supported on this device');return}
      this.showNfcAssign=true;this.nfcAssigning=true;this.nfcAssignStatus='';
      try{
        this.nfcAssignAbort=new AbortController();
        this.nfcAssignReader=new NDEFReader();
        await this.nfcAssignReader.scan({signal:this.nfcAssignAbort.signal});
        var self=this;
        this.nfcAssignReader.onreading=function(event){
          var serial=event.serialNumber||'';
          self.nfcAssigning=false;
          if(!serial){self.nfcAssignStatus='Error: Could not read tag serial number';return}
          self.nfcAssignStatus='Tag detected! Assigning...';
          self.assignNfcTag(serial);
        };
        this.nfcAssignReader.onreadingerror=function(){
          self.nfcAssigning=false;
          self.nfcAssignStatus='Error reading tag. Try again.';
        };
      }catch(e){
        this.nfcAssigning=false;
        if(e.name==='AbortError')return;
        this.nfcAssignStatus=e.name==='NotAllowedError'?'NFC permission denied':'Error: '+e.message;
      }
    },
    stopNfcAssign(){
      if(this.nfcAssignAbort){try{this.nfcAssignAbort.abort()}catch(e){}}
      this.nfcAssignAbort=null;this.nfcAssignReader=null;this.nfcAssigning=false;this.showNfcAssign=false;
    },
    async assignNfcTag(serial){
      this.processing=true;
      try{
        var r=await executeJson({function:'assignNfcTag',animalId:this.animal.id,nfcTagSerial:serial,farmId:this.animal.farm_id},flocker);
        if(r.data&&r.data.success){
          this.nfcAssignStatus='NFC tag assigned successfully!';
          this.animal.nfc_tag_serial=serial;
          this.showManualNfc=false;this.manualNfcSerial='';
          // Try to write animal ID to tag for offline lookup
          try{
            var writer=new NDEFReader();
            await writer.write({records:[{recordType:'text',data:this.animal.id}]});
            this.nfcAssignStatus+=' (Animal ID written to tag)';
          }catch(we){/* write optional */}
        }else{
          this.nfcAssignStatus=r.data.message||'Failed to assign tag';
        }
      }catch(e){this.nfcAssignStatus='Error: '+e.message}
      this.processing=false;
    },
    async removeNfcTag(){
      if(!confirm('Remove NFC tag from '+( this.animal.name||this.animal.tag_number||'this animal')+'?'))return;
      this.processing=true;
      try{
        var r=await executeJson({function:'removeNfcTag',animalId:this.animal.id},flocker);
        if(r.data&&r.data.success){this.animal.nfc_tag_serial=null}
        else alert(r.data.message||'Failed');
      }catch(e){alert('Error')}
      this.processing=false;
    },
    // AI Vet Assistant
    openAiVet(){this.showAiVet=true;this.aiVetMessages=[];this.aiVetInput='';this.aiVetPhoto=null},
    async loadMyFarms(){
      try{var r=await executeJson({function:'getMyFarms',ownerId:sessionStorage.getItem('userId')},flocker);
        if(r.data&&r.data.success)this.myFarms=r.data.data.farms||[]}catch(e){}
    },
    openEditAnimal(){
      var a=this.animal;
      var dOnly=function(v){return v?String(v).split(' ')[0].split('T')[0]:'';};
      // Compute age (months) from DOB or estimated_age_months for the Age input
      var ageMonths='';
      if(a.estimated_age_months){ ageMonths=a.estimated_age_months; }
      else if(a.date_of_birth){ var _dob=new Date(a.date_of_birth); var _m=Math.floor((new Date()-_dob)/(30.44*86400000)); if(_m>=0) ageMonths=_m; }
      this.editForm={
        name:a.name||'',tag_number:a.tag_number||'',anitrac_id:a.anitrac_id||'',sex:a.sex||'unknown',
        age_months:ageMonths, date_of_birth:dOnly(a.date_of_birth),weight_kg:a.weight_kg||'',
        // Birth + weaning (Alex 2026-07-17)
        birth_weight_kg:a.birth_weight_kg||'',
        weaning_date:dOnly(a.weaning_date),
        weaning_weight_kg:a.weaning_weight_kg||'',
        // Growth + phenotype (2026-07-29 gap-close)
        body_condition_score:a.body_condition_score ? String(parseFloat(a.body_condition_score)) : '',
        height_cm:a.height_cm||'',
        // Pedigree + identifiers
        sire_id:a.sire_id||'',dam_id:a.dam_id||'',
        is_pedigree: (a.is_pedigree === 1 || a.is_pedigree === '1' || a.is_pedigree === true),
        pedigree_number:a.pedigree_number||'',
        microchip_number:a.microchip_number||'',
        color_markings:a.color_markings||'',
        breed_id:a.breed_id||'',
        acquisition_type:a.acquisition_type||'born_on_farm',
        acquisition_date:dOnly(a.acquisition_date),
        acquisition_price:a.acquisition_price||'',
        acquisition_source:a.acquisition_source||'',
        health_status:a.health_status||'healthy',
        reproductive_status:a.reproductive_status||'not_applicable',
        pregnancy_due_date:dOnly(a.pregnancy_due_date),
        daily_milk_yield_liters:a.daily_milk_yield_liters||'',
        notes:a.notes||''
      };
      this.showEditAnimal=true;
      this.loadEditBreeds(a.species_id);
      this.loadFarmAnimalsForPedigree();
    },
    async loadFarmAnimalsForPedigree(){
      // Pull every animal on this farm so the sire/dam pickers can offer real choices.
      // Cheap — bounded by herd size. Filtered client-side per sex + species.
      if(!this.animal||!this.animal.farm_id){this.farmAnimalsForPedigree=[];return}
      this.loadingPedigree=true;
      try{
        var r=await executeJson({function:'getFarmAnimals',farmId:this.animal.farm_id},flocker);
        if(r.data&&r.data.success)this.farmAnimalsForPedigree=(r.data.data&&r.data.data.animals)||[];
      }catch(e){this.farmAnimalsForPedigree=[]}
      this.loadingPedigree=false;
    },
    async loadEditBreeds(speciesId){
      if(!speciesId){this.editBreedsList=[];return}
      this.loadingEditBreeds=true;
      try{
        var r=await executeJson({function:'getAnimalBreeds',speciesId:speciesId},flocker);
        if(r.data&&r.data.success)this.editBreedsList=r.data.data.breeds||[];
      }catch(e){this.editBreedsList=[]}
      this.loadingEditBreeds=false;
    },
    recalcActionSaleTotal(){
      var w = Number(this.actionForm.sale_weight_kg || this.animal.weight_kg) || 0;
      var p = Number(this.actionForm.sale_price_per_kg_kes) || 0;
      if (w > 0 && p > 0) this.actionForm.sale_price_kes = Math.round(w * p);
    },
    async searchCorporates(){
      var q = (this.corpSearch || '').trim();
      if (!q || q.length < 2) { this.corpResults = []; return; }
      this.corpSearching = true;
      try {
        var r = await executeJson({ function:'listCorporateAccounts', keyword: q }, flocker);
        this.corpResults = (r.data && r.data.success && r.data.data && r.data.data.accounts) || [];
      } catch(e){ this.corpResults = []; }
      this.corpSearching = false;
    },
    pickCorpBuyer(c){
      // Link the buyer to a real Flockr user account + pre-fill defaults.
      this.actionForm.buyer_user_id = c.owner_user_id || '';
      this.actionForm.buyer_name    = c.company_name || '';
      this.actionForm.buyer_phone   = c.contact_phone || '';
      this.actionForm.buyer_corp_kyc = c.kyc_status || '';
      if (c.default_payment_method && !this.actionForm.sale_payment_method) this.actionForm.sale_payment_method = c.default_payment_method;
      if (Number(c.default_payment_terms_days) > 0 && !this.actionForm.sale_payment_terms) {
        this.actionForm.sale_payment_terms = c.default_payment_terms_days + '-day terms';
      }
      this.corpResults = [];
      this.corpSearch = '';
    },
    clearCorpBuyer(){
      this.actionForm.buyer_user_id = '';
      this.actionForm.buyer_corp_kyc = '';
    },
    useManualBuyer(){
      this.actionForm.buyer_user_id = '';
      this.actionForm.buyer_name = this.corpSearch;
      this.corpResults = [];
      this.corpSearch = '';
    },
    onEditAgeChange(){
      // Age input drives DOB — sellers rarely know exact birth date, so we back-compute a
      // representative DOB from age months and persist that (schema still stores date_of_birth).
      if(this.editForm.age_months===''||this.editForm.age_months==null){this.editForm.date_of_birth='';return;}
      var m=parseInt(this.editForm.age_months);if(isNaN(m)||m<0){this.editForm.date_of_birth='';return;}
      var now=new Date();var dob=new Date(now.getFullYear(),now.getMonth()-m,now.getDate());
      this.editForm.date_of_birth=dob.toISOString().split('T')[0];
    },
    async saveEditAnimal(){
      if(this.editForm.acquisition_type && this.editForm.acquisition_type!=='born_on_farm' && !this.editForm.acquisition_date){alert('Please enter the '+(this.editForm.acquisition_type==='purchased'?'purchase':'acquired')+' date — it\'s needed for profitability tracking.');return}
      this.processing=true;
      try{
        var f=this.editForm;
        var params={function:'updateAnimal',animalId:this.animal.id,userId:sessionStorage.getItem('userId'),
          name:f.name,tagNumber:f.tag_number,anitracId:f.anitrac_id,sex:f.sex,
          dateOfBirth:f.date_of_birth,weightKg:f.weight_kg,
          // Birth + weaning (Alex 2026-07-17)
          birthWeightKg:f.birth_weight_kg,
          weaningDate:f.weaning_date,
          weaningWeightKg:f.weaning_weight_kg,
          // Growth + phenotype (2026-07-29 gap-close)
          bodyConditionScore:f.body_condition_score,
          heightCm:f.height_cm,
          // Pedigree + identifiers
          sireId:f.sire_id,damId:f.dam_id,
          isPedigree:f.is_pedigree?1:0,
          pedigreeNumber:f.pedigree_number,
          microchipNumber:f.microchip_number,
          colorMarkings:f.color_markings,
          breedId:f.breed_id,
          acquisitionType:f.acquisition_type,
          acquisitionDate:f.acquisition_date,
          acquisitionPrice:f.acquisition_price,
          acquisitionSource:f.acquisition_source,
          healthStatus:f.health_status,reproductiveStatus:f.reproductive_status,
          pregnancyDueDate:f.pregnancy_due_date,
          dailyMilkYieldLiters:f.daily_milk_yield_liters,
          notes:f.notes};
        var r=await executeJson(params,flocker);
        if(r.data&&r.data.success){
          this.showEditAnimal=false;
          // Refresh from server so we get the resolved buyer_display_name + canonical fields.
          await this.load(this.animal.id);
          alert('Animal updated successfully');
        }else{alert(r.data.message||'Update failed')}
      }catch(e){console.error(e);alert('Error saving changes')}
      this.processing=false;
    },
    // ===== Actions module (issue 86) =====
    async loadPendingActions(){
      this.loadingPending=true;
      try{
        var r=await executeJson({function:'getFarmPendingActions',animalId:this.animal.id,userId:sessionStorage.getItem('userId')},flocker);
        if(r.data&&r.data.success){this.pendingActions=(r.data.data&&r.data.data.actions)||[];this.amOwner=!!(r.data.data&&r.data.data.isOwner)}
      }catch(e){}
      this.loadingPending=false;
    },
    openAction(type){
      var a=this.animal;
      var today=new Date().toISOString().split('T')[0];
      var dOnly=function(v){return v?String(v).split(' ')[0].split('T')[0]:'';};
      this.actionType=type;
      this.actionForm={
        sale_date:dOnly(a.sale_date)||today,sale_price_kes:a.sale_price_kes||'',sale_weight_kg:a.sale_weight_kg||a.weight_kg||'',sale_price_per_kg_kes:a.sale_price_per_kg_kes||'',
        buyer_user_id:a.buyer_user_id||'',buyer_name:a.buyer_name||'',buyer_phone:a.buyer_phone||'',buyer_corp_kyc:a.buyer_corp_kyc_status||'',
        sale_payment_method:a.sale_payment_method||'',sale_payment_terms:a.sale_payment_terms||'',sale_destination:a.sale_destination||'',sale_receipt_no:a.sale_receipt_no||'',sale_notes:a.sale_notes||'',
        death_date:dOnly(a.death_date)||today,cause_of_death:a.cause_of_death||'',death_notes:a.death_notes||'',
        cull_date:dOnly(a.cull_date)||today,cull_reason:a.cull_reason||'',
        incident_date:dOnly(a.incident_date)||today,incident_notes:a.incident_notes||'',
        to_farm_id:''
      };
      this.corpSearch='';this.corpResults=[];
      if(type==='transfer')this.loadMyFarms();
      if(this.amOwner===null)this.loadPendingActions();
      this.showActionModal=true;
    },
    async submitAction(){
      var fieldMap={
        sold:['sale_date','sale_price_kes','sale_price_per_kg_kes','sale_weight_kg','buyer_user_id','buyer_name','buyer_phone','sale_payment_method','sale_payment_terms','sale_destination','sale_receipt_no','sale_notes'],
        deceased:['death_date','cause_of_death','death_notes'],
        culled:['cull_date','cull_reason'],
        slaughtered:['cull_date','cull_reason'],
        lost:['incident_date','incident_notes'],
        stolen:['incident_date','incident_notes'],
        transfer:['to_farm_id']
      };
      if(this.actionType==='transfer'&&!this.actionForm.to_farm_id)return;
      if(this.actionType==='sold'&&!this.actionForm.sale_price_kes){alert('Please enter the total sale price.');return}
      this.processing=true;
      try{
        var params={function:'submitAnimalAction',animalId:this.animal.id,userId:sessionStorage.getItem('userId'),action:this.actionType};
        var f=this.actionForm;
        fieldMap[this.actionType].forEach(function(k){params[k]=f[k]!=null?f[k]:''});
        var r=await executeJson(params,flocker);
        if(r.data&&r.data.success){
          this.showActionModal=false;
          alert(r.data.message||'Done');
          if(r.data.data&&r.data.data.pending){this.loadPendingActions()}
          else{await this.load(this.animal.id);this.loadPendingActions()}
        }else alert((r.data&&r.data.message)||'Failed')
      }catch(e){console.error(e);alert('Error submitting action')}
      this.processing=false;
    },
    formatMd(text){
      if(!text)return'';
      var s=text.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
      s=s.replace(/^###\s+(.+)$/gm,'<div style="font-weight:700;font-size:12px;color:#BFA164;margin:8px 0 3px;">$1</div>');
      s=s.replace(/^##\s+(.+)$/gm,'<div style="font-weight:700;font-size:13px;color:#BFA164;margin:10px 0 5px;text-transform:uppercase;letter-spacing:0.4px;">$1</div>');
      s=s.replace(/^#\s+(.+)$/gm,'<div style="font-weight:700;font-size:14px;color:#BFA164;margin:10px 0 5px;">$1</div>');
      s=s.replace(/\*\*(.+?)\*\*/g,'<strong style="color:#F5F0E8;">$1</strong>');
      s=s.replace(/(^|[^*])\*([^*\n]+)\*(?!\*)/g,'$1<em>$2</em>');
      s=s.replace(/^\s{3,}[-•]\s+/gm,'&nbsp;&nbsp;&nbsp;<span style="color:#6B6356;">◦</span> ');
      s=s.replace(/^(\d+)\.\s+/gm,'<span style="color:#BFA164;font-weight:600;">$1.</span> ');
      s=s.replace(/^[-•]\s+/gm,'<span style="color:#BFA164;">•</span> ');
      s=s.replace(/`([^`]+)`/g,'<code style="background:rgba(191,161,100,0.12);padding:1px 4px;border-radius:3px;">$1</code>');
      s=s.replace(/\n\n+/g,'<br><br>');
      s=s.replace(/\n/g,'<br>');
      return s;
    },
    onAiVetPhoto(e){
      var file=e.target.files&&e.target.files[0];if(!file)return;
      if(!file.type.startsWith('image/')){alert('Please select an image file');return}
      var self=this;var reader=new FileReader();
      reader.onload=function(ev){
        self.aiVetPhoto={name:file.name,size:file.size,preview:ev.target.result,base64:ev.target.result.split(',')[1],mediaType:file.type};
      };
      reader.readAsDataURL(file);
      e.target.value='';
    },
    toggleVoiceInput(){
      if(this.aiVetRecording){this.stopVoiceInput();return}
      if(!('webkitSpeechRecognition' in window)&&!('SpeechRecognition' in window)){alert('Voice input not supported. Use Chrome.');return}
      var SpeechRecognition=window.SpeechRecognition||window.webkitSpeechRecognition;
      this.aiVetRecognition=new SpeechRecognition();
      this.aiVetRecognition.lang='en-KE';
      this.aiVetRecognition.continuous=true;
      this.aiVetRecognition.interimResults=true;
      var self=this;var finalText='';
      this.aiVetRecognition.onresult=function(event){
        var interim='';
        for(var i=event.resultIndex;i<event.results.length;i++){
          if(event.results[i].isFinal){finalText+=event.results[i][0].transcript+' '}
          else{interim+=event.results[i][0].transcript}
        }
        self.aiVetInput=finalText+interim;
      };
      this.aiVetRecognition.onerror=function(){self.aiVetRecording=false};
      this.aiVetRecognition.onend=function(){self.aiVetRecording=false};
      this.aiVetRecognition.start();
      this.aiVetRecording=true;
    },
    stopVoiceInput(){
      if(this.aiVetRecognition){try{this.aiVetRecognition.stop()}catch(e){}}
      this.aiVetRecording=false;
    },
    closeAiVet(){
      this.showAiVet=false;
      this.aiVetUrgent=false;
      if(this.aiVetRecording)this.stopVoiceInput();
    },
    lastAiVetSummary(){
      for (var i = this.aiVetMessages.length - 1; i >= 0; i--) {
        if (this.aiVetMessages[i].role === 'assistant') return this.aiVetMessages[i].content;
      }
      return '';
    },
    openVetPicker(isUrgent, mode){
      this.vetPickerUrgent = !!isUrgent;
      this.vetPickerMode = mode || 'mine';
      this.showVetPicker = true;
    },
    onVetSent(payload){
      this.showVetPicker = false;
      this.sentToast = { show:true, vetName: payload.vetName || 'the vet', smsSent: !!payload.smsSent, conversationId: payload.conversationId || '' };
      var self = this;
      setTimeout(function(){ self.sentToast.show = false; }, 6000);
    },
    detectAiVetUrgency(text){
      if(!text)return false;
      var lower=text.toLowerCase();
      var phrases=['emergency','immediately','right now','do not wait',"don't wait",'urgent','call a vet now','call the vet now','seek immediate','life-threatening','critical','severe','rapid deterioration','within hours','as soon as possible','go to the vet','take to the vet','call immediately','medical emergency','down cow','recumbent','unable to stand'];
      for(var i=0;i<phrases.length;i++){if(lower.indexOf(phrases[i])>-1)return true}
      return false;
    },
    async sendAiVet(){
      var q=this.aiVetInput.trim();var hasPhoto=!!this.aiVetPhoto;
      if(!q&&!hasPhoto)return;if(this.aiVetLoading)return;
      if(this.aiVetRecording)this.stopVoiceInput();
      var userMsg=q||(hasPhoto?'[Photo attached \u2014 please analyse this image]':'');
      this.aiVetMessages.push({role:'user',content:userMsg,photo:hasPhoto?this.aiVetPhoto.preview:null});
      this.aiVetInput='';this.aiVetLoading=true;
      var photoData=this.aiVetPhoto;this.aiVetPhoto=null;
      this.$nextTick(function(){var el=this.$refs.aiVetChat;if(el)el.scrollTop=el.scrollHeight}.bind(this));
      try{
        var historyForApi=this.aiVetMessages.filter(function(m){return m.role==='user'||m.role==='assistant'}).slice(0,-1).map(function(m){return{role:m.role,content:m.content}});
        var params={
          function:'aiVetAssist',
          farmId:this.animal.farm_id||'',
          animalId:this.animal.id,
          question:userMsg,
          chatHistory:JSON.stringify(historyForApi),
          userId:sessionStorage.getItem('userId')
        };
        if(photoData){params.imageBase64=photoData.base64;params.imageMediaType=photoData.mediaType}
        var r=await executeJson(params,flocker);
        if(r.data&&r.data.success&&r.data.data.response){
          this.aiVetMessages.push({role:'assistant',content:r.data.data.response});
          if(this.detectAiVetUrgency(r.data.data.response)){this.aiVetUrgent=true}
        }else if(r.data&&r.data.data&&r.data.data.code==='limit_reached'){
          var hrs=r.data.data.reset_in_hours||24;
          this.aiVetMessages.push({role:'assistant',content:'⏱ Daily AI Vet limit reached — try again in '+hrs+' hour'+(hrs>1?'s':'')+', or tap "Find a Vet" above to talk to a real vet now.'});
        }else{
          this.aiVetMessages.push({role:'assistant',content:'Sorry: '+(r.data.message||'Please try again.')});
        }
      }catch(e){
        this.aiVetMessages.push({role:'assistant',content:'Connection error. Please try again.'});
      }
      this.aiVetLoading=false;
      this.$nextTick(function(){var el=this.$refs.aiVetChat;if(el)el.scrollTop=el.scrollHeight}.bind(this));
    },
    compressImage(file,maxDim,quality,callback){
      var reader=new FileReader();
      reader.onload=function(e){
        var img=new Image();
        img.onload=function(){
          var w=img.width;var h=img.height;
          if(w>maxDim||h>maxDim){if(w>h){h=Math.round(h*maxDim/w);w=maxDim}else{w=Math.round(w*maxDim/h);h=maxDim}}
          var canvas=document.createElement('canvas');canvas.width=w;canvas.height=h;
          var ctx=canvas.getContext('2d');ctx.drawImage(img,0,0,w,h);
          canvas.toBlob(function(blob){
            if(!blob){callback(file,e.target.result);return}
            if(blob.size>2*1024*1024){
              canvas.toBlob(function(blob2){var fb=blob2||blob;var c=new File([fb],file.name.replace(/\.[^.]+$/,'.jpg'),{type:'image/jpeg'});callback(c,URL.createObjectURL(c))},'image/jpeg',0.6);
            }else{var c=new File([blob],file.name.replace(/\.[^.]+$/,'.jpg'),{type:'image/jpeg'});callback(c,URL.createObjectURL(c))}
          },'image/jpeg',quality);
        };img.src=e.target.result;
      };reader.readAsDataURL(file);
    },
    onPhotoSelect(e){
      var files=e.target.files;if(!files||!files.length)return;
      var self=this;
      var toProcess=Array.from(files).slice(0,6-this.stagedPhotos.length);
      toProcess.forEach(function(file){
        if(!file.type.startsWith('image/'))return;
        self.compressImage(file,1200,0.8,function(compressed,previewUrl){
          self.stagedPhotos.push({file:compressed,preview:previewUrl,size:compressed.size});
        });
      });
      e.target.value='';
    },
    async unlistAnimal(){
      if(!confirm('Remove this animal from the marketplace? The listing will be deactivated.'))return;
      this.processing=true;
      try{
        var r=await executeJson({function:'unlistAnimal',animalId:this.animal.id},flocker);
        if(r.data&&r.data.success){
          alert('Animal unlisted from marketplace');
          await this.load(this.animal.id);
        }else{alert((r.data&&r.data.message)||'Failed')}
      }catch(e){alert('Error')}
      this.processing=false;
    },
    printReport(){
      var a=this.animal;
      var self=this;
      var fNum=function(n){return n?Number(n).toLocaleString('en-KE'):'0'};
      var fDate=function(d){if(!d)return'—';return new Date(d).toLocaleDateString('en-KE',{day:'numeric',month:'short',year:'numeric'})};
      var photoUrl=function(p){if(!p)return'';if(p.startsWith&&p.startsWith('http'))return p;return uploads+String(p).replace('uploads/','')};

      // Build photo for header
      var headerPhoto='';
      if(this.photos.length){headerPhoto='<img src="'+photoUrl(this.photos[0].photo_url)+'" style="width:120px;height:120px;object-fit:cover;border-radius:10px;border:2px solid #BFA164;" />'}

      // Build health records table
      var healthRows='';
      this.healthRecords.forEach(function(h){
        healthRows+='<tr><td>'+fDate(h.record_date)+'</td><td style="text-transform:capitalize;">'+h.record_type+'</td><td><strong>'+h.title+'</strong></td><td>'+(h.diagnosis||'—')+'</td><td>'+(h.treatment||'—')+'</td><td style="text-align:right;">'+(h.cost?'KES '+fNum(h.cost):'—')+'</td></tr>';
      });

      // Build vaccination table
      var vaxRows='';
      this.vaccinations.forEach(function(v){
        vaxRows+='<tr><td>'+fDate(v.administered_date)+'</td><td><strong>'+v.vaccine_name+'</strong></td><td>'+v.disease_target+'</td><td>'+(v.dosage||'—')+'</td><td>'+fDate(v.next_due_date)+'</td><td style="text-align:right;">'+(v.cost?'KES '+fNum(v.cost):'—')+'</td></tr>';
      });

      // Build weight table
      var weightRows='';
      this.weightHistory.forEach(function(w){
        weightRows+='<tr><td>'+fDate(w.recorded_at)+'</td><td style="font-weight:700;">'+w.weight_kg+' kg</td><td>'+(this.weightMethodLabel(w.measurement_method))+'</td><td>'+(w.notes||'—')+'</td></tr>';
      }, this);

      // Build breeding table
      var breedRows='';
      this.breedingRecords.forEach(function(b){
        var method=b.breeding_method==='artificial_insemination'?'AI':b.breeding_method==='embryo_transfer'?'ET':b.breeding_method;
        breedRows+='<tr><td>'+fDate(b.breeding_date)+'</td><td style="text-transform:capitalize;">'+method+'</td><td>'+(b.semen_source||b.sire_name||'—')+'</td><td>'+fDate(b.expected_due_date)+'</td><td style="text-transform:capitalize;">'+(b.outcome||'pending')+'</td><td style="text-align:right;">'+(b.cost?'KES '+fNum(b.cost):'—')+'</td></tr>';
      });

      // Build feeding table
      var feedRows='';
      this.feedingLogs.forEach(function(f){
        feedRows+='<tr><td>'+fDate(f.fed_at)+'</td><td><strong>'+f.feed_type+'</strong></td><td style="font-weight:600;">'+f.quantity_kg+' kg</td><td>'+(f.notes||'—')+'</td><td style="text-align:right;">'+(f.cost?'KES '+fNum(f.cost):'—')+'</td></tr>';
      });

      // Calculate age
      var age='—';
      if(a.date_of_birth){var dob=new Date(a.date_of_birth);var now=new Date();var m=Math.floor((now-dob)/(30.44*86400000));age=m<12?m+' months':Math.floor(m/12)+' yr '+(m%12)+' mo';}
      else if(a.estimated_age_months){age=a.estimated_age_months+' months'}

      var html='<!DOCTYPE html><html><head><title>Animal Report — '+(a.name||a.tag_number||'Unknown')+'</title><style>'
          +'@page{size:A4;margin:15mm 20mm}'
          +'*{margin:0;padding:0;box-sizing:border-box}'
          +'body{font-family:"Segoe UI",Roboto,Helvetica,Arial,sans-serif;font-size:11px;color:#1a1a1a;line-height:1.5;padding:0}'
          +'.header{display:flex;align-items:center;gap:20px;padding-bottom:12px;border-bottom:3px solid #BFA164;margin-bottom:16px}'
          +'.header-info{flex:1}'
          +'.header-info h1{font-size:22px;color:#1a1a1a;margin-bottom:2px}'
          +'.header-info .breed{font-size:14px;color:#666;margin-bottom:6px}'
          +'.meta-row{display:flex;gap:24px;flex-wrap:wrap}'
          +'.meta-item{font-size:11px;color:#444}'
          +'.meta-item strong{color:#1a1a1a}'
          +'.logo-area{text-align:right}'
          +'.logo-area .brand{font-size:18px;font-weight:800;color:#BFA164;letter-spacing:1px}'
          +'.logo-area .sub{font-size:9px;color:#999}'
          +'.section{margin-bottom:14px}'
          +'.section-title{font-size:13px;font-weight:700;color:#BFA164;text-transform:uppercase;letter-spacing:0.5px;padding-bottom:4px;border-bottom:1px solid #e0d5c0;margin-bottom:8px}'
          +'.info-grid{display:grid;grid-template-columns:1fr 1fr;gap:3px 20px}'
          +'.info-row{display:flex;justify-content:space-between;padding:3px 0;border-bottom:1px dotted #e8e8e8}'
          +'.info-row .label{color:#666;font-size:10px}'
          +'.info-row .value{font-weight:600;color:#1a1a1a;font-size:10px}'
          +'.cost-grid{display:grid;grid-template-columns:1fr 1fr 1fr 1fr 1fr 1fr;gap:8px;margin-bottom:14px}'
          +'.cost-box{background:#f9f6f0;border:1px solid #e0d5c0;border-radius:6px;padding:8px;text-align:center}'
          +'.cost-box .amt{font-size:14px;font-weight:700}'
          +'.cost-box .lbl{font-size:9px;color:#888;text-transform:uppercase}'
          +'.cost-box.total{background:#BFA164;color:#fff;border-color:#BFA164}'
          +'.cost-box.total .lbl{color:rgba(255,255,255,.8)}'
          +'table{width:100%;border-collapse:collapse;font-size:10px;margin-bottom:4px}'
          +'th{background:#f5f0e8;color:#666;font-weight:600;text-align:left;padding:5px 6px;border-bottom:2px solid #e0d5c0;font-size:9px;text-transform:uppercase}'
          +'td{padding:4px 6px;border-bottom:1px solid #f0f0f0;vertical-align:top}'
          +'tr:nth-child(even){background:#fafafa}'
          +'.badge{display:inline-block;padding:1px 6px;border-radius:3px;font-size:9px;font-weight:600}'
          +'.badge-healthy{background:#e8f5e9;color:#2e7d32}'
          +'.badge-sick{background:#fce4ec;color:#c62828}'
          +'.badge-pregnant{background:#f3e5f5;color:#7b1fa2}'
          +'.badge-listed{background:#fff8e1;color:#f57f17}'
          +'.footer{margin-top:20px;padding-top:10px;border-top:2px solid #BFA164;display:flex;justify-content:space-between;font-size:9px;color:#999}'
          +'.stamp{border:2px solid #2e7d32;color:#2e7d32;padding:4px 12px;border-radius:4px;font-weight:700;font-size:10px;display:inline-block;transform:rotate(-3deg)}'
          +'.no-data{color:#999;font-style:italic;font-size:10px;padding:8px 0}'
          +'@media print{body{-webkit-print-color-adjust:exact;print-color-adjust:exact}}'
          +'</style></head><body>'

          // HEADER
          +'<div class="header">'
          +headerPhoto
          +'<div class="header-info">'
          +'<h1>'+(a.name||'Unnamed Animal')+(a.tag_number?' &nbsp;<span style="color:#BFA164;font-size:14px;">#'+a.tag_number+'</span>':'')+'</h1>'
          +'<div class="breed">'+(a.species_name||'')+(a.breed_name?' — '+a.breed_name:'')+'</div>'
          +'<div class="meta-row">'
          +'<div class="meta-item">Sex: <strong style="text-transform:capitalize;">'+(a.sex||'—')+'</strong></div>'
          +'<div class="meta-item">Age: <strong>'+age+'</strong></div>'
          +'<div class="meta-item">Weight: <strong>'+(a.weight_kg?a.weight_kg+' kg':'—')+'</strong></div>'
          +'<div class="meta-item">Health: <strong><span class="badge badge-'+(a.health_status||'healthy')+'" style="text-transform:capitalize;">'+(a.health_status||'healthy')+'</span></strong></div>'
          +'<div class="meta-item">Status: <strong><span class="badge badge-'+(a.status||'active')+'" style="text-transform:capitalize;">'+(a.status||'').replace(/_/g,' ')+'</span></strong></div>'
          +'</div></div>'
          +'<div class="logo-area"><div class="brand">FLOCKR</div><div class="sub">Livestock Management Report</div><div style="font-size:9px;color:#aaa;margin-top:4px;">'+new Date().toLocaleDateString('en-KE',{day:'numeric',month:'long',year:'numeric'})+'</div></div>'
          +'</div>'

          // COST SUMMARY
          +'<div class="cost-grid">'
          +'<div class="cost-box"><div class="amt" style="color:#BFA164;">KES '+fNum(a.acquisition_price||0)+'</div><div class="lbl">Acquisition</div></div>'
          +'<div class="cost-box"><div class="amt" style="color:#c62828;">KES '+fNum(self.totalHealthCost)+'</div><div class="lbl">Health/Vet</div></div>'
          +'<div class="cost-box"><div class="amt" style="color:#1565c0;">KES '+fNum(self.totalVaxCost)+'</div><div class="lbl">Vaccination</div></div>'
          +'<div class="cost-box"><div class="amt" style="color:#7b1fa2;">KES '+fNum(self.totalBreedCost)+'</div><div class="lbl">Breeding</div></div>'
          +'<div class="cost-box"><div class="amt" style="color:#e65100;">KES '+fNum(self.totalFeedCost)+'</div><div class="lbl">Feeding</div></div>'
          +'<div class="cost-box total"><div class="amt">KES '+fNum(self.totalInvestment)+'</div><div class="lbl">Total Investment</div></div>'
          +'</div>'

          // ANIMAL INFO
          +'<div class="section"><div class="section-title">Animal Information</div><div class="info-grid">'
          +'<div class="info-row"><span class="label">Farm</span><span class="value">'+(a.farm_name||'—')+'</span></div>'
          +'<div class="info-row"><span class="label">Owner</span><span class="value">'+(a.owner_name||'—')+'</span></div>'
          +'<div class="info-row"><span class="label">Species</span><span class="value">'+(a.species_name||'—')+'</span></div>'
          +'<div class="info-row"><span class="label">Breed</span><span class="value">'+(a.breed_name||'—')+'</span></div>'
          +'<div class="info-row"><span class="label">Date of Birth</span><span class="value">'+fDate(a.date_of_birth)+'</span></div>'
          +'<div class="info-row"><span class="label">Source</span><span class="value" style="text-transform:capitalize;">'+(a.acquisition_type||'').replace(/_/g,' ')+'</span></div>'
          +'<div class="info-row"><span class="label">Reproductive</span><span class="value" style="text-transform:capitalize;">'+(a.reproductive_status||'—').replace(/_/g,' ')+'</span></div>'
          +'<div class="info-row"><span class="label">Due Date</span><span class="value">'+fDate(a.pregnancy_due_date)+'</span></div>'
          +(a.dam?'<div class="info-row"><span class="label">Dam</span><span class="value">'+a.dam.name+(a.dam.tag_number?' (#'+a.dam.tag_number+')':'')+'</span></div>':'')
          +(a.sire?'<div class="info-row"><span class="label">Sire</span><span class="value">'+a.sire.name+(a.sire.tag_number?' (#'+a.sire.tag_number+')':'')+'</span></div>':'')
          +(a.pedigree_number?'<div class="info-row"><span class="label">Pedigree #</span><span class="value">'+a.pedigree_number+'</span></div>':'')
          +(a.microchip_number?'<div class="info-row"><span class="label">Microchip #</span><span class="value">'+a.microchip_number+'</span></div>':'')
          +(a.notes?'<div class="info-row" style="grid-column:1/-1"><span class="label">Notes</span><span class="value">'+a.notes+'</span></div>':'')
          +'</div></div>'

          // HEALTH RECORDS
          +(self.reportSections.health?
              '<div class="section"><div class="section-title">Health Records ('+this.healthRecords.length+')</div>'
              +(healthRows?'<table><thead><tr><th>Date</th><th>Type</th><th>Title</th><th>Diagnosis</th><th>Treatment</th><th style="text-align:right;">Cost</th></tr></thead><tbody>'+healthRows+'</tbody></table>':'<div class="no-data">No health records</div>')
              +'</div>':'')

          // VACCINATIONS
          +(self.reportSections.vaccinations?
              '<div class="section"><div class="section-title">Vaccination Records ('+this.vaccinations.length+')</div>'
              +(vaxRows?'<table><thead><tr><th>Date</th><th>Vaccine</th><th>Disease</th><th>Dosage</th><th>Next Due</th><th style="text-align:right;">Cost</th></tr></thead><tbody>'+vaxRows+'</tbody></table>':'<div class="no-data">No vaccination records</div>')
              +'</div>':'')

          // WEIGHT HISTORY
          +(self.reportSections.weight?
              '<div class="section"><div class="section-title">Weight History ('+this.weightHistory.length+')</div>'
              +(weightRows?'<table><thead><tr><th>Date</th><th>Weight</th><th>Method</th><th>Notes</th></tr></thead><tbody>'+weightRows+'</tbody></table>':'<div class="no-data">No weight records</div>')
              +'</div>':'')

          // BREEDING RECORDS
          +(self.reportSections.breeding?
              '<div class="section"><div class="section-title">Breeding Records ('+this.breedingRecords.length+')</div>'
              +(breedRows?'<table><thead><tr><th>Date</th><th>Method</th><th>Source/Sire</th><th>Due Date</th><th>Outcome</th><th style="text-align:right;">Cost</th></tr></thead><tbody>'+breedRows+'</tbody></table>':'<div class="no-data">No breeding records</div>')
              +'</div>':'')

          // FEEDING RECORDS
          +(self.reportSections.feeding?
              '<div class="section"><div class="section-title">Feeding Log ('+this.feedingLogs.length+')</div>'
              +(feedRows?'<table><thead><tr><th>Date</th><th>Feed Type</th><th>Quantity</th><th>Notes</th><th style="text-align:right;">Cost</th></tr></thead><tbody>'+feedRows+'</tbody></table>':'<div class="no-data">No feeding records</div>')
              +'</div>':'')

          // PHOTOS
          +(self.reportSections.photos && self.photos.length?
              '<div class="section"><div class="section-title">Photos ('+self.photos.length+')</div>'
              +'<div style="display:flex;flex-wrap:wrap;gap:8px;">'+self.photos.map(function(p){return'<img src="'+photoUrl(p.photo_url)+'" style="width:120px;height:120px;object-fit:cover;border-radius:6px;border:1px solid #e0d5c0;" />'}).join('')+'</div></div>':'')

          // FOOTER
          +'<div class="footer">'
          +'<div><span class="stamp">VERIFIED FARM RECORDS</span></div>'
          +'<div style="text-align:right;">Generated by Flockr Farm Management<br/>Report ID: '+a.id.substring(0,8).toUpperCase()+' &bull; '+new Date().toLocaleString('en-KE')+'</div>'
          +'</div>'

          +'</body></html>';

      var w=window.open('','_blank','width=900,height=700');
      w.document.write(html);
      w.document.close();
      setTimeout(function(){w.print()},600);
    },
    async uploadStagedPhotos(){
      if(!this.stagedPhotos.length)return;
      this.uploadingPhotos=true;
      for(var i=0;i<this.stagedPhotos.length;i++){
        try{
          var f=new FormData();
          f.append('function','addAnimalPhoto');
          f.append('animalId',this.animal.id);
          f.append('photo',this.stagedPhotos[i].file);
          if(this.photos.length===0&&i===0)f.append('isPrimary','1');
          await execute(f,flocker);
        }catch(err){console.error('Photo upload error',err)}
      }
      this.stagedPhotos=[];
      await this.load(this.animal.id);
      this.uploadingPhotos=false;
    },
    async onProfilePhotoChange(e){
      var file=e.target.files&&e.target.files[0];if(!file)return;
      this.uploadingPhotos=true;
      var self=this;
      this.compressImage(file,1200,0.8,async function(compressed){
        try{
          var f=new FormData();
          f.append('function','addAnimalPhoto');
          f.append('animalId',self.animal.id);
          f.append('photo',compressed);
          f.append('isPrimary','1');
          await execute(f,flocker);
          await self.load(self.animal.id);
        }catch(err){console.error('Profile photo error',err)}
        self.uploadingPhotos=false;
      });
      e.target.value='';
    },
    async setPrimaryPhoto(photo){
      try{
        var r=await executeJson({function:'setAnimalPrimaryPhoto',animalId:this.animal.id,photoId:photo.id},flocker);
        if(r.data.success)await this.load(this.animal.id);
        else alert(r.data.message||'Failed');
      }catch(e){alert('Error')}
    },
    openDeletePhoto(photo){this.deletePhotoTarget=photo;this.showDeletePhotoModal=true},
    closeDeletePhoto(){if(this.processing)return;this.showDeletePhotoModal=false;this.deletePhotoTarget=null},
    async deletePhoto(photo){ this.openDeletePhoto(photo); },
    async confirmDeletePhoto(){
      if(!this.deletePhotoTarget)return;
      this.processing=true;
      try{
        var r=await executeJson({function:'deleteAnimalPhoto',photoId:this.deletePhotoTarget.id,animalId:this.animal.id},flocker);
        if(r.data.success){this.showDeletePhotoModal=false;this.deletePhotoTarget=null;await this.load(this.animal.id)}
        else alert(r.data.message||'Failed');
      }catch(e){alert('Error')}
      this.processing=false;
    },
    fNum(n){return n?Number(n).toLocaleString('en-KE'):'0'},
    fDate(d){if(!d)return'—';return new Date(d).toLocaleDateString('en-KE',{day:'numeric',month:'short',year:'numeric'})},
    isDueSoon(d){if(!d)return false;return new Date(d)<new Date(Date.now()+7*86400000)}
  }
};
</script>